webpackJsonp([0],{

/***/ "+H76":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("i3pt")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("yRx6"),
  /* template */
  __webpack_require__("M5Z/"),
  /* scopeId */
  "data-v-491686f8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "+Mdo":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "min-width": "900px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "26px",
      "display": "inline-block",
      "cursor": "pointer"
    }
  }, [_vm._v("官网新闻")]), _vm._v(" "), _c('div', {
    staticClass: "formStyle"
  }, [_c('p', {
    staticClass: "formTitle"
  }, [_vm._v("新闻信息")]), _vm._v(" "), _c('Form', {
    staticStyle: {
      "padding": "20px"
    },
    attrs: {
      "model": _vm.formItem,
      "label-width": 100
    }
  }, [_c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("封面图")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "150px",
      "height": "150px"
    },
    attrs: {
      "src": _vm.formItem.titleImgUrl
    }
  })])], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("主标题")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.mainTitle),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "mainTitle", $$v)
      },
      expression: "formItem.mainTitle"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("来源")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.source),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "source", $$v)
      },
      expression: "formItem.source"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("新闻类别")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formItem.newsCategory),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "newsCategory", $$v)
      },
      expression: "formItem.newsCategory"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1",
      "disabled": ""
    }
  }, [_vm._v("公司新闻")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2",
      "disabled": ""
    }
  }, [_vm._v("行业动态")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3",
      "disabled": ""
    }
  }, [_vm._v("媒体报导")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("发布时间")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.time),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "time", $$v)
      },
      expression: "formItem.time"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("简介")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.summary),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "summary", $$v)
      },
      expression: "formItem.summary"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("详细内容")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "readonly": "",
      "autosize": {
        minRows: 4,
        maxRows: 8
      },
      "placeholder": "请输入详细内容..."
    },
    model: {
      value: (_vm.formItem.content),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "content", $$v)
      },
      expression: "formItem.content"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.editNewsInfo(_vm.formItem.id)
      }
    }
  }, [_vm._v("编辑新闻")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ "+f2D":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    class: _vm.wrapClasses
  }, [_c('span', {
    class: _vm.checkboxClasses
  }, [_c('span', {
    class: _vm.innerClasses
  }), _vm._v(" "), (_vm.group) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model),
      expression: "model"
    }],
    class: _vm.inputClasses,
    attrs: {
      "type": "checkbox",
      "disabled": _vm.disabled,
      "name": _vm.name
    },
    domProps: {
      "value": _vm.label,
      "checked": Array.isArray(_vm.model) ? _vm._i(_vm.model, _vm.label) > -1 : (_vm.model)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.model,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.label,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.model = $$c
        }
      }, _vm.change],
      "focus": _vm.onFocus,
      "blur": _vm.onBlur
    }
  }) : _c('input', {
    class: _vm.inputClasses,
    attrs: {
      "type": "checkbox",
      "disabled": _vm.disabled,
      "name": _vm.name
    },
    domProps: {
      "checked": _vm.currentValue
    },
    on: {
      "change": _vm.change,
      "focus": _vm.onFocus,
      "blur": _vm.onBlur
    }
  })]), _vm._v(" "), _vm._t("default", function() {
    return [(_vm.showSlot) ? _c('span', [_vm._v(_vm._s(_vm.label))]) : _vm._e()]
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ "+kMF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__("oFuF");

var _util2 = _interopRequireDefault(_util);

var _format = __webpack_require__("4/BI");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "volunteerUsers",
  data: function data() {
    var _this = this;

    return {
      showEdit: false, //是否是可编辑状态
      nickNameSearch: "", //搜索框中的内容
      nickNameSearchBlack: "", //黑名单搜索框
      volunteers: [], //志愿者信息数组
      totalUser: "全部用户",
      askNum: "提问数量",
      checkedVolunteers: [], //已经选中的志愿者数组
      checkedDragVolunteers: [], //需要拖出黑名单的志愿者数组
      blackList: [], //黑名单用户
      columnsMain: [{
        type: 'selection',
        width: 40,
        align: 'center',
        title: '全部'
      }, {
        title: "头像",
        align: "center",
        render: function render(h, params) {
          return h('img', {
            attrs: {
              src: params.row.avatarUrl
            },
            style: {
              width: "48px",
              height: "48px",
              margin: "5px",
              marginBottom: "0",
              borderRadius: "3px"
            }
          });
        }
      }, {
        title: "昵称",
        align: "center",
        key: "nickname"
      }, {
        title: "状态",
        key: "version",
        align: "center"
      }, {
        title: "性别",
        align: "center",
        key: 'sex',
        render: function render(h, params) {
          return h("div", (0, _format.formatSex)(params.row.sex));
        }
      }, {
        title: "省份",
        key: "province",
        align: "center"
      }, {
        title: "城市",
        key: "city",
        align: "center"
      }, {
        title: "备注",
        key: "remarks",
        align: "center",
        width: 110,
        render: function render(h, params) {
          if (params.row.$isEdit) {
            return h('input', {
              domProps: {
                value: params.row.remarks
              },
              style: {
                border: "none",
                width: "80px",
                lineHeight: "20px",
                textAlign: "center"
              },
              on: {
                input: function input(event) {
                  params.row.remarks = event.target.value;
                }
              }
            });
          } else {
            return h('div', params.row.remarks);
          }
        }
      }, {
        title: "编辑 / 保存",
        align: "center",
        width: 150,
        render: function render(h, params) {
          return h('Button', {
            props: {
              icon: "paintbrush",
              type: "primary"
            },
            style: {
              padding: "3px 8px",
              borderRadius: "20px",
              fontSize: "16px"
            },
            on: {
              click: function click(event) {
                if (params.row.$isEdit) {
                  _this.handleSave(params.row);
                } else {
                  _this.handleEdit(params.row);
                }
              }
            }
          }, params.row.$isEdit ? "保存" : "编辑");
        }
        //       on:{
        //         click:() => { //返回编辑的信息
        //           this.$http.post('/zm/backManage/updateVolunteerDescr?id='+params.row.id+'&remarks='+params.row.remarks);
        //           this.showEdit = false;
        //         }
        //       }
        //     }, "保存");
        //   }
        // }
      }, {
        title: "详情",
        align: "center",
        render: function render(h, params) {
          return h('Button', {
            props: {
              type: "info"
            },
            on: {
              click: function click() {
                _this.functionA();
                _this.$router.push({
                  path: '/volunteerDetail',
                  query: {
                    id: _this.volunteers[params.index].id
                  }
                });
              }
            }
          }, "详情");
        }
      }],
      dataCount: 0, //初始化信息总条数
      pageSize: 20, //每页条数
      dataCountBlack: 0, //黑名单：初始化信息总条数
      pageSizeBlack: 20, //黑名单：每页条数
      tableLoading: false, //表格是否加载
      dataSearch: { //请求的数据
        "code": 0,
        "content": {},
        "currPage": 1,
        "pageSize": 20,
        "pageTotal": 0
      },
      dataSearchBlack: { //黑名单请求的数据
        "code": 0,
        "content": { "status": 0 },
        "currPage": 1,
        "pageSize": 20,
        "pageTotal": 0
      }
    };
  },

  methods: {
    functionA: function functionA() {
      //调用menu-list的函数用于切换页面
      _util2.default.$emit('demo', 'volunteerDetail');
    },
    handleEdit: function handleEdit(row) {
      this.$set(row, '$isEdit', true);
    },
    //编辑->修改
    handleSave: function handleSave(row) {
      var _this2 = this;

      this.$set(row, '$isEdit', false);
      this.$http.post('/zm/backManage/updateVolunteerDescr?id=' + row.id + '&remarks=' + row.remarks).then(function (res) {
        _this2.$Message.success("保存成功！");
      }, function (err) {
        _this2.$Message.error("保存失败" + err.message);
      });
    },
    //保存修改
    searchName: function searchName() {
      this.dataSearch.content = {
        "nickname": this.nickNameSearch
      };
      this.getVolunterrList();
    },
    //点击搜索框进行对昵称的搜索
    searchNameBlack: function searchNameBlack() {
      this.dataSearchBlack.content = {
        "nickname": this.nickNameSearchBlack,
        "status": 0
      };
      this.getBlackVolunteerList();
    },
    //黑名单，搜索昵称
    handleSelectRow: function handleSelectRow() {
      this.checkedVolunteers = this.$refs.selection.getSelection();
    },
    //获取已经选中的项目
    handleSelectBlackRow: function handleSelectBlackRow() {
      this.checkedDragVolunteers = this.$refs.select.getSelection();
    },
    //黑名单：获取已经选中的项目
    putBlack: function putBlack() {
      this.blackList = this.checkedVolunteers;
      var item = void 0;
      var flag = true;
      var msg = void 0;
      for (item in this.checkedVolunteers) {
        this.$http.post('/zm/backManage/addVolunteerBacklist?id=' + this.checkedVolunteers[item].id).then(function (res) {}, function (err) {
          flag = false;
          msg = err.data.content;
        });
      }
      if (flag) {
        this.$Message.success("加入黑名单成功!");
      } else {
        this.$Message.error(msg);
      }
      this.getBlackVolunteerList();
    },
    //加入黑名单
    dragBlack: function dragBlack() {
      var item = void 0;
      var flag = true;
      var msg = void 0;
      for (item in this.checkedVolunteers) {
        this.$http.post('/zm/backManage/deleteVolunteerBacklist?id=' + this.checkedVolunteers[item].id).then(function (res) {}, function (err) {
          flag = false;
          msg = err.data.content;
        });
      }
      if (flag) {
        this.$Message.success("解除黑名单成功!");
      } else {
        this.$Message.error(msg);
      }
      this.getBlackVolunteerList();
    },
    //拖出黑名单
    changePage: function changePage(index) {
      this.dataSearch.currPage = index;
      this.getVolunterrList();
    },
    //改变志愿者列表页数
    changePageBlack: function changePageBlack(index) {
      this.dataSearchBlack.currPage = index;
      this.getBlackVolunteerList();
    },
    //改变黑名单列表页数
    getVolunterrList: function getVolunterrList() {
      var _this3 = this;

      this.tableLoading = true;
      this.$http.post('/zm/backManage/queryVolunteerInfoByPage', this.dataSearch).then(function (res) {
        _this3.dataCount = res.data.pageTotal;
        _this3.pageSize = res.data.pageSize;
        _this3.volunteers = res.data.content;
        _this3.tableLoading = false;
      }, function (err) {
        _this3.$Message.error("请求失败：" + err.message);
        _this3.tableLoading = false;
      });
    },
    //获得志愿者列表
    getBlackVolunteerList: function getBlackVolunteerList() {
      var _this4 = this;

      this.tableLoading = true;
      this.$http.post('/zm/backManage/queryVolunteerInfoByPage', this.dataSearchBlack).then(function (res) {
        _this4.dataCountBlack = res.data.pageTotal;
        _this4.pageSizeBlack = res.data.pageSize;
        _this4.blackList = res.data.content;
        _this4.tableLoading = false;
      }, function (err) {
        _this4.$Message.error("请求失败：" + err.message);
        _this4.tableLoading = false;
      });
    } //获得志愿者黑名单列表

  },
  created: function created() {
    this.getVolunterrList();
    this.getBlackVolunteerList();
  }
};

/***/ }),

/***/ "+skl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/S6c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//

exports.default = {
    name: "totalCount"
};

/***/ }),

/***/ "/xek":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0mYp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bg_03.adeeade.jpg";

/***/ }),

/***/ "0xDb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* 工具类库 */
exports.default = {
  /* 设置cookie */
  setCookie: function setCookie(name, value, expires) {
    var exdate = new Date();
    //设置过期时间以小时为单位
    exdate.setTime(exdate.getTime() + expires * 60 * 60 * 1000); //(expires * 60 * 60 * 1000)
    document.cookie = name + "=" + escape(value) + (expires == null ? "" : ";expires=" + exdate.toGMTString());
  },

  /* 获取cookie */
  getCookie: function getCookie(name) {
    var start, end;
    if (document.cookie.length > 0) {
      start = document.cookie.indexOf(name + "=");
      if (start !== -1) {
        start = start + name.length + 1;
        end = document.cookie.indexOf(";", start);
        if (end === -1) end = document.cookie.length;
        return unescape(document.cookie.substring(start, end));
      }
    }
    return null;
  },

  /* 删除cookie */
  delCookie: function delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = this.getCookie(name);
    if (cval != null) {
      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    }
  },
  formatDate: function formatDate(date, fmt) {
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    }
    var o = {
      'M+': date.getMonth() + 1,
      'd+': date.getDate(),
      'h+': date.getHours(),
      'm+': date.getMinutes(),
      's+': date.getSeconds()
    };
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
        var str = o[k] + '';
        fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? str : ("00" + o[k]).substr(("" + o[k]).length));
      }
    }
    return fmt;
  }
};

/***/ }),

/***/ "1S7i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1eOD":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', {
    class: _vm.classes,
    style: (_vm.styles),
    on: {
      "click": _vm.handleClick
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ "1u2F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2wic":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("Wo8S")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("+kMF"),
  /* template */
  __webpack_require__("8mk/"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "3vwo":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("oGzK")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("8UII"),
  /* template */
  __webpack_require__("nj25"),
  /* scopeId */
  "data-v-73bdcaf7",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "4/BI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDate = formatDate;
exports.format = format;
exports.format2Sec = format2Sec;
exports.formatSex = formatSex;
exports.formatStatus = formatStatus;
exports.formatAskWay = formatAskWay;
function formatDate(date, fmt) {
  var o = {
    'M+': date.getMonth() + 1, // 月份
    'd+': date.getDate(), // 日
    'h+': date.getHours(), // 小时
    'm+': date.getMinutes(), // 分
    's+': date.getSeconds(), // 秒
    'S': date.getMilliseconds() // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
  }
  return fmt;
}

function format(time) {
  time = JSON.parse(time);
  var date = new Date(time);
  return formatDate(date, 'yyyy-MM-dd hh:mm');
}

function format2Sec(time) {
  var date = new Date(time);
  return formatDate(date, 'yyyy-MM-dd hh:mm:ss');
}

function formatSex(sex) {
  //具体化性别
  if (sex === 0) {
    return "未知";
  } else if (sex === 1) {
    return "男";
  } else {
    return "女";
  }
}

function formatStatus(status) {
  //具体化状态
  if (status === 0) {
    return "禁用";
  } else {
    return "启用";
  }
}

function formatAskWay(askWay) {
  //具体化求助方式
  switch (askWay) {
    case 1:
      return "图片 + 文字";
    case 2:
      return "图片 + 语音";
    case 3:
      return "短视频";
    case 4:
      return "实时视频";
  }
}

/***/ }),

/***/ "49Wm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "messageTip",
  props: {
    value: {
      type: Number,
      default: 0
    }
  }
};

/***/ }),

/***/ "4ADN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4piF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.adminRouter = undefined;

var _Admin = __webpack_require__("nKAD");

var _Admin2 = _interopRequireDefault(_Admin);

var _adminHome = __webpack_require__("WMMa");

var _adminHome2 = _interopRequireDefault(_adminHome);

var _adminNotice = __webpack_require__("3vwo");

var _adminNotice2 = _interopRequireDefault(_adminNotice);

var _weChatMaterial = __webpack_require__("wkzM");

var _weChatMaterial2 = _interopRequireDefault(_weChatMaterial);

var _newsManager = __webpack_require__("ZJNI");

var _newsManager2 = _interopRequireDefault(_newsManager);

var _otherMaterial = __webpack_require__("GIKy");

var _otherMaterial2 = _interopRequireDefault(_otherMaterial);

var _templateMessage = __webpack_require__("E9G3");

var _templateMessage2 = _interopRequireDefault(_templateMessage);

var _helpMessage = __webpack_require__("payt");

var _helpMessage2 = _interopRequireDefault(_helpMessage);

var _usersMessage = __webpack_require__("dgke");

var _usersMessage2 = _interopRequireDefault(_usersMessage);

var _weChatMessage = __webpack_require__("zCSa");

var _weChatMessage2 = _interopRequireDefault(_weChatMessage);

var _blindUsers = __webpack_require__("XcRv");

var _blindUsers2 = _interopRequireDefault(_blindUsers);

var _volunteerUsers = __webpack_require__("2wic");

var _volunteerUsers2 = _interopRequireDefault(_volunteerUsers);

var _totalCount = __webpack_require__("5Sj+");

var _totalCount2 = _interopRequireDefault(_totalCount);

var _appCount = __webpack_require__("BNlP");

var _appCount2 = _interopRequireDefault(_appCount);

var _volunteerCount = __webpack_require__("DKwD");

var _volunteerCount2 = _interopRequireDefault(_volunteerCount);

var _blindDetail = __webpack_require__("G+oQ");

var _blindDetail2 = _interopRequireDefault(_blindDetail);

var _volunteerDetail = __webpack_require__("BaUe");

var _volunteerDetail2 = _interopRequireDefault(_volunteerDetail);

var _helpMessageDetail = __webpack_require__("HhrG");

var _helpMessageDetail2 = _interopRequireDefault(_helpMessageDetail);

var _publicSetting = __webpack_require__("C3q7");

var _publicSetting2 = _interopRequireDefault(_publicSetting);

var _productManager = __webpack_require__("hsz7");

var _productManager2 = _interopRequireDefault(_productManager);

var _webAPP = __webpack_require__("V6nq");

var _webAPP2 = _interopRequireDefault(_webAPP);

var _webAppDetail = __webpack_require__("zoD6");

var _webAppDetail2 = _interopRequireDefault(_webAppDetail);

var _editWebAppDetail = __webpack_require__("mULj");

var _editWebAppDetail2 = _interopRequireDefault(_editWebAppDetail);

var _editNewsInfo = __webpack_require__("nX10");

var _editNewsInfo2 = _interopRequireDefault(_editNewsInfo);

var _newsInfo = __webpack_require__("8XXS");

var _newsInfo2 = _interopRequireDefault(_newsInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var adminRouter = exports.adminRouter = [{
  path: "/admin",
  title: "",
  meta: { requiresAuth: true },
  component: _Admin2.default,
  children: [{
    path: "",
    name: "admin",
    component: _adminHome2.default
  }, {
    path: "/notice",
    name: "notice",
    title: "通知",
    component: _adminNotice2.default
  }]
}, {
  path: "/material",
  name: "material",
  title: "素材管理",
  meta: { requiresAuth: true },
  component: _Admin2.default,
  children: [{
    path: "/weChatMaterial",
    name: "weChatMaterial",
    title: "微信文章",
    component: _weChatMaterial2.default
  }, {
    path: "/productManager",
    name: "productManager",
    title: "官网产品",
    component: _productManager2.default
  }, {
    path: "/newsManager",
    name: "newsManager",
    title: "官网新闻",
    component: _newsManager2.default
  }, {
    path: "/editNewsInfo",
    name: "editNewsInfo",
    title: "编辑官网新闻",
    component: _editNewsInfo2.default
  }, {
    path: "/newsInfo",
    name: "newsInfo",
    title: "新闻详情",
    component: _newsInfo2.default
  }, {
    path: "/otherMaterial",
    name: "otherMaterial",
    title: "其他",
    component: _otherMaterial2.default
  }]
}, {
  path: "/appManager",
  name: "appManager",
  title: "APP管理",
  meta: { requiresAuth: true },
  component: _Admin2.default,
  children: [{
    path: "/webAPP",
    name: "webAPP",
    title: "官网展示",
    component: _webAPP2.default
  }, {
    path: "/webAppDetail",
    name: "webAppDetail",
    title: "APP详情",
    component: _webAppDetail2.default
  }, {
    path: "/editWebAppDetail",
    name: "editWebAppDetail",
    title: "编辑APP详情",
    component: _editWebAppDetail2.default
  }]
}, {
  path: "/messageManage",
  name: "messageManage",
  title: "消息管理",
  meta: { requiresAuth: true },
  component: _Admin2.default,
  children: [{
    path: "/templateMessage",
    name: "templateMessage",
    title: "模板消息推送",
    component: _templateMessage2.default
  }, {
    path: "/helpMessage",
    name: "helpMessage",
    title: "盲人求助消息",
    component: _helpMessage2.default
  }, {
    path: "/helpMessageDetail",
    name: "helpMessageDetail",
    title: "求助消息详情",
    component: _helpMessageDetail2.default
  }, {
    path: "/usersMessage",
    name: "usersMessage",
    title: "用户反馈消息",
    component: _usersMessage2.default
  }, {
    path: "/weChatMessage",
    name: "weChatMessage",
    title: "微信公共账号消息",
    component: _weChatMessage2.default
  }]
}, {
  path: "/usersManage",
  name: "usersManage",
  title: "用户管理",
  meta: { requiresAuth: true },
  component: _Admin2.default,
  children: [{
    path: "/blindUsers",
    name: "blindUsers",
    title: "盲人用户",
    component: _blindUsers2.default
  }, {
    path: "/blindDetail",
    name: "blindDetail",
    title: "盲人用户详情",
    component: _blindDetail2.default
  }, {
    path: "/volunteerUsers",
    name: "volunteerUsers",
    title: "志愿者用户",
    component: _volunteerUsers2.default
  }, {
    path: "/volunteerDetail",
    name: "volunteerDetail",
    title: "志愿者用户详情",
    component: _volunteerDetail2.default
  }]
}, {
  path: "/count",
  name: "count",
  title: "统计",
  meta: { requiresAuth: true },
  component: _Admin2.default,
  children: [{
    path: "/totalCount",
    name: "totalCount",
    title: "总体数据",
    component: _totalCount2.default
  }, {
    path: "/appCount",
    name: "appCount",
    title: "APP数据",
    component: _appCount2.default
  }, {
    path: "/volunteerCount",
    name: "volunteerCount",
    title: "志愿者数据",
    component: _volunteerCount2.default
  }]
}, {
  path: "/setup",
  name: "setup",
  title: "设置",
  meta: { requiresAuth: true },
  component: _Admin2.default,
  children: [{
    path: "/publicSetting",
    name: "publicSetting",
    title: "公众号设置",
    component: _publicSetting2.default
  }]
}];

/***/ }),

/***/ "56XX":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("oRfq"),
  /* template */
  __webpack_require__("+f2D"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "5QFy":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("1S7i")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("RTzJ"),
  /* template */
  __webpack_require__("ZW+m"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "5Sj+":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("oCbg")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("/S6c"),
  /* template */
  __webpack_require__("LRNV"),
  /* scopeId */
  "data-v-0954ad8c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "5XZ0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5enB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5gie":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "62+D":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("7dGL")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("osGv"),
  /* template */
  __webpack_require__("tmQQ"),
  /* scopeId */
  "data-v-7f2beb48",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "6xkd":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "min-width": "900px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "26px",
      "display": "inline-block",
      "cursor": "pointer"
    }
  }, [_vm._v("微信公众账号消息")])])
}]}

/***/ }),

/***/ "7M94":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _format = __webpack_require__("4/BI");

var _admin = __webpack_require__("4piF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "helpMessageDetail",
  data: function data() {
    return {
      helpInfo: {}, //返回来的信息
      offerHelpInfos: [], //志愿者回复
      nickName: "", //盲人基本信息昵称
      quesPic: "/static/avatar.jpg",
      picModal: false, //图片放大弹框
      percentNum: 50, //求助进度
      quickItem: "", //提交的内容
      successBtn: false, //控制按钮变色的变量
      quickItem1: "描述模糊，请尝试重新叙述问题",
      quickItem2: "图片模糊，请尝试重新拍照后提问",
      quickItem3: "视频模糊，请尝试重新拍摄后提问",
      quickItem4: "信息过多，指向不明确，请尝试重新叙述问题",
      replyText: "", //客服回复内容
      grade: [{
        one: 12,
        two: 3,
        three: 48
      }, {
        one: 12,
        two: 3,
        three: 48
      }, {
        one: 12,
        two: 3,
        three: 48
      }]
    };
  },
  activated: function activated() {
    this.helpInfo = this.$route.params.helpInfo;
    this.offerHelpInfos = this.$route.params.offerHelpInfos;
  },
  mounted: function mounted() {},

  watch: {
    helpInfo: function helpInfo(res) {
      this.helpInfo.createTime = (0, _format.format)(res.createTime);
    }
  },
  methods: {
    getHelpDetail: function getHelpDetail() {},
    returnPage: function returnPage() {
      /*返回到求助消息管理*/
      this.$router.go(-1);
    },

    /**
     * 查看历史求助
     */
    goHistory: function goHistory() {
      var active = "blindDetail";
      if (this.currentTag !== active) {
        var tags = null;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(_admin.adminRouter), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var ele = _step.value;

            if (ele.name === active) {
              tags = {
                title: ele.title,
                name: ele.name,
                path: ele.path
              };
              break;
            } else {
              if (ele.children.length) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                  for (var _iterator2 = (0, _getIterator3.default)(ele.children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var val = _step2.value;

                    if (val.name === active) {
                      tags = {
                        title: val.title,
                        name: val.name,
                        path: val.path
                      };
                      break;
                    }
                  }
                } catch (err) {
                  _didIteratorError2 = true;
                  _iteratorError2 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                      _iterator2.return();
                    }
                  } finally {
                    if (_didIteratorError2) {
                      throw _iteratorError2;
                    }
                  }
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        localStorage.setItem("currentTag", active);
        this.$store.commit("updateCurrentTag", active);
        this.$store.commit("updateOpenedTags", [tags]);
        this.$store.commit("updateCurrentPath", active);
        this.$router.push({
          name: "blindDetail",
          query: { "id": this.helpInfo.id }
        });
      }
    },

    /**
     * 处理时间格式
     */
    format: _format.format,
    diffTime: function diffTime(diff) {
      //计算差值
      var d = Math.floor(diff / 1000 / 60 / 60 / 24);
      var h = Math.floor((diff - d * 24 * 60 * 60 * 1000) / 1000 / 60 / 60);
      var m = Math.floor((diff - d * 24 * 60 * 60 * 1000 - h * 60 * 60 * 1000) / 1000 / 60);
      d = d > 0 ? d + "天" : "";
      h = h > 0 ? h + "小时" : "";
      m = m > 0 ? m + "分钟" : "";
      return d + h + m;
    },
    downloadIamge: function downloadIamge(imgsrc, name) {
      //下载图片地址和图片名
      var image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = function () {
        var canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        var context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

        var a = document.createElement("a"); // 生成一个a元素
        var event = new MouseEvent("click"); // 创建一个单击事件
        a.download = name || "photo"; // 设置图片名称
        a.href = url; // 将生成的URL设置为a.href属性
        a.dispatchEvent(event); // 触发a的单击事件
      };
      image.src = imgsrc;
    },
    downPic: function downPic() {
      this.downloadIamge(this.helpInfo.imageUrl, "pic");
    },

    // showBig() {
    //   // this.$Modal.confirm({
    //   //   render: (h) => {}
    //   // })
    // },
    chooseItem: function chooseItem(i) {
      switch (i) {
        case 1:
          this.replyText = this.quickItem1;break;
        case 2:
          this.replyText = this.quickItem2;break;
        case 3:
          this.replyText = this.quickItem3;break;
        case 4:
          this.replyText = this.quickItem4;break;
      }
    },
    successSubmit: function successSubmit() {
      this.successBtn = true;
      this.percentNum = 75;
      // TODO  post thequickItem
    }
  }
};

/***/ }),

/***/ "7ZpJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _icon = __webpack_require__("LW0X");

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//

var prefixCls = 'ivu-card';
var defaultPadding = 16;
exports.default = {
    name: 'Card',
    components: { Icon: _icon2.default },
    props: {
        bordered: {
            type: Boolean,
            default: true
        },
        disHover: {
            type: Boolean,
            default: false
        },
        shadow: {
            type: Boolean,
            default: false
        },
        padding: {
            type: Number,
            default: defaultPadding
        },
        title: {
            type: String
        },
        icon: {
            type: String
        }
    },
    data: function data() {
        return {
            showHead: true,
            showExtra: true
        };
    },

    computed: {
        classes: function classes() {
            var _ref;

            return ['' + prefixCls, (_ref = {}, (0, _defineProperty3.default)(_ref, prefixCls + '-bordered', this.bordered && !this.shadow), (0, _defineProperty3.default)(_ref, prefixCls + '-dis-hover', this.disHover || this.shadow), (0, _defineProperty3.default)(_ref, prefixCls + '-shadow', this.shadow), _ref)];
        },
        headClasses: function headClasses() {
            return prefixCls + '-head';
        },
        extraClasses: function extraClasses() {
            return prefixCls + '-extra';
        },
        bodyClasses: function bodyClasses() {
            return prefixCls + '-body';
        },
        bodyStyles: function bodyStyles() {
            if (this.padding !== defaultPadding) {
                return {
                    padding: this.padding + 'px'
                };
            } else {
                return '';
            }
        }
    },
    mounted: function mounted() {
        this.showHead = this.title || this.$slots.title !== undefined;
        this.showExtra = this.$slots.extra !== undefined;
    }
};

/***/ }),

/***/ "7dGL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7hpk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8Dj3":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "count-container"
  }, [_c('h1', [_vm._v("志愿者数据")])])
}]}

/***/ }),

/***/ "8JCJ":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("/xek")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("49Wm"),
  /* template */
  __webpack_require__("g6Jh"),
  /* scopeId */
  "data-v-9b615ef8",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "8K8j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8UII":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//

exports.default = {
    name: "notice"
};

/***/ }),

/***/ "8XIX":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "comp-container"
  }, [_c('p', {
    staticStyle: {
      "font-size": "26px",
      "margin-top": "20px",
      "margin-left": "25px"
    }
  }, [_vm._v("盲人求助消息")]), _vm._v(" "), _c('Tabs', {
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "25px"
    },
    attrs: {
      "value": "name1"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "全部消息",
      "name": "name1"
    }
  }, [_c('table', {
    staticClass: "headTable"
  }, [_c('tr', [_c('td', [_vm._v("时间")]), _vm._v(" "), _c('td', [_c('DatePicker', {
    attrs: {
      "type": "datetimerange",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "开始时间-结束时间",
      "clearable": ""
    },
    on: {
      "on-change": _vm.dateTimeChange,
      "on-clear": _vm.dateTimeClear
    },
    model: {
      value: (_vm.checkedTime),
      callback: function($$v) {
        _vm.checkedTime = $$v
      },
      expression: "checkedTime"
    }
  })], 1), _vm._v(" "), _c('td', [_vm._v("用户来源")]), _vm._v(" "), _c('td', [_c('Select', {
    staticStyle: {
      "width": "10rem"
    },
    on: {
      "on-change": _vm.sourceChange
    },
    model: {
      value: (_vm.source),
      callback: function($$v) {
        _vm.source = $$v
      },
      expression: "source"
    }
  }, [_c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("小程序")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("App")])], 1)], 1), _vm._v(" "), _c('td', [_vm._v("求助方式")]), _vm._v(" "), _c('td', [_c('Select', {
    staticStyle: {
      "width": "15rem"
    },
    on: {
      "on-change": _vm.askWayChange
    },
    model: {
      value: (_vm.askWay),
      callback: function($$v) {
        _vm.askWay = $$v
      },
      expression: "askWay"
    }
  }, _vm._l((_vm.askWayArr), function(item) {
    return _c('Option', {
      key: item.key,
      attrs: {
        "value": item.key
      }
    }, [_vm._v(_vm._s(item.content))])
  }), 1)], 1), _vm._v(" "), _c('td', [_c('Button', {
    attrs: {
      "type": "default"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_vm._v("筛选")])], 1)])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "98%"
    }
  }, [_c('tr', [_c('td', [_c('table', {
    staticClass: "headTable",
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    }
  }, [_c('tr', [_c('td', [_vm._v("求助内容")]), _vm._v(" "), _c('td', [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "支持模糊搜索",
      "clearable": ""
    },
    on: {
      "on-change": _vm.helpContentChange,
      "on-enter": _vm.search
    },
    model: {
      value: (_vm.helpContent),
      callback: function($$v) {
        _vm.helpContent = $$v
      },
      expression: "helpContent"
    }
  })], 1), _vm._v(" "), _c('td', [_vm._v("盲人昵称")]), _vm._v(" "), _c('td', [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "支持模糊搜索",
      "clearable": ""
    },
    on: {
      "on-change": _vm.blindNickChange,
      "on-enter": _vm.search
    },
    model: {
      value: (_vm.blindNick),
      callback: function($$v) {
        _vm.blindNick = $$v
      },
      expression: "blindNick"
    }
  })], 1), _vm._v(" "), _c('td', [_c('Button', {
    attrs: {
      "type": "default"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_vm._v("搜索")])], 1)])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('Table', {
    ref: "selection",
    staticClass: "mainTable",
    attrs: {
      "stripe": "",
      "columns": _vm.columns1,
      "data": _vm.helpMessage,
      "loading": _vm.tableLoading
    },
    on: {
      "on-selection-change": function($event) {
        return _vm.handleSelectRow()
      }
    }
  }), _vm._v(" "), _c('Page', {
    staticStyle: {
      "text-align": "center",
      "margin": "50px"
    },
    attrs: {
      "total": _vm.pageTotal,
      "page-size": _vm.pageSize,
      "current": _vm.currPage,
      "show-elevator": ""
    },
    on: {
      "on-change": _vm.pageChange
    }
  })], 1)])], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ "8XXS":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("5gie")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("mODz"),
  /* template */
  __webpack_require__("+Mdo"),
  /* scopeId */
  "data-v-4a884d44",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "8mk/":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('keep-alive', {
    attrs: {
      "include": "des"
    }
  }, [_c('div', {
    staticClass: "table-container",
    staticStyle: {
      "min-width": "1100px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "26px",
      "margin-top": "20px",
      "margin-left": "25px"
    }
  }, [_vm._v("志愿者用户")]), _vm._v(" "), _c('Tabs', {
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "25px"
    },
    attrs: {
      "value": "name1"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "志愿者",
      "name": "name1"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "14"
    }
  }, [_c('Row', {
    staticStyle: {
      "margin": "3% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "18"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "用户昵称"
    },
    nativeOn: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchName.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.nickNameSearch),
      callback: function($$v) {
        _vm.nickNameSearch = $$v
      },
      expression: "nickNameSearch"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-search"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.searchName.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-top": "8%",
      "margin-left": "70%"
    },
    attrs: {
      "type": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.putBlack.apply(null, arguments)
      }
    }
  }, [_vm._v("加入黑名单")])], 1)], 1), _vm._v(" "), _c('Card', {
    staticClass: "mainBox"
  }, [_c('Tabs', {
    attrs: {
      "value": "main1",
      "type": "card"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": _vm.totalUser,
      "name": "main1"
    }
  }, [_c('Table', {
    ref: "selection",
    attrs: {
      "stripe": "",
      "columns": _vm.columnsMain,
      "data": _vm.volunteers
    },
    on: {
      "on-selection-change": function($event) {
        return _vm.handleSelectRow()
      }
    }
  }), _vm._v(" "), _c('Page', {
    staticClass: "paging",
    attrs: {
      "total": _vm.dataCount,
      "page-size": _vm.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "黑名单",
      "name": "name2"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "14"
    }
  }, [_c('Row', {
    staticStyle: {
      "margin": "3% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "18"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "用户昵称"
    },
    nativeOn: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchNameBlack.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.nickNameSearchBlack),
      callback: function($$v) {
        _vm.nickNameSearchBlack = $$v
      },
      expression: "nickNameSearchBlack"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-search"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.searchNameBlack.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-top": "8%",
      "margin-left": "70%"
    },
    attrs: {
      "type": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dragBlack.apply(null, arguments)
      }
    }
  }, [_vm._v("解除黑名单")])], 1)], 1), _vm._v(" "), _c('Card', {
    staticClass: "mainBox"
  }, [_c('Tabs', {
    attrs: {
      "value": "main1",
      "type": "card"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": _vm.totalUser,
      "name": "main1"
    }
  }, [_c('Table', {
    ref: "select",
    attrs: {
      "stripe": "",
      "columns": _vm.columnsMain,
      "data": _vm.blackList
    },
    on: {
      "on-selection-change": function($event) {
        return _vm.handleSelectBlackRow()
      }
    }
  }), _vm._v(" "), _c('Page', {
    staticClass: "paging",
    attrs: {
      "total": _vm.dataCountBlack,
      "page-size": _vm.pageSizeBlack,
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePageBlack
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ "8zdW":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    staticStyle: {
      "min-width": "1000px"
    }
  }, [_c('card', {
    staticStyle: {
      "width": "100%",
      "height": "11%",
      "position": "absolute",
      "top": "0px"
    }
  }, [_c('div', {
    staticClass: "nav-right"
  }, [_c('Icon', {
    staticClass: "nav-icon",
    attrs: {
      "type": "person"
    }
  }), _vm._v("\n        立即注册 丨\n        "), _c('Icon', {
    staticClass: "nav-icon",
    attrs: {
      "type": "ios-analytics"
    }
  }), _vm._v(" "), _c('select', {
    staticStyle: {
      "border": "0"
    }
  }, [_c('option', {
    attrs: {
      "value": "简体中文"
    }
  }, [_vm._v("简体中文")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "繁体中文"
    }
  }, [_vm._v("繁体中文")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "英文"
    }
  }, [_vm._v("英文")])])], 1)]), _vm._v(" "), (_vm.status) ? _c('Card', {
    staticClass: "card",
    staticStyle: {
      "min-width": "300px",
      "min-height": "300px"
    }
  }, [_c('p', {
    staticClass: "login-avatar"
  }, [_vm._v("登录")]), _vm._v(" "), _c('Form', {
    ref: "loginForm",
    staticClass: "login",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.loginRule
    }
  }, [_c('FormItem', {
    key: "login-account",
    staticStyle: {
      "margin-top": "5%"
    },
    attrs: {
      "prop": "account"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "邮箱/微信号/QQ号"
    },
    model: {
      value: (_vm.loginForm.account),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "account", $$v)
      },
      expression: "loginForm.account"
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "prepend",
      "type": "person",
      "size": "16"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('FormItem', {
    key: "login-password",
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "prepend",
      "type": "locked",
      "size": "14"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('FormItem', {
    staticClass: "remember-account"
  }, [_c('input', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-left": "6%",
      "float": "left"
    }
  }, [_vm._v("记住账号")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("忘记账号或密码")])]), _vm._v(" "), _c('FormItem', [_c('Button', {
    staticStyle: {
      "width": "35%",
      "float": "left",
      "min-width": "100px",
      "margin-bottom": "5%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorCount > 3),
      expression: "errorCount > 3"
    }],
    staticClass: "card-tip"
  }, [_c('Alert', {
    attrs: {
      "type": "error",
      "show-icon": ""
    }
  }, [_vm._v("错误次数超过3次 "), _c('router-link', {
    attrs: {
      "to": "/registe"
    }
  }, [_vm._v("注册")])], 1)], 1)], 1) : _c('Card', {
    staticClass: "card"
  }, [_c('Avatar', {
    staticClass: "registe-avatar",
    attrs: {
      "icon": "person",
      "size": "large"
    }
  }), _vm._v(" "), _c('Form', {
    ref: "registeForm",
    staticClass: "registe",
    attrs: {
      "model": _vm.registeForm,
      "rules": _vm.registeRule
    }
  }, [_c('FormItem', {
    key: "registe-account",
    attrs: {
      "prop": "account"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "账号"
    },
    model: {
      value: (_vm.registeForm.account),
      callback: function($$v) {
        _vm.$set(_vm.registeForm, "account", $$v)
      },
      expression: "registeForm.account"
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "prepend",
      "type": "person",
      "size": "16"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('FormItem', {
    key: "registe-password",
    attrs: {
      "prop": "password"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.registeForm.password),
      callback: function($$v) {
        _vm.$set(_vm.registeForm, "password", $$v)
      },
      expression: "registeForm.password"
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "prepend",
      "type": "locked",
      "size": "14"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('FormItem', {
    key: "registe-confirm",
    attrs: {
      "prop": "confirm"
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "placeholder": "确认密码"
    },
    model: {
      value: (_vm.registeForm.confirm),
      callback: function($$v) {
        _vm.$set(_vm.registeForm, "confirm", $$v)
      },
      expression: "registeForm.confirm"
    }
  }, [_c('Icon', {
    attrs: {
      "slot": "prepend",
      "type": "locked",
      "size": "14"
    },
    slot: "prepend"
  })], 1)], 1), _vm._v(" "), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary",
      "long": ""
    },
    on: {
      "click": _vm.registe
    }
  }, [_vm._v("注册")])], 1)], 1)], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "11%",
      "position": "absolute",
      "bottom": "0px",
      "background-color": "#fff"
    }
  }, [_c('ul', {
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "flex-direction": "column",
      "list-style": "none",
      "justify-content": "center",
      "height": "100%"
    }
  }, [_c('li', {
    staticClass: "info"
  }, [_vm._v("Copyright © 2017-2021 All rights reserved 版权所有 © 无障碍科技")]), _vm._v(" "), _c('li', {
    staticClass: "info"
  }, [_c('a', {
    attrs: {
      "href": "https://beian.miit.gov.cn/#/Integrated/recordQuery",
      "target": "_blank"
    }
  }, [_vm._v("鄂ICP备18005954号")])])])])
}]}

/***/ }),

/***/ "BAQ6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import imgSrc from "@/assets/images/avatar.jpg";
// import utils from "@/utils";
// import adminMap from "./admin-map";
// import visiteVolume from "./visite-volume";
// import dataSourcePie from "./data-source";
// import userFlow from "./user-flow";
// import List from "../../../../firstVue/src/components/List";
// import axios from 'axios';

exports.default = {
  name: "AdminHome",
  data: function data() {
    return {
      countInfo: {},
      list: true,
      defaultKey: 0 //后台数据缺失，默认为0
    };
  },
  created: function created() {
    var _this = this;

    this.$http.get('/zm/backManage/queryIndexInfo').then(function (res) {
      // console.log(res.data);
      _this.countInfo = res.data.content;
    });
  },

  methods: {}
};

/***/ }),

/***/ "BNlP":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("1u2F")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("to50"),
  /* template */
  __webpack_require__("DHdB"),
  /* scopeId */
  "data-v-6eedf58f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "BaUe":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("4ADN")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("JGXI"),
  /* template */
  __webpack_require__("RfiY"),
  /* scopeId */
  "data-v-95c66b5e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "C3q7":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("7hpk")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("kTqd"),
  /* template */
  __webpack_require__("a78U"),
  /* scopeId */
  "data-v-7ed2a828",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "DHdB":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "count-container"
  }, [_c('h1', [_vm._v("APP数据")])])
}]}

/***/ }),

/***/ "DKwD":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("8K8j")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("xRgN"),
  /* template */
  __webpack_require__("8Dj3"),
  /* scopeId */
  "data-v-a2f9a0f4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Di+W":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _mixin = __webpack_require__("vsZy");

var _mixin2 = _interopRequireDefault(_mixin);

var _admin = __webpack_require__("4piF");

var _utils = __webpack_require__("0xDb");

var _utils2 = _interopRequireDefault(_utils);

var _messageTip = __webpack_require__("8JCJ");

var _messageTip2 = _interopRequireDefault(_messageTip);

var _menuLists = __webpack_require__("62+D");

var _menuLists2 = _interopRequireDefault(_menuLists);

var _tagLists = __webpack_require__("G/4W");

var _tagLists2 = _interopRequireDefault(_tagLists);

var _avatar = __webpack_require__("odpv");

var _avatar2 = _interopRequireDefault(_avatar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "admin",
  mixins: [_mixin2.default],
  components: {
    messageTip: _messageTip2.default,
    menuLists: _menuLists2.default,
    tagLists: _tagLists2.default
  },
  data: function data() {
    var img = new Image().src = _avatar2.default;
    return {
      shrink: false,
      avatarSrc: img,
      dataSource: null,
      mesCount: 3,
      userInfo: null,
      tagOffsetLeft: false
    };
  },

  computed: {},
  watch: {},
  methods: {
    toggleClick: function toggleClick() {
      this.shrink = !this.shrink;
    },
    handleDropdown: function handleDropdown(name) {
      if (name === "userCenter") {
        if (this.currentTag !== name) {
          var tags = null;
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = (0, _getIterator3.default)(_admin.adminRouter), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var ele = _step.value;

              if (ele.name === name) {
                tags = {
                  title: ele.title,
                  name: ele.name,
                  path: ele.path
                };
                break;
              } else {
                if (ele.children.length) {
                  var _iteratorNormalCompletion2 = true;
                  var _didIteratorError2 = false;
                  var _iteratorError2 = undefined;

                  try {
                    for (var _iterator2 = (0, _getIterator3.default)(ele.children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                      var val = _step2.value;

                      if (val.name === name) {
                        tags = {
                          title: val.title,
                          name: val.name,
                          path: val.path
                        };
                        break;
                      }
                    }
                  } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                  } finally {
                    try {
                      if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                      }
                    } finally {
                      if (_didIteratorError2) {
                        throw _iteratorError2;
                      }
                    }
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          localStorage.setItem("currentTag", name);
          this.$store.commit("updateCurrentTag", name);
          this.$store.commit("updateOpenedTags", [tags]);
          this.$store.commit("updateCurrentPath", name);
          this.$router.push({
            name: "userCenter"
          });
        }
      } else if (name === "logout") {
        localStorage.clear();
        this.$store.commit("updateLogin", false);
        this.$store.commit("updateSession", null);
        _utils2.default.delCookie("uid");
        _utils2.default.delCookie("user");
        this.$router.push("/login");
      }
    },
    showHref: function showHref(item, index) {
      var len = this.currentPath.length;
      if (index !== len - 1 && item.name !== "tables" && item.name !== "forms" && item.name !== "component") {
        return item.path;
      } else {
        return null;
      }
    },
    getUserInfo: function getUserInfo() {
      return { user: _utils2.default.getCookie("user"), uid: _utils2.default.getCookie("uid") };
      // this.$http.get("/GET/userLists").then(function(res){
      //   if(res.readyState === 4 && res.status === 200){
      //     this.dataSource = res.data;
      //   }
      // }).catch(function(error){
      //   console.log(error);
      // });
    }
  },
  created: function created() {
    this.userInfo = this.getUserInfo();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "DpJM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _wangeditor = __webpack_require__("alfv");

var _wangeditor2 = _interopRequireDefault(_wangeditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Editor',
  props: {
    value: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      editor: null
    };
  },

  methods: {},
  mounted: function mounted() {
    var _this = this;

    this.editor = new _wangeditor2.default(this.$refs.editor);
    this.editor.customConfig.onchange = function (html) {
      _this.$emit('input', html);
    };
    this.editor.customConfig.uploadImgShowBase64 = true; //使用base64保存图片
    // 将图片大小限制为 3M
    this.editor.customConfig.uploadImgMaxSize = 3 * 1024 * 1024;
    this.editor.customConfig.uploadFileName = 'file';
    // 限制一次最多上传 1 张图片
    this.editor.customConfig.uploadImgMaxLength = 1;

    this.editor.create();
    this.editor.txt.html(this.value);
  }
}; //
//
//
//
//
//

/***/ }),

/***/ "E9G3":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("zG6b")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("SaVt"),
  /* template */
  __webpack_require__("tILD"),
  /* scopeId */
  "data-v-5ede7524",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "E9pU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "FviQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = __webpack_require__("0xDb");

var _utils2 = _interopRequireDefault(_utils);

var _input = __webpack_require__("VrLL");

var _input2 = _interopRequireDefault(_input);

var _card = __webpack_require__("t2zW");

var _card2 = _interopRequireDefault(_card);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Card: _card2.default,
    Input: _input2.default },
  name: "home",
  props: ["status"],
  data: function data() {
    var _this = this;

    var validPwd = function validPwd(rule, value, callback, source, options) {
      if (value === "") {
        callback(new Error("input valid password"));
      } else {
        console.log(_this.registeForm.confirm);
        if (_this.registeForm.confirm !== "") {
          _this.$refs.registeForm.validateField("confirm");
        }
        callback();
      }
    };
    var validConfirm = function validConfirm(rule, value, callback, source, options) {
      if (value === "") {
        callback(new Error("input valid password again"));
      } else if (value !== _this.registeForm.password) {
        callback(new Error('The two input passwords do not match!'));
      } else {
        callback();
      }
    };
    return {
      errorCount: 0,
      loginForm: {
        account: "",
        password: ""
      },
      registeForm: {
        account: "",
        password: "",
        confirm: ""
      },
      loginRule: {
        account: [{
          required: true,
          message: "input valid accout"
        }],
        password: [{
          required: true,
          message: "input valid password"
        }]
      },
      registeRule: {
        account: [{
          required: true,
          message: "input valid accout",
          trigger: "blur"
        }],
        password: [{
          validator: validPwd,
          trigger: "blur"
        }],
        confirm: [{
          validator: validConfirm,
          trigger: "blur"
        }]
      }
    };
  },
  mounted: function mounted() {
    if (_utils2.default.getCookie('username')) {
      console.log('1234');
    }
  },

  methods: {
    login: function login() {
      var _this2 = this;

      this.$refs['loginForm'].validate(function (valid) {
        if (_this2.loginForm.account === '' || _this2.loginForm.password === '') {
          alert('请输入用户名或密码');
        } else {
          var data = { 'userName': _this2.loginForm.account, 'password': _this2.loginForm.password };
          _this2.$http.post('/zm/session/login', data).then(function (res) {
            // console.log(res);
            if (res.data.code === 0) {
              _this2.$Message.success("登录成功!");
              _this2.setUserInfo();
              var currentTag = _this2.$store.state.currentTag;
              if (currentTag) {
                _this2.$router.push({
                  name: currentTag,
                  query: ""
                });
              } else {
                var openedPage = localStorage.getItem("currentTag");
                _this2.$router.push({
                  name: openedPage || "admin"
                });
              }
            } else {
              _this2.$Message.error(res.data.errorMsg);
            }
          });
        }
      });
      //重置表单
      this.$refs.loginForm.resetFields();
    },
    registe: function registe() {
      var _this3 = this;

      this.$refs['registeForm'].validate(function (valid) {
        console.log(valid);
        if (valid) {
          _this3.$Message.success("注册成功!");
        } else {
          _this3.$Message.error("注册失败!");
        }
      });
    },
    setUserInfo: function setUserInfo() {
      var user = this.loginForm.account;
      var uid = new Date().getTime().toString(16);
      _utils2.default.setCookie("user", user, 1);
      _utils2.default.setCookie("uid", uid, 1);
      // this.$store.commit("updateCurrentTag", "admin");
      if (typeof Storage !== "undefined") {
        localStorage.setItem("isLogin", true);
        // localStorage.setItem("currentTag", "admin");
        // localStorage.setItem("openedTags", JSON.stringify(this.$store.state.openedTags));
        // localStorage.setItem("currentPath", JSON.stringify(this.$store.state.currentPath));
      } else {
        console.error("your browser doesn't support localstorage and sessionstorage.");
      }
    }
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "G+oQ":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("E9pU")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("gxDU"),
  /* template */
  __webpack_require__("gcER"),
  /* scopeId */
  "data-v-75288b5c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "G/4W":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("5XZ0")
__webpack_require__("fDCX")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Iwfw"),
  /* template */
  __webpack_require__("e3Xd"),
  /* scopeId */
  "data-v-8cabc4de",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "G5xB":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contianer"
  }, [_c('Carousel', {
    attrs: {
      "autoplay": "",
      "loop": ""
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, [_c('CarouselItem', [_c('div', {
    staticClass: "carousel-item"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("V3Wx"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('CarouselItem', [_c('div', {
    staticClass: "carousel-item"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("RGHt"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('CarouselItem', [_c('div', {
    staticClass: "carousel-item"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("0mYp"),
      "alt": ""
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "nav-container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "nav-navbar"
  }, [_c('ul', [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('li', {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.toLogin
    }
  }, [_vm._v("登录")])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row-container"
  }, [_c('Row', {
    staticClass: "row",
    attrs: {
      "gutter": 40,
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v(" "), _c('h2', [_vm._v("HEAD")]), _vm._v(" "), _c('p', [_vm._v("Donec sed odio dui. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Vestibulum id ligula porta felis euismod semper. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus.")]), _vm._v(" "), _c('p', [_c('Button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("Primary")])], 1)]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v(" "), _c('h2', [_vm._v("HEAD")]), _vm._v(" "), _c('p', [_vm._v("Donec sed odio dui. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Vestibulum id ligula porta felis euismod semper. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus.")]), _vm._v(" "), _c('p', [_c('Button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("Primary")])], 1)]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('span', {
    staticClass: "circle"
  }), _vm._v(" "), _c('h2', [_vm._v("HEAD")]), _vm._v(" "), _c('p', [_vm._v("Donec sed odio dui. Cras justo odio, dapibus ac facilisis in, egestas eget quam. Vestibulum id ligula porta felis euismod semper. Fusce dapibus, tellus ac cursus commodo, tortor mauris condimentum nibh, ut fermentum massa justo sit amet risus.")]), _vm._v(" "), _c('p', [_c('Button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("Primary")])], 1)])], 1), _vm._v(" "), _c('Row', {
    staticClass: "wrap",
    attrs: {
      "gutter": 40,
      "type": "flex",
      "justify": "center",
      "align": "middle"
    }
  }, [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('h2', [_vm._v("First featurette heading. ")]), _vm._v(" "), _c('p', [_vm._v("Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper. Praesent commodo cursus magna, vel scelerisque nisl consectetur. Fusce dapibus, tellus ac cursus commodo.")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('span', {
    staticClass: "wrap-content"
  })])], 1), _vm._v(" "), _c('Row', {
    staticClass: "wrap",
    attrs: {
      "gutter": 40,
      "type": "flex",
      "justify": "center",
      "align": "middle"
    }
  }, [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('span', {
    staticClass: "wrap-content"
  })]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('h2', [_vm._v("First featurette heading. ")]), _vm._v(" "), _c('p', [_vm._v("Donec ullamcorper nulla non metus auctor fringilla. Vestibulum id ligula porta felis euismod semper. Praesent commodo cursus magna, vel scelerisque nisl consectetur. Fusce dapibus, tellus ac cursus commodo.")])])], 1), _vm._v(" "), _c('Row', {
    staticClass: "wrap",
    attrs: {
      "gutter": 40,
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_vm._v("vue")]), _vm._v(" "), _c('Col', {
    staticClass: "wrap-right",
    attrs: {
      "span": "8"
    }
  }, [_vm._v("© 2017 Company, Inc. ·")])], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-logo"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("iQH9")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Business")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Work")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("About")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Contact")])])
}]}

/***/ }),

/***/ "GFSd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GIKy":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("fZhn")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Ju8e"),
  /* template */
  __webpack_require__("WBak"),
  /* scopeId */
  "data-v-4a0bf96a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "GXsV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _tables = __webpack_require__("WPWB");

var _tables2 = _interopRequireDefault(_tables);

var _format = __webpack_require__("4/BI");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "weChatMaterial",
  components: { Tables: _tables2.default },
  data: function data() {
    var _this = this;

    return {
      loading1: true,
      columns: [{
        title: '选择',
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        title: '图片',
        width: 100,
        key: 'title-image',
        sortable: true,
        align: 'center',
        render: function render(h, params) {
          return h('Tooltip', {
            props: {
              content: '点击访问原文链接',
              placement: 'top'
            }
          }, [h('a', {
            attrs: {
              href: params.row.url,
              target: '_blank'
            }
          }, [h('img', {
            attrs: {
              src: params.row.thumbUrl
            },
            style: {
              width: '50px',
              height: '50px'
            }
          })])]);
        }
      }, {
        title: '标题',
        key: 'title',
        editable: true,
        minWidth: 500,
        align: 'center'
      }, {
        title: '作者',
        key: 'author',
        editable: true,
        width: 200,
        sortable: true,
        align: 'center'
      }, {
        title: '更新时间',
        key: 'time',
        width: 260,
        sortable: true,
        /*editable: true,*/
        align: 'center',
        render: function render(h, params) {
          return h('span', _this.tableData[params.index].time);
        }
      }, {
        title: '专辑',
        key: 'album',
        width: 200,
        sortable: true,
        editable: true,
        align: 'center'
      }, {
        title: '操作',
        key: 'handle',
        align: 'center',
        width: 300,
        fixed: 'right'
      }],
      appName: 'qmtfwh',
      tableData: [],
      albumList: [],
      currPage: 1,
      pageSize: 10,
      pageTotal: 0,
      pageResultVo: {}
    };
  },

  computed: {},
  methods: {
    currentTabChanged: function currentTabChanged(name) {
      var _this2 = this;

      this.tableData = [];
      this.loading1 = true;
      this.appName = name;
      setTimeout(function () {
        _this2.getTableData();
      }, 1500);
    },
    getAlbumName: function getAlbumName(id) {
      var name = void 0;
      for (var i = 0; i < this.albumList.length; i++) {
        if (id === this.albumList[i].id) {
          name = this.albumList[i].name;
          break;
        } else {
          name = '请添加所属专辑';
        }
      }
      return name;
    },
    getTableData: function getTableData() {
      var _this3 = this;

      this.pageResultVo.content = { appName: this.appName };
      this.pageResultVo.currPage = this.currPage;
      this.pageResultVo.pageSize = this.pageSize;
      this.$http.post('/zm/backManage/queryBackMaterialListByPage', this.pageResultVo).then(function (res) {
        _this3.currPage = res.data.currPage;
        _this3.pageSize = res.data.pageSize;
        _this3.pageTotal = res.data.pageTotal;
        _this3.loading1 = false;
        var tempData = res.data.content;
        tempData.map(function (item, index) {
          var res1 = item;
          if (res1.updateTime) {
            res1.time = (0, _format.format2Sec)(res1.updateTime);
          }
          res1.album = _this3.getAlbumName(res1.albumId);
          return res1;
        });
        _this3.tableData = tempData;
      }, function (err) {
        _this3.$Message.error("请求失败：" + err.message);
      });
    }
  },

  created: function created() {
    var _this4 = this;

    this.$http.post("/zm/backManage/queryAlbumList", {}).then(function (res) {
      _this4.albumList = res.data.content;
      _this4.getTableData();
    }, function (err) {
      _this4.$Message.error("请求失败：" + err.message);
    });
  },
  mounted: function mounted() {}
};

/***/ }),

/***/ "HhrG":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("NqMA")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("7M94"),
  /* template */
  __webpack_require__("ZXMG"),
  /* scopeId */
  "data-v-59c66bae",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Hzbo":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gantan.e8706fb.png";

/***/ }),

/***/ "IE5C":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "material-container"
  }, [_c('Tabs', {
    attrs: {
      "value": _vm.appName
    },
    on: {
      "on-click": _vm.currentTabChanged
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "启明瞳服务号",
      "name": "qmtfwh"
    }
  }, [(_vm.appName === 'qmtfwh') ? _c('Card', [_c('Tables', {
    ref: "tables",
    attrs: {
      "searchable": "",
      "editable": "",
      "border": "",
      "appName": _vm.appName,
      "currPage": _vm.currPage,
      "pageSize": _vm.pageSize,
      "pageTotal": _vm.pageTotal,
      "columns": _vm.columns,
      "loading": _vm.loading1,
      "albumList": _vm.albumList,
      "height": 600
    },
    model: {
      value: (_vm.tableData),
      callback: function($$v) {
        _vm.tableData = $$v
      },
      expression: "tableData"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "无障碍科技",
      "name": "ACCESSIBILITY_TECHNOLOGY"
    }
  }, [(_vm.appName === 'ACCESSIBILITY_TECHNOLOGY') ? _c('Card', [_c('Tables', {
    ref: "tables",
    attrs: {
      "searchable": "",
      "editable": "",
      "border": "",
      "appName": _vm.appName,
      "currPage": _vm.currPage,
      "pageSize": _vm.pageSize,
      "pageTotal": _vm.pageTotal,
      "columns": _vm.columns,
      "loading": _vm.loading1,
      "albumList": _vm.albumList,
      "height": 600
    },
    model: {
      value: (_vm.tableData),
      callback: function($$v) {
        _vm.tableData = $$v
      },
      expression: "tableData"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "我能帮帮忙服务号",
      "name": "I_Can_Help"
    }
  }, [(_vm.appName === 'I_Can_Help') ? _c('Card', [_c('Tables', {
    ref: "tables",
    attrs: {
      "searchable": "",
      "editable": "",
      "border": "",
      "appName": _vm.appName,
      "currPage": _vm.currPage,
      "pageSize": _vm.pageSize,
      "pageTotal": _vm.pageTotal,
      "columns": _vm.columns,
      "loading": _vm.loading1,
      "albumList": _vm.albumList,
      "height": 600
    },
    model: {
      value: (_vm.tableData),
      callback: function($$v) {
        _vm.tableData = $$v
      },
      expression: "tableData"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "IcnI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _admin = __webpack_require__("4piF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//状态管理模式
_vue2.default.use(_vuex2.default);
//创建vuex仓库
exports.default = new _vuex2.default.Store({
  //状态
  state: {
    domain: "http://rap2api.taobao.org/",
    isLogin: false,
    openedSubmenuArr: [], //展开的菜单数组
    openedTags: [{
      title: "首页",
      name: "admin",
      path: "/admin"
    }],
    currentTag: "",
    currentPath: [{
      title: "首页",
      name: "admin",
      path: "/admin"
    }],
    routers: _admin.adminRouter
  },
  //state的计算属性
  getters: {},
  //突变
  mutations: {
    updateSession: function updateSession(state, newUserInfo) {
      state.session = newUserInfo;
    },
    updateLogin: function updateLogin(state, status) {
      state.isLogin = status;
    },
    updateOpenedTags: function updateOpenedTags(state, tagsArr) {
      if (tagsArr.length) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(tagsArr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            var hasItem = false;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = (0, _getIterator3.default)(state.openedTags), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var ele = _step2.value;

                if (ele.name === item.name) {
                  hasItem = true;
                  break;
                }
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }

            if (!hasItem) {
              state.openedTags.push(item);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        localStorage.openedTags = (0, _stringify2.default)(state.openedTags);
      }
    },
    deleteOpenedTags: function deleteOpenedTags(state, name) {
      for (var i = 0; i < state.openedTags.length; i++) {
        if (state.openedTags[i].name === name) {
          state.openedTags.splice(i, 1);
          break;
        }
      }
    },
    updateCurrentPath: function updateCurrentPath(state, name) {
      var pathArr = state.currentPath.filter(function (item) {
        return item.name === "admin";
      });
      if (name !== "admin") {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = (0, _getIterator3.default)(_admin.adminRouter), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var ele = _step3.value;

            if (ele.name === name) {
              pathArr.push({
                title: ele.title,
                name: ele.name,
                path: ele.path
              });
              break;
            } else {
              if (ele.children.length) {
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                  for (var _iterator4 = (0, _getIterator3.default)(ele.children), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var val = _step4.value;

                    if (val.name === name) {
                      if (ele.name) {
                        pathArr.push({
                          title: ele.title,
                          name: ele.name,
                          path: ele.path
                        }, {
                          title: val.title,
                          name: val.name,
                          path: val.path
                        });
                      } else {
                        pathArr.push({
                          title: val.title,
                          name: val.name,
                          path: val.path
                        });
                      }
                      break;
                    }
                  }
                } catch (err) {
                  _didIteratorError4 = true;
                  _iteratorError4 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                      _iterator4.return();
                    }
                  } finally {
                    if (_didIteratorError4) {
                      throw _iteratorError4;
                    }
                  }
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
      state.currentPath = pathArr;
      // let pathArr = path.split("/").filter(item => item!=="");
      // let arr = pathArr.filter(item => state.currentPath.findIndex(ele => ele.name===item)===-1);
    },
    openedSubmenu: function openedSubmenu(state, arr) {
      state.openedSubmenuArr = arr;
    },
    updateCurrentTag: function updateCurrentTag(state, tag) {
      state.currentTag = tag;
      localStorage.currentTag = tag;
    },
    clearTags: function clearTags(state, tag) {
      if (tag) {
        state.openedTags = state.openedTags.filter(function (item, index) {
          return tag === item.name || item.name === "admin";
        });
      } else {
        state.openedTags.splice(1);
        state.currentTag = "admin";
        localStorage.currentTag = "admin";
      }
      localStorage.openedTags = (0, _stringify2.default)(state.openedTags);
    }
  },
  actions: {
    //context具有与state相同方法和属性
    updateSession: function updateSession(context, obj) {
      context.commit("updateLogin", obj.isLogin);
      context.commit("updateCurrentTag", obj.currentTag);
      context.commit("updateOpenedTags", obj.openedTags);
      context.commit("updateCurrentPath", obj.currentPath);
      context.commit("openedSubmenu", obj.submenuArr);
    }
  }
});

/***/ }),

/***/ "IwIZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Iwfw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _mixin = __webpack_require__("vsZy");

var _mixin2 = _interopRequireDefault(_mixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "tagLists",
  mixins: [_mixin2.default],
  props: ["shrink"],
  data: function data() {
    return {
      styleObj: null
    };
  },

  watch: {
    shrink: function shrink(val, oldVal) {
      if (val && this.styleObj) {
        this.styleObj = {
          left: 0
        };
      }
    },
    currentTag: function currentTag(val, oldVal) {
      this.$nextTick(function () {
        this.computeOffset(val);
      });
    }
  },
  methods: {
    closeTag: function closeTag(event, name) {
      var openedTags = this.openedTags;
      var lastOpenedTag = openedTags[0];
      if (this.currentTag === name) {
        var len = openedTags.length;
        for (var i = 1; i < len; i++) {
          if (openedTags[i].name === name) {
            if (i < len - 1) {
              lastOpenedTag = openedTags[i + 1];
            } else {
              lastOpenedTag = openedTags[i - 1];
            }
            break;
          }
        }
      }
      this.$store.commit("deleteOpenedTags", name);
      openedTags = this.openedTags;
      localStorage.setItem("openedTags", (0, _stringify2.default)(openedTags));
      if (this.currentTag === name) {
        this.linkTo(lastOpenedTag);
      }
    },
    linkTo: function linkTo(item, index) {
      localStorage.currentTag = item.name;
      this.$router.push({
        name: item.name,
        params: ""
      });
    },
    handleTagsOption: function handleTagsOption(name) {
      if (name === 'clearAll') {
        this.$store.commit('clearTags');
        this.$router.push({
          name: 'admin'
        });
      } else {
        this.$store.commit('clearTags', this.currentTag);
      }
    },
    computeOffset: function computeOffset(name) {
      var index = this.openedTags.findIndex(function (item, index) {
        return item.name === name;
      });
      var tagWrap = this.$el;
      var tagWrapWidth = tagWrap.offsetWidth - 120;
      var tagGroup = tagWrap.firstChild;
      var tagGroupWidth = tagGroup.offsetWidth;
      var groupArr = tagGroup.firstChild.children;
      var currentTagLeft = groupArr[index].offsetLeft;
      if (tagGroupWidth > tagWrapWidth) {
        var tagGroupLeft = tagGroup.offsetLeft;
        var tagGroupRight = tagGroupWidth - tagWrapWidth - Math.abs(tagGroupLeft);
        if (currentTagLeft < tagGroupWidth / 2) {
          var num = this.openedTags[index - 1] ? index - 1 : index;
          var previousTag = groupArr[num];
          var previousTagLeft = previousTag.offsetLeft;
          if (tagGroupLeft < 0) {
            /*向右移动*/
            this.styleObj = {
              left: parseFloat(-previousTagLeft + 10) + "px"
            };
            console.log("向右移动" + this.styleObj.left);
          } else {
            console.log("不向右移动");
          }
        } else {
          var _num = this.openedTags[index + 1] ? index + 1 : index;
          var nextTag = groupArr[_num];
          var nextTagLeft = nextTag.offsetLeft;
          var nextTagWidth = nextTag.offsetWidth;
          var moveLeft = parseFloat(nextTagLeft + nextTagWidth - tagWrapWidth);
          if (tagGroupRight > 0 && moveLeft > 0) {
            /*向左移动*/
            this.styleObj = {
              left: parseFloat(-moveLeft - 5) + "px"
            };
            console.log("向左移动" + this.styleObj.left);
          } else {
            console.log("不向左移动");
          }
        }
      } else {
        console.log("不移动");
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.computeOffset(this.currentTag);
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "J63L":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', _vm._l((_vm.content), function(value, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(value))])
  }), 0)])
},staticRenderFns: []}

/***/ }),

/***/ "JEoT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//

exports.default = {
  name: "expandRow",
  props: {
    index: Number,
    template_list: Array
  },
  computed: {
    content: function content() {
      return this.template_list[this.index].content.split('\n');
    }
  }
};

/***/ }),

/***/ "JGXI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _format = __webpack_require__("4/BI");

exports.default = {
  name: "volunteerDetail",
  data: function data() {
    return {
      volunteers: {
        "avatarUrl": "",
        "nickname": "",
        "createTime": "",
        "unAns": 0,
        "loveGrade": 3256
      }, //志愿者信息
      numbers: {
        "answerNum": 1,
        "nonAnswerNum": 0
      },
      loveGrade: 3569, //爱心积分
      aveGrade: 3.45, //平均积分
      aveDelay: 6, //平均延时
      serveGrade: 3456, //服务积分
      serveAveGrade: 3.45, //平均积分
      timebank: 34560, //时间银行
      avetime: 34.7, //平均耗时

      /*时间模块的相关参数*/
      totalTime: true, //所有时间单选按钮
      recentTime: "一周", //选择列表最近的时间
      timeList: [{
        value: '一天',
        label: '一天'
      }, {
        value: '一周',
        label: '一周'
      }, {
        value: '一月',
        label: '一月'
      }, {
        value: '一年',
        label: '一年'
      }],
      fromTime: "", //起始时间
      toTime: "", //结束时间
      switch1: true, //第一个设为默认

      /*盲人评分模块的相关参数*/
      totalRate: true, //所有评分单选按钮
      rate5: 5,
      rate4: 4,
      rate3: 3,
      rate2: 2,
      rate1: 1,
      check: "",
      rateArr: ['5星', '4星', '3星', '2星', '1星', '0星'], //获取盲人评分数组
      switch2: true, //第二个设为默认

      /*当前进度模块的相关参数*/
      totalProcess: true, //所有进度单选按钮
      processArr: ['zero', 'twenty', 'fifty', 'seventy', 'hundred', 'manager'], //获取当前进度数组
      switch3: true, //第三个设为默认

      /*求助方式模块的相关参数*/
      wayArr: ['picAndWord', 'picAndVoice', 'shortVideo'], //求助方式选项数组
      switch4: true,
      vitalWord: "", //搜索框的内容
      columns: [{
        title: 'ID',
        key: "id",
        align: 'center'
      }, {
        title: "求助时间",
        key: "updateTime",
        align: 'center',
        sortable: true,
        render: function render(h, params) {
          return h("div", (0, _format.format)(params.row.updateTime, "yyyy-MM-dd hh:mm"));
        }
      }, {
        title: "帮助类型",
        key: "askWay",
        align: 'center'
      }, {
        title: "盲人昵称",
        key: "nickname",
        align: 'center'
      }, {
        title: "问题缩略",
        key: "helpText",
        align: 'center'
      }, {
        title: "评分",
        key: "grade",
        align: 'center',
        render: function render(h, params) {
          return h('Rate', {
            props: {
              disabled: true,
              value: params.row.grade
            },
            style: {
              fontSize: "13px"
            }
          });
        }
      }, {
        title: "当前进度",
        key: "process",
        align: 'center'
      }, {
        title: "标记",
        align: 'center',
        render: function render(h, params) {
          return h('Button', {
            props: {
              icon: "flag",
              type: "text"
            },
            style: {
              border: "none",
              fontSize: "20px"
            },
            on: {
              click: function click() {
                // console.log(params.row.id);
              }
            }
          });
        }
      }, {
        title: '详情',
        align: 'center',
        render: function render(h, params) {
          return h('Button', {
            props: {
              type: "primary",
              icon: "ios-arrow-right"
            },
            style: {
              border: 'none',
              fontSize: "20px"
            },
            on: {
              click: function click() {
                console.log(params.row.id);
              }
            }
          });
        }
      }],
      dataCount: 0, //初始化信息总条数
      pageSize: 20, //每页条数
      tableLoading: false, //表格是否加载
      dataSearch: //请求的数据
      {
        "code": 0,
        "content": {},
        "currPage": 1,
        "pageSize": 20,
        "pageTotal": 0
      },
      tableData: []
    };
  },
  destroyed: function destroyed() {
    this.$router.go(-1);
  },

  methods: {
    change1: function change1() {
      //第一个设为默认
      if (this.switch1) {
        this.totalTime = true;
        this.recentTime = "一周";
        this.fromTime = "";
        this.toTime = "";
      } else {
        this.totalTime = false;
      }
    },
    change2: function change2() {
      //第二个设为默认
      if (!this.switch2) {
        this.totalRate = false;
        this.rateArr = [];
      } else {
        this.rateArr = ['5星', '4星', '3星', '2星', '1星', '0星'];
        this.totalRate = true;
      }
    },
    change3: function change3() {
      //第三个设为默认
      if (!this.switch3) {
        this.totalProcess = false;
        this.processArr = [];
      } else {
        this.totalProcess = true;
        this.processArr = ['zero', 'twenty', 'fifty', 'seventy', 'hundred', 'manager'];
      }
    },
    change4: function change4() {
      if (!this.switch4) {
        this.wayArr = [];
      } else {
        this.wayArr = ['picAndWord', 'picAndVoice', 'shortVideo'];
      }
    },
    getAllTime: function getAllTime() {
      /*所有时间单选按钮*/
      this.totalTime = !this.totalTime;
      if (!this.totalTime) {
        this.switch1 = false;
      }
    },
    getAllRate: function getAllRate() {
      /*点击所有评分*/
      if (!this.totalRate) {
        this.totalRate = true;
        this.rateArr = ['5星', '4星', '3星', '2星', '1星', '0星'];
        this.switch2 = true;
      } else {
        this.totalRate = false;
        this.rateArr = [];
        this.switch2 = false;
      }
    },
    getAllProcess: function getAllProcess() {
      /*点击所有进度*/
      if (!this.totalProcess) {
        this.totalProcess = true;
        this.processArr = ['zero', 'twenty', 'fifty', 'seventy', 'hundred', 'manager'];
        this.switch3 = true;
      } else {
        this.totalProcess = false;
        this.processArr = [];
        this.switch3 = false;
      }
    },
    resetAll: function resetAll() {
      //重置
      this.switch1 = true;
      this.switch2 = true;
      this.switch3 = true;
      this.switch4 = true;
      this.change1();
      this.change2();
      this.change3();
      this.change4();
    },
    searchQus: function searchQus() {
      //筛选
      console.log("选择列表最近的时间   :" + this.recentTime);
      console.log("起始时间  :" + this.fromTime);
      console.log("结束时间   :" + this.toTime);
      console.log("盲人评分数组   :" + this.rateArr);
      console.log("当前进度数组   :" + this.processArr);
      console.log("求助方式数组   :" + this.wayArr);
    },
    clearInputInfo: function clearInputInfo() {
      //清除搜索框的内容
      this.vitalWord = "";
    },
    summaryChange: function summaryChange() {
      //搜索框中的内容改变触发
      if (this.vitalWord === "") {
        delete this.dataSearch.content["helpText"];
      } else {
        //TODO 问题概述是否为helpText
        this.dataSearch.content.helpText = this.vitalWord;
      }
    },
    searchItem: function searchItem() {
      var _this = this;

      //点击搜索
      this.tableLoading = true;
      this.dataSearch.currPage = 1;
      this.currPage = 1;

      ////TODO 将地址替换为志愿者所有回复
      this.$http.post("/zm/backManage/queryAllQuestionsByOpneid", this.dataSearch).then(function (res) {
        _this.tableData = res.data.content;
        _this.dataCount = res.data.pageTotal;
        _this.pageSize = res.data.pageSize;
        _this.$data.tableLoading = false;
      }, function (err) {
        _this.$Message.error("请求失败：" + err.message);
        _this.$data.tableLoading = false;
      });
    },
    changePage: function changePage(index) {
      var _this2 = this;

      //改变页数
      this.dataSearch.currPage = index;
      console.log(this.dataSearch);
      this.tableLoading = true;

      //TODO 将地址替换为志愿者所有回复
      this.$http.post('/zm/backManage/queryAllQuestionsByOpneid', this.dataSearch).then(function (res) {
        _this2.tableData = res.data.content;
        _this2.dataCount = res.data.pageTotal;
        _this2.pageSize = res.data.pageSize;
        _this2.tableLoading = false;
      }, function (err) {
        _this2.$Message.error("请求失败：" + err.message);
        _this2.tableLoading = false;
      });
    },
    getData: function getData() {
      var _this3 = this;

      //获取数据
      var data = this.$route.query.id; //志愿者的id
      /*获取志愿者的详细信息*/
      this.$http.post('/zm/backManage/queryVolunteerInfoDetail?id=' + data).then(function (res) {
        _this3.volunteers = res.data.content;
        console.log(_this3.volunteers);

        if (data) {
          _this3.dataSearch.content = { "id": data }; //修改传回去的参数
          /*获取这个志愿者回答的所有问题*/
          //TODO 将地址替换为志愿者所有回复
          _this3.$http.post('/zm/backManage/queryAllQuestionsByOpneid', _this3.dataSearch).then(function (res) {
            _this3.tableData = res.data.content;
            _this3.dataCount = res.data.pageTotal;
            _this3.pageSize = res.data.pageSize;
          }, function (err) {
            _this3.$Message.error("请求失败：" + err.message);
            _this3.tableLoading = false;
          });
        } else {
          _this3.$Message.error("该志愿者还未有回答！");
        }
      }, function (err) {
        _this3.$Message.error("请求失败：" + err.message);
        _this3.tableLoading = false;
      });
      /*获取志愿者回答和未回答的问题总数*/
      var openID = this.volunteers.openid;
      this.$http.post('/zm/backManage/queryVolunteerCount?openid=' + openID).then(function (res) {
        _this3.numbers = res.data.content;
      }, function (err) {
        _this3.$Message.error("请求失败：" + err.message);
        _this3.tableLoading = false;
      });
      this.resetAll();
    }
  },
  watch: {
    // "$route":"getData"
  },
  activated: function activated() {
    this.getData();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "Ju8e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//

exports.default = {
    name: "otherMaterial"
};

/***/ }),

/***/ "KB42":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KQWh":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('keep-alive', [_c('meta', {
    attrs: {
      "name": "referrer",
      "content": "no-referrer"
    }
  }), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "KX8I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "L739":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _vuedraggable = __webpack_require__("w/TU");

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

var _admin = __webpack_require__("4piF");

var _format = __webpack_require__("4/BI");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "newsManager",
    components: {
        draggable: _vuedraggable2.default
    },
    data: function data() {
        return {
            newsList: [],
            editable: false,
            isDragging: false,
            delayedDragging: false
        };
    },

    methods: {
        getName: function getName(num) {
            switch (num) {
                case 1:
                    return '公司新闻';
                case 2:
                    return '行业动态';
                case 3:
                    return '媒体报导';
                default:
                    return '无';
            }
        },
        transDate: function transDate(time) {
            return (0, _format.format2Sec)(time);
        },
        addNews: function addNews() {
            var active = 'editNewsInfo';
            var currentTag = localStorage.getItem('currentTag');
            if (currentTag !== active) {
                var tags = null;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(_admin.adminRouter), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var ele = _step.value;

                        if (ele.name === active) {
                            tags = {
                                title: ele.title,
                                name: ele.name,
                                path: ele.path
                            };
                            break;
                        } else {
                            if (ele.children.length) {
                                var _iteratorNormalCompletion2 = true;
                                var _didIteratorError2 = false;
                                var _iteratorError2 = undefined;

                                try {
                                    for (var _iterator2 = (0, _getIterator3.default)(ele.children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                        var val = _step2.value;

                                        if (val.name === active) {
                                            tags = {
                                                title: val.title,
                                                name: val.name,
                                                path: val.path
                                            };
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                            _iterator2.return();
                                        }
                                    } finally {
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                localStorage.setItem("currentTag", active);
                localStorage.setItem("newsId", '');
                this.$store.commit("updateCurrentTag", active);
                this.$store.commit("updateOpenedTags", [tags]);
                this.$store.commit("updateCurrentPath", active);
                this.$router.push({
                    name: active
                });
            }
        },
        showNewsInfo: function showNewsInfo(id) {
            var active = 'newsInfo';
            var currentTag = localStorage.getItem('currentTag');
            if (currentTag !== active) {
                var tags = null;
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = (0, _getIterator3.default)(_admin.adminRouter), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var ele = _step3.value;

                        if (ele.name === active) {
                            tags = {
                                title: ele.title,
                                name: ele.name,
                                path: ele.path
                            };
                            break;
                        } else {
                            if (ele.children.length) {
                                var _iteratorNormalCompletion4 = true;
                                var _didIteratorError4 = false;
                                var _iteratorError4 = undefined;

                                try {
                                    for (var _iterator4 = (0, _getIterator3.default)(ele.children), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                        var val = _step4.value;

                                        if (val.name === active) {
                                            tags = {
                                                title: val.title,
                                                name: val.name,
                                                path: val.path
                                            };
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError4 = true;
                                    _iteratorError4 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                            _iterator4.return();
                                        }
                                    } finally {
                                        if (_didIteratorError4) {
                                            throw _iteratorError4;
                                        }
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }

                localStorage.setItem("currentTag", active);
                localStorage.setItem("newsId", id);
                this.$store.commit("updateCurrentTag", active);
                this.$store.commit("updateOpenedTags", [tags]);
                this.$store.commit("updateCurrentPath", active);
                this.$router.push({
                    name: active
                });
            }
        },
        updateNewsInfo: function updateNewsInfo(id) {
            var active = 'editNewsInfo';
            var currentTag = localStorage.getItem('currentTag');
            if (currentTag !== active) {
                var tags = null;
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = (0, _getIterator3.default)(_admin.adminRouter), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var ele = _step5.value;

                        if (ele.name === active) {
                            tags = {
                                title: ele.title,
                                name: ele.name,
                                path: ele.path
                            };
                            break;
                        } else {
                            if (ele.children.length) {
                                var _iteratorNormalCompletion6 = true;
                                var _didIteratorError6 = false;
                                var _iteratorError6 = undefined;

                                try {
                                    for (var _iterator6 = (0, _getIterator3.default)(ele.children), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                        var val = _step6.value;

                                        if (val.name === active) {
                                            tags = {
                                                title: val.title,
                                                name: val.name,
                                                path: val.path
                                            };
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError6 = true;
                                    _iteratorError6 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                            _iterator6.return();
                                        }
                                    } finally {
                                        if (_didIteratorError6) {
                                            throw _iteratorError6;
                                        }
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }

                localStorage.setItem("currentTag", active);
                localStorage.setItem("newsId", id);
                this.$store.commit("updateCurrentTag", active);
                this.$store.commit("updateOpenedTags", [tags]);
                this.$store.commit("updateCurrentPath", active);
                this.$router.push({
                    name: active
                });
            }
        },
        newsUp: function newsUp(index) {
            this.newsList[index].active = 1;
            this.setData(this.newsList[index]);
        },
        newsDown: function newsDown(index) {
            this.newsList[index].active = 0;
            this.setData(this.newsList[index]);
        },
        deleteNews: function deleteNews(id, index) {
            var _this = this;

            this.$http.post('/zm/WMWebsite/deleteNewsInfos', { 'id': id }).then(function (res) {
                _this.$Message.success("成功删除！");
                _this.newsList.splice(index, 1);
            }, function (err) {
                _this.$Message.error("提交失败！" + err.message);
            });
        },
        setData: function setData(obj) {
            var _this2 = this;

            this.$http.post('/zm/WMWebsite/updateNewsInfos', obj).then(function (res) {}, function (err) {
                _this2.$Message.error("提交失败！" + err.message);
            });
        }
    },

    activated: function activated() {
        var _this3 = this;

        this.$http.get('/zm/WMWebsite/queryNewsInfos').then(function (res) {
            _this3.newsList = res.data.content;
        });
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "LRNV":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "count-container"
  }, [_c('h1', [_vm._v("总体数据")])])
}]}

/***/ }),

/***/ "LW0X":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("son6"),
  /* template */
  __webpack_require__("1eOD"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "LZ1c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M5Z/":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error404"
  }, [_c('div', {
    staticClass: "error404-body-con"
  }, [_c('Card', [_c('div', {
    staticClass: "error404-body-con-title"
  }, [_vm._v("4"), _c('span', [_c('Icon', {
    attrs: {
      "type": "ios-navigate-outline"
    }
  })], 1), _vm._v("4")]), _vm._v(" "), _c('p', {
    staticClass: "error404-body-con-message"
  }, [_vm._v("YOU  LOOK  LOST")]), _vm._v(" "), _c('div', {
    staticClass: "error404-btn-con"
  }, [_c('Button', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "size": "large",
      "type": "text"
    },
    on: {
      "click": _vm.goHome
    }
  }, [_vm._v("返回首页")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "width": "200px",
      "margin-left": "40px"
    },
    attrs: {
      "size": "large",
      "type": "primary"
    },
    on: {
      "click": _vm.backPage
    }
  }, [_vm._v("返回上一页")])], 1)])], 1)])
},staticRenderFns: []}

/***/ }),

/***/ "M93x":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("f87Q")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("N6Vm"),
  /* template */
  __webpack_require__("KQWh"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "MGgh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "N1/5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "productManager",
  data: function data() {
    return {
      formItem: {
        playerSrc: "", //视频地址
        posterSrc: "", //图片地址
        productTitle: "", //产品标题
        productId: "", //产品id
        appid: "", //软件有，硬件无
        productShortDescribe: "", //产品简介
        productDescribe: "" //产品描述
      },
      videoPath: [], //视频地址
      imgPath: [] //图片地址
    };
  },

  methods: {
    videoUploadSuccess: function videoUploadSuccess(res, file) {
      this.videoPath.push({ name: file.name, path: res.content });
    },
    //视频上传
    imgUploadSuccess: function imgUploadSuccess(res, file) {
      this.imgPath.push({ name: file.name, path: res.content });
    },
    //图片上传
    submitTotal: function submitTotal() {
      var _this = this;

      this.formItem.playerSrc = this.videoPath[this.videoPath.length - 1].path;
      this.formItem.posterSrc = this.imgPath[this.imgPath.length - 1].path;
      console.log(this.formItem);
      this.$http.post('/zm/WMWebsite/addProductInfo', this.formItem).then(function (res) {
        _this.$Message.success("上产成功！");
        _this.formItem = {
          playerSrc: "", //视频地址
          posterSrc: "", //图片地址
          productTitle: "", //产品标题
          productId: "", //产品id
          appid: "", //软件有，硬件无
          productShortDescribe: "", //产品简介
          productDescribe: "" //产品描述
        };
        _this.videoPath = [];
        _this.imgPath = [];
      }, function (err) {
        _this.$Message.error("上传失败！" + err.message);
      });
    }
  }
};

/***/ }),

/***/ "N6Vm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "app",
  mounted: function mounted() {
    //关闭时清空currentTag、openedTags;刷新时不处理
    window.onload = function () {
      if (!window.sessionStorage["tempFlag"]) {
        localStorage.removeItem("currentTag");
        localStorage.removeItem("openedTags");
        location.reload(); //不能省，强制跳到登陆页
      } else {
        window.sessionStorage.removeItem("tempFlag");
      }
    };
    window.onunload = function () {
      window.sessionStorage["tempFlag"] = true;
    };
    window.onbeforeunload = function () {
      sessionStorage.setItem("tempFlag", true);
    };
  }
};

/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _iview = __webpack_require__("BTaQ");

var _iview2 = _interopRequireDefault(_iview);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

__webpack_require__("+skl");

var _utils = __webpack_require__("0xDb");

var _utils2 = _interopRequireDefault(_utils);

var _store = __webpack_require__("IcnI");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 如果使用模块化机制编程，要调用 Vue.use()安装 Vue插件
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
_vue2.default.use(_iview2.default); //提供http请求


/**
 *fastclick消除在移动浏览器上触发click事件与一个物理Tap(敲击)之间的300延迟,chrome32+的meta头信息中设置width=device-width就不需用本插件
 *IE10可以用-ms-touch-action: manipulation，IE11 + 你可以设置 touch-action: manipulation，来禁用通过双击放大某些元素
 */

_vue2.default.config.productionTip = false;

/**
 * 路由的切换过程，本质上是执行一系列路由钩子函数,
 * 钩子函数总体上分为两大类:
 * 全局的钩子函数和组件的钩子函数
 * 全局钩子函数有2个
 * beforeEach：在路由切换开始时调用
 * afterEach：在每次路由切换成功进入激活阶段时被调用
 * next函数主要负责将控制权交给下一个中间件
 */
//全局导航守卫中检查元字段
//$route.matched是所有路由记录数组
//全局路由钩子，监听浏览器前进后退

_router2.default.beforeEach(function (to, from, next) {
  _iview2.default.LoadingBar.start();
  if (!_utils2.default.getCookie("uid")) {
    localStorage.setItem("isLogin", false);
  }
  if (to.matched.some(function (record) {
    return record.meta.requiresAuth;
  })) {
    var status = localStorage.getItem("isLogin"); /*是否登录*/
    if (status === "true") {
      if (localStorage.currentTag !== to.name) {
        localStorage.currentTag = to.name;
      }
      _store2.default.dispatch({
        type: "updateSession",
        isLogin: true,
        currentTag: localStorage.currentTag ? localStorage.currentTag : to.name,
        openedTags: localStorage.openedTags ? JSON.parse(localStorage.openedTags) : [_store2.default.state.openedTags[0]],
        currentPath: localStorage.currentTag ? localStorage.currentTag : to.name,
        submenuArr: localStorage.openedSubmenu ? JSON.parse(localStorage.openedSubmenu) : []
      });
      next();
    } else {
      /*没有获取到登录状态*/
      next({
        path: "/login",
        query: { redirect: to.fullPath } //查询参数
      });
    }
  } else {
    next();
  }
});
_router2.default.afterEach(function (to, from, next) {
  _iview2.default.LoadingBar.finish();
  window.scrollTo(0, 0);
});
/*
* 设置全局的 axios 默认值
* `baseURL` 将自动加在 `url` 前面，除非 `url` 是一个绝对 URL
* 它可以通过设置一个 `baseURL` 便于为 axios 实例的方法传递相对 URL
* `headers` 是即将被发送的自定义请求头
 */
_axios2.default.defaults.baseURL = "";
_axios2.default.defaults.headers.common['Authorization'] = "AUTH_TOKEN";
//全局添加 Vue 实例方法
_vue2.default.prototype.$http = _axios2.default;
new _vue2.default({
  el: "#app",
  router: _router2.default, //通过 router 配置参数注入路由,让整个应用都有路由功能
  store: _store2.default, //把 store 对象提供给 “store” 选项，这可以把 store 的实例注入所有的子组件
  // template: '<App/>',
  // components: { App }
  render: function render(h) {
    return h(_App2.default);
  },
  methods: {
    /* 检查是否存在session */
    checkLogin: function checkLogin() {
      if (!_utils2.default.getCookie("username")) {
        this.$router.push("/login");
      }
    }
  },
  //vue实例被创建之后执行
  created: function created() {
    // this.checkLogin();
  }
});

/***/ }),

/***/ "NlIO":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("tvui")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("JEoT"),
  /* template */
  __webpack_require__("J63L"),
  /* scopeId */
  "data-v-62482d97",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "NqMA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "O4Nb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _admin = __webpack_require__("4piF");

var _format = __webpack_require__("4/BI");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "webAppDetail",
    data: function data() {
        return {
            pageInfo: {},
            formItem: {},
            playerOptions: {},
            sortOrder: 0,
            imgList: []
        };
    },

    methods: {
        apkUploadSuccess: function apkUploadSuccess(res, file) {
            this.apkPath.push({ name: file.name, path: res.content });
        },
        videoUploadSuccess: function videoUploadSuccess(res, file) {
            this.videoPath.push({ name: file.name, path: res.content });
        },
        //视频上传
        imgUploadSuccess: function imgUploadSuccess(res, file) {
            this.imgPath.push({ name: file.name, path: res.content });
        },
        //图片上传
        editAppDetail: function editAppDetail(areaId, order) {
            var active = 'editWebAppDetail';
            var currentTag = localStorage.getItem('currentTag');
            if (currentTag !== active) {
                var tags = null;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(_admin.adminRouter), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var ele = _step.value;

                        if (ele.name === active) {
                            tags = {
                                title: ele.title,
                                name: ele.name,
                                path: ele.path
                            };
                            break;
                        } else {
                            if (ele.children.length) {
                                var _iteratorNormalCompletion2 = true;
                                var _didIteratorError2 = false;
                                var _iteratorError2 = undefined;

                                try {
                                    for (var _iterator2 = (0, _getIterator3.default)(ele.children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                        var val = _step2.value;

                                        if (val.name === active) {
                                            tags = {
                                                title: val.title,
                                                name: val.name,
                                                path: val.path
                                            };
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                            _iterator2.return();
                                        }
                                    } finally {
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                localStorage.setItem("currentTag", active);
                localStorage.setItem("areaId", areaId);
                localStorage.setItem("sortOrder", order);
                this.$store.commit("updateCurrentTag", active);
                this.$store.commit("updateOpenedTags", [tags]);
                this.$store.commit("updateCurrentPath", active);
                this.$router.push({
                    name: active
                });
            }
        }
    },

    watch: {},
    created: function created() {},
    activated: function activated() {
        var _this = this;

        this.formItem = {};
        var area = 'productInfoArea' + localStorage.getItem('areaId');
        var order = Number(localStorage.getItem('sortOrder'));
        this.sortOrder = order;
        this.$http.post('/zm/WMWebsite/queryProductInfos', {}).then(function (res) {
            var tempData = res.data.content;
            _this.formItem = tempData[area][order];
            if (_this.formItem.createDate) {
                _this.formItem.time = (0, _format.format2Sec)(_this.formItem.createDate);
            }
            _this.imgList = _this.formItem.posterSrc.split('分割');
            _this.formItem.appCategory = String(_this.formItem.appCategory);
        });
    }
};

/***/ }),

/***/ "OIt8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__("oFuF");

var _util2 = _interopRequireDefault(_util);

var _format = __webpack_require__("4/BI");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "blindUsers",
  data: function data() {
    var _this = this;

    return {
      nickNameSearch: "", //搜索框中的内容
      bindUsers: [], //盲人用户信息数组
      totalUser: "全部用户",
      // starUser:"星标用户",
      askNum: "提问数量",
      checkedBlindUser: [], //已经选中的盲人用户数组
      checkedDragUser: [], //选中的要拖出黑名单的用户数组
      blackList: [], //黑名单用户
      showEdit: false, //是否是可编辑状态
      columnsMain: [{
        type: 'selection',
        width: 40,
        align: 'center',
        title: '全部'
      }, {
        title: "头像",
        align: "center",
        render: function render(h, params) {
          return h('img', {
            attrs: {
              src: !params.row.avatarUrl ? "/static/avatar.jpg" : params.row.avatarUrl,
              onerror: 'javascript:this.src="/static/avatar.jpg"'
            },
            style: {
              width: "48px",
              height: "48px",
              margin: "5px",
              marginBottom: "0",
              borderRadius: "3px"
            }
          });
        }
      }, {
        title: "昵称",
        align: "center",
        key: "nickname"
      }, {
        title: "状态",
        key: "status",
        align: "center",
        render: function render(h, params) {
          return h('div', (0, _format.formatStatus)(params.row.status));
        }
      }, {
        title: "性别",
        key: "gender",
        align: "center",
        render: function render(h, params) {
          return h('div', (0, _format.formatSex)(params.row.gender));
        }
      }, {
        title: "省份",
        key: "province",
        align: "center"
      }, {
        title: "城市",
        key: "city",
        align: "center"
      }, {
        title: "备注",
        key: "remarks",
        align: "center",
        width: 100,
        render: function render(h, params) {
          if (params.row.$isEdit) {
            return h('input', {
              domProps: {
                value: params.row.remarks
              },
              style: {
                border: "none",
                width: "80px",
                lineHeight: "20px",
                textAlign: "center"
              },
              on: {
                input: function input(event) {
                  params.row.remarks = event.target.value;
                }
              }
            });
          } else {
            return h('div', params.row.remarks);
          }
        }
      }, {
        title: "编辑 / 保存",
        align: "center",
        width: 150,
        render: function render(h, params) {
          return h('Button', {
            props: {
              icon: "paintbrush",
              type: "primary"
            },
            style: {
              padding: "3px 8px",
              borderRadius: "20px",
              fontSize: "16px"
            },
            on: {
              click: function click(event) {
                if (params.row.$isEdit) {
                  _this.handleSave(params.row);
                } else {
                  _this.handleEdit(params.row);
                }
              }
            }
          }, params.row.$isEdit ? "保存" : "编辑");
        }
      }, {
        title: "详情",
        align: "center",
        render: function render(h, params) {
          return h('Button', {
            props: {
              type: "info"
            },
            on: {
              click: function click() {
                _this.functionA(); //转到详情页面
                _this.$router.push({
                  path: '/blindDetail',
                  query: {
                    id: _this.bindUsers[params.index].id,
                    openId: _this.bindUsers[params.index].openId
                  }
                });
              }
            }
          }, "详情");
        }
      }],
      dataCount: 0, //初始化信息总条数
      pageSize: 20, //每页条数
      dataCountBlack: 0, //黑名单初始化信息总条数
      pageSizeBlack: 20, //黑名单每页条数
      tableLoading: false, //表格是否加载
      dataSearch: { //请求的数据
        "code": 0,
        "content": {},
        "currPage": 1,
        "pageSize": 20,
        "pageTotal": 0
      },
      dataSearchBlack: { //黑名单请求的数据
        "code": 0,
        "content": {},
        "currPage": 1,
        "pageSize": 20,
        "pageTotal": 0
      }
    };
  },

  methods: {
    functionA: function functionA() {
      //调用menu-list的函数用于切换页面
      _util2.default.$emit('demo', 'blindDetail');
    },
    handleEdit: function handleEdit(row) {
      //编辑->修改
      this.$set(row, '$isEdit', true);
    },
    handleSave: function handleSave(row) {
      var _this2 = this;

      //保存修改
      this.$set(row, '$isEdit', false);
      this.$http.post('/zm/backManage/updateAskerDescr?id=' + row.id + '&remarks=' + row.remarks).then(function (res) {
        _this2.$Message.success("保存成功！");
      }, function (err) {
        _this2.$Message.error("保存失败" + err.message);
      });
    },
    searchName: function searchName() {
      var _this3 = this;

      //点击搜索框进行对昵称的搜索
      // console.log(this.nickNameSearch);
      this.dataSearch.content = {
        "nickname": this.nickNameSearch
      };
      this.$http.post('/zm/backManage/queryAskerInfoByPage', this.dataSearch).then(function (res) {
        _this3.bindUsers = res.data.content;
        _this3.dataCount = res.data.pageTotal;
        _this3.pageSize = res.data.pageSize;
        // console.log(res.data);
      }, function (err) {
        _this3.$Message.error("请求失败：" + err.message);
        _this3.tableLoading = false;
      });
    },
    searchBlackName: function searchBlackName() {
      this.dataSearchBlack.content = {
        "nickname": this.nickNameSearch,
        "status": 0
      };
      //获取黑名单
      this.getBlackList();
    },
    //黑名单内点击搜索框对昵称进行搜索
    handleSelectRow: function handleSelectRow() {
      //获取已经选中的盲人信息
      this.checkedBlindUser = this.$refs.select.getSelection();
    },
    handleSelectBlackRow: function handleSelectBlackRow() {
      //获取已经选中的黑名单中的盲人信息
      this.checkedDragUser = this.$refs.selection.getSelection();
    },
    changePage: function changePage(index) {
      var _this4 = this;

      //改变页数
      this.dataSearch.currPage = index;
      this.tableLoading = true;
      this.$http.post('/zm/backManage/queryAskerInfoByPage', this.dataSearch).then(function (res) {
        _this4.bindUsers = res.data.content;
        _this4.dataCount = res.data.pageTotal;
        _this4.pageSize = res.data.pageSize;
        _this4.tableLoading = false;
      }, function (err) {
        _this4.$Message.error("请求失败：" + err.message);
        _this4.tableLoading = false;
      });
    },
    changePageBlack: function changePageBlack(index) {
      //改变黑名单页数
      this.dataSearchBlack.currPage = index;
      this.dataSearchBlack.content = {
        "nickname": this.nickNameSearch,
        "status": 0
      };
      this.tableLoading = true;
      this.getBlackList();
    },
    putBlack: function putBlack() {
      var item = void 0;
      var flag = true;
      var msg = void 0;
      for (item in this.checkedBlindUser) {
        this.$http.post('/zm/backManage/addBlacklist?id=' + this.checkedBlindUser[item].id).then(function (res) {}, function (err) {
          flag = false;
          msg = err.data.content;
        });
      }
      if (flag) {
        this.$Message.success("加入黑名单成功!");
      } else {
        this.$Message.error(msg);
      }
      //获取黑名单
      this.dataSearchBlack.content = {
        "status": 0
      };
      this.getBlackList();
    },
    //加入黑名单
    dragBlack: function dragBlack() {
      //拖出黑名单
      var item = void 0;
      var flag = true;
      var msg = void 0;
      for (item in this.checkedDragUser) {
        this.$http.post('/zm/backManage/deleteBlacklist?id=' + this.checkedDragUser[item].id).then(function (res) {}, function (err) {
          flag = false;
          msg = err.data.content;
        });
      }
      if (flag) {
        this.$Message.success("解除黑名单成功!");
      } else {
        this.$Message.error(msg);
      }
      //获取黑名单
      this.dataSearchBlack.content = {
        "status": 0
      };
      this.getBlackList();
    },
    getBlackList: function getBlackList() {
      var _this5 = this;

      //获取黑名单
      this.$http.post('/zm/backManage/queryAskerInfoByPage', this.dataSearchBlack).then(function (res) {
        _this5.blackList = res.data.content;
        _this5.dataCountBlack = res.data.pageTotal;
        _this5.pageSizeBlack = res.data.pageSize;
        _this5.tableLoading = false;
      }, function (err) {
        _this5.$Message.error("请求失败：" + err.message);
        _this5.tableLoading = false;
      });
    },
    getData: function getData() {
      var _this6 = this;

      //加载页面时获取数据
      this.$http.post('/zm/backManage/queryAskerInfoByPage', this.dataSearch).then(function (res) {
        _this6.bindUsers = res.data.content;
        _this6.dataCount = res.data.pageTotal;
        _this6.pageSize = res.data.pageSize;
        // console.log(res.data);
      }, function (err) {
        _this6.$Message.error("请求失败：" + err.message);
        _this6.tableLoading = false;
      });
      //获取黑名单
      this.dataSearchBlack.content = {
        "status": 0
      };
      this.getBlackList();
    }
  },
  activated: function activated() {
    this.getData();
  },
  destroyed: function destroyed() {
    console.log("销毁了");
  },

  watch: {}
};

/***/ }),

/***/ "RGHt":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bg_02.e2335dc.jpg";

/***/ }),

/***/ "RTzJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Editor = __webpack_require__("v1aQ");

var _Editor2 = _interopRequireDefault(_Editor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'TablesEdit',
  components: { Editor: _Editor2.default },
  props: {
    value: [String, Number, Date],
    edittingCellId: String,
    params: Object,
    editable: Boolean,
    albumList: Array
  },
  data: function data() {
    return {
      formUrl: '',
      modal: false,
      loading2: false,
      formItem: {},
      ruleValidate: {
        title: [{ required: true, message: '不能为空', trigger: 'blur' }],
        /*author: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],*/
        album: [{ required: true, message: '请选择专辑', trigger: 'blur' }]
        /*content: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],*/
        /*time: [
          { required: true, type: 'date', message: '请选择日期', trigger: 'change' }
        ]*/
      }
    };
  },

  computed: {
    isEditting: function isEditting() {
      return this.edittingCellId === 'editting-' + this.params.index + '-' + this.params.column.key;
    },
    isTitle: function isTitle() {
      return this.params.column.key === 'title';
    },
    isDate: function isDate() {
      return this.params.column.key === 'time';
    },
    isAlbum: function isAlbum() {
      return this.params.column.key === 'album';
    }
  },
  methods: {
    editParams: function editParams() {
      this.modal = true;
    },
    handleInput: function handleInput(val) {
      this.$emit('input', val);
    },
    startEdit: function startEdit() {
      this.$emit('on-start-edit', this.params);
    },
    saveEdit: function saveEdit() {
      this.$emit('on-save-edit', this.params);
    },
    canceltEdit: function canceltEdit() {
      this.$emit('on-cancel-edit', this.params);
    },
    saveModalEdit: function saveModalEdit() {
      var _this = this;

      this.loading2 = true;
      setTimeout(function () {
        _this.loading2 = false;
        _this.$refs.formItem.validate(function (valid) {
          if (valid) {
            if (_this.formItem.content) {
              if (_this.formItem.content[1] !== 'p') {
                _this.formItem.content = '<p>' + _this.formItem.content + '</p>';
              }
            } else {
              _this.formItem.content = '<p>该文章内容暂未编辑</p>';
            }
            _this.formItem.updateTime = _this.formItem.time;
            _this.$emit('on-save-modal', _this.params);
            _this.modal = false;
          } else {
            _this.$Message.error('操作失败!');
          }
        });
      }, 1000);
    },
    cancelModalEdit: function cancelModalEdit() {
      this.$refs.formItem.resetFields();
      this.modal = false;
    },
    getContent: function getContent() {
      this.formUrl = this.formItem.url;
    }
  },

  created: function created() {
    this.formItem = this.params.row;
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "RfiY":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "min-width": "1100px"
    }
  }, [_c('p', {
    staticClass: "paraHead",
    staticStyle: {
      "font-size": "26px"
    }
  }, [_vm._v("志愿者用户详情")]), _vm._v(" "), _c('Card', {
    staticClass: "bodyCard"
  }, [_c('Row', {
    attrs: {
      "gutter": 64
    }
  }, [_c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "background-color": "#fff"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.volunteers.avatarUrl,
      "alt": "headUrl"
    }
  })])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "9"
    }
  }, [_c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("昵称:"), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.volunteers.nickname))])]), _vm._v(" "), _c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("加入时间:"), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.volunteers.createTime))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("回答数量:\n        "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    staticClass: "answerInfo"
  }, [_vm._v(_vm._s(_vm.numbers.answerNum))]), _vm._v("条")])]), _vm._v(" "), _c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("未回答数:\n        "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    staticClass: "answerInfo"
  }, [_vm._v(_vm._s(_vm.numbers.nonAnswerNum))]), _vm._v("条")])])])], 1)], 1), _vm._v(" "), _c('Card', {
    staticClass: "gradeCard"
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('Row', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('Col', [_c('p', {
    staticStyle: {
      "font-size": "18px",
      "text-align": "center"
    }
  }, [_vm._v("爱心积分\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.loveGrade) + "\n        ")])])], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "14px",
      "text-align": "center"
    }
  }, [_vm._v("平均积分\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.aveGrade) + "\n        ")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "14px",
      "text-align": "center"
    }
  }, [_vm._v("平均延时\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.aveDelay) + "\n        ")])])], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "100px",
      "width": "2px",
      "background-color": "#ccc",
      "border": "none"
    }
  })]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('Row', [_c('p', {
    staticStyle: {
      "font-size": "18px",
      "text-align": "center"
    }
  }, [_vm._v("服务积分\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.serveGrade) + "\n        ")])]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1%"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "14px",
      "text-align": "center"
    }
  }, [_vm._v("平均积分\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.serveAveGrade) + "\n        ")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "1"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "100px",
      "width": "2px",
      "background-color": "#ccc",
      "border": "none"
    }
  })]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('Row', [_c('p', {
    staticStyle: {
      "font-size": "18px",
      "text-align": "center"
    }
  }, [_vm._v("时间银行\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.timebank) + "s\n        ")])]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1%"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "14px",
      "text-align": "center"
    }
  }, [_vm._v("平均耗时\n          "), _c('br'), _vm._v("\n          " + _vm._s(_vm.avetime) + "\n        ")])])], 1)], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "paraHead",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("回答历史")]), _vm._v(" "), _c('Tabs', {
    staticStyle: {
      "margin": "25px",
      "width": "95%"
    },
    attrs: {
      "value": "totalMessage"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "全部消息",
      "name": "totalMessage"
    }
  }, [_c('table', {
    staticClass: "fourDiv"
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "width": "25%"
    }
  }, [_c('div', {
    staticClass: "innerDiv"
  }, [_c('div', {
    staticClass: "divHead"
  }, [_vm._v("\n                时间\n              ")]), _vm._v(" "), _c('Button', {
    staticClass: "btn",
    staticStyle: {
      "border": "none",
      "background-color": "rgb(245,247,249)"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getAllTime.apply(null, arguments)
      }
    }
  }, [_c('Radio', {
    staticStyle: {
      "font-size": "14px",
      "margin": "5% 0 5% -20%"
    },
    on: {
      "on-change": function($event) {}
    },
    model: {
      value: (_vm.totalTime),
      callback: function($$v) {
        _vm.totalTime = $$v
      },
      expression: "totalTime"
    }
  }, [_vm._v("所有时间")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("最近 "), _c('span', [_c('Select', {
    staticStyle: {
      "width": "60%"
    },
    model: {
      value: (_vm.recentTime),
      callback: function($$v) {
        _vm.recentTime = $$v
      },
      expression: "recentTime"
    }
  }, _vm._l((_vm.timeList), function(timer) {
    return _c('Option', {
      key: timer.value,
      attrs: {
        "value": timer.value
      }
    }, [_vm._v(_vm._s(timer.label))])
  }), 1)], 1)]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "80%",
      "margin": "5%"
    },
    attrs: {
      "type": "date",
      "placeholder": "起始时间"
    },
    model: {
      value: (_vm.fromTime),
      callback: function($$v) {
        _vm.fromTime = $$v
      },
      expression: "fromTime"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "16px",
      "margin-left": "-70%"
    }
  }, [_vm._v("至")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "80%",
      "margin": "5%"
    },
    attrs: {
      "type": "date",
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.toTime),
      callback: function($$v) {
        _vm.toTime = $$v
      },
      expression: "toTime"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0 -50% 3% 0"
    }
  }, [_vm._v("设为默认 "), _c('i-switch', {
    on: {
      "on-change": _vm.change1
    },
    model: {
      value: (_vm.switch1),
      callback: function($$v) {
        _vm.switch1 = $$v
      },
      expression: "switch1"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center",
      "width": "25%"
    }
  }, [_c('div', {
    staticClass: "innerDiv"
  }, [_c('div', {
    staticClass: "divHead"
  }, [_vm._v("\n                盲人评分\n              ")]), _vm._v(" "), _c('Button', {
    staticClass: "btn",
    staticStyle: {
      "border": "none",
      "background-color": "rgb(245,247,249)"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getAllRate.apply(null, arguments)
      }
    }
  }, [_c('Radio', {
    staticStyle: {
      "font-size": "14px",
      "margin": "5% 0 5% -50%"
    },
    model: {
      value: (_vm.totalRate),
      callback: function($$v) {
        _vm.totalRate = $$v
      },
      expression: "totalRate"
    }
  }, [_vm._v("所有评分")])], 1), _vm._v(" "), _c('CheckboxGroup', {
    model: {
      value: (_vm.rateArr),
      callback: function($$v) {
        _vm.rateArr = $$v
      },
      expression: "rateArr"
    }
  }, [_c('Checkbox', {
    staticClass: "pInCheck",
    attrs: {
      "label": "5星"
    }
  }, [_c('Rate', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.rate5),
      callback: function($$v) {
        _vm.rate5 = $$v
      },
      expression: "rate5"
    }
  })], 1), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    attrs: {
      "label": "4星"
    }
  }, [_c('Rate', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.rate4),
      callback: function($$v) {
        _vm.rate4 = $$v
      },
      expression: "rate4"
    }
  })], 1), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    attrs: {
      "label": "3星"
    }
  }, [_c('Rate', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.rate3),
      callback: function($$v) {
        _vm.rate3 = $$v
      },
      expression: "rate3"
    }
  })], 1), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    attrs: {
      "label": "2星"
    }
  }, [_c('Rate', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.rate2),
      callback: function($$v) {
        _vm.rate2 = $$v
      },
      expression: "rate2"
    }
  })], 1), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    attrs: {
      "label": "1星"
    }
  }, [_c('Rate', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.rate1),
      callback: function($$v) {
        _vm.rate1 = $$v
      },
      expression: "rate1"
    }
  })], 1), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    attrs: {
      "label": "0星"
    }
  }, [_vm._v("未评价")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "4% -50% 3% 0"
    }
  }, [_vm._v("设为默认 "), _c('i-switch', {
    on: {
      "on-change": _vm.change2
    },
    model: {
      value: (_vm.switch2),
      callback: function($$v) {
        _vm.switch2 = $$v
      },
      expression: "switch2"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center",
      "width": "25%"
    }
  }, [_c('div', {
    staticClass: "innerDiv"
  }, [_c('div', {
    staticClass: "divHead"
  }, [_vm._v("\n                当前进度\n              ")]), _vm._v(" "), _c('Button', {
    staticClass: "btn",
    staticStyle: {
      "border": "none",
      "background-color": "rgb(245,247,249)"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getAllProcess.apply(null, arguments)
      }
    }
  }, [_c('Radio', {
    staticStyle: {
      "font-size": "14px",
      "margin": "5% 0 5% -20%"
    },
    model: {
      value: (_vm.totalProcess),
      callback: function($$v) {
        _vm.totalProcess = $$v
      },
      expression: "totalProcess"
    }
  }, [_vm._v("所有进度")])], 1), _vm._v(" "), _c('CheckboxGroup', {
    model: {
      value: (_vm.processArr),
      callback: function($$v) {
        _vm.processArr = $$v
      },
      expression: "processArr"
    }
  }, [_c('Checkbox', {
    staticClass: "pInCheck",
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "label": "zero"
    }
  }, [_vm._v(" 0人回复")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "label": "twenty"
    }
  }, [_vm._v(" 25%回复")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "label": "fifty"
    }
  }, [_vm._v(" 50%回复")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "label": "seventy"
    }
  }, [_vm._v(" 75%回复")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "label": "hundred"
    }
  }, [_vm._v(" 100%回复")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "label": "manager"
    }
  }, [_vm._v(" 已有管理员回复")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "2% -50% 2% 0"
    }
  }, [_vm._v("设为默认 "), _c('i-switch', {
    on: {
      "on-change": _vm.change3
    },
    model: {
      value: (_vm.switch3),
      callback: function($$v) {
        _vm.switch3 = $$v
      },
      expression: "switch3"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center",
      "width": "25%"
    }
  }, [_c('div', {
    staticClass: "innerDiv"
  }, [_c('div', {
    staticClass: "divHead"
  }, [_vm._v("\n                求助方式\n              ")]), _vm._v(" "), _c('CheckboxGroup', {
    model: {
      value: (_vm.wayArr),
      callback: function($$v) {
        _vm.wayArr = $$v
      },
      expression: "wayArr"
    }
  }, [_c('Checkbox', {
    staticClass: "pInCheck",
    staticStyle: {
      "margin-top": "10%"
    },
    attrs: {
      "label": "picAndWord"
    }
  }, [_vm._v("图片 + 文字")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    staticStyle: {
      "margin-top": "10%"
    },
    attrs: {
      "label": "picAndVoice"
    }
  }, [_vm._v("图片 + 语音")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "width": "80%",
      "margin": "10% auto",
      "border": "1px solid #CCCCCC"
    }
  }), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    attrs: {
      "label": "shortVideo"
    }
  }, [_vm._v("短视频")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "7% -50% 2% 0"
    }
  }, [_vm._v("设为默认 "), _c('i-switch', {
    on: {
      "on-change": _vm.change4
    },
    model: {
      value: (_vm.switch4),
      callback: function($$v) {
        _vm.switch4 = $$v
      },
      expression: "switch4"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('hr', {
    staticStyle: {
      "width": "98%",
      "margin": "1% auto",
      "border": "1px solid #CCCCCC"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('Button', {
    staticStyle: {
      "width": "5%",
      "margin": "0 1% 1% 0"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetAll.apply(null, arguments)
      }
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "width": "5%",
      "margin": "0 0 1% 1%"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.searchQus.apply(null, arguments)
      }
    }
  }, [_vm._v("筛选")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "searchCard"
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-left": "40%",
      "margin-top": "1%"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.searchItem.apply(null, arguments)
      }
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "10"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "text",
      "placeholder": "问题关键字",
      "clearable": ""
    },
    on: {
      "on-change": _vm.summaryChange,
      "on-enter": _vm.searchItem
    },
    model: {
      value: (_vm.vitalWord),
      callback: function($$v) {
        _vm.vitalWord = $$v
      },
      expression: "vitalWord"
    }
  }, [_c('Button', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "slot": "append",
      "icon": "close-circled"
    },
    on: {
      "click": _vm.clearInputInfo
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Table', {
    staticClass: "mainTable",
    attrs: {
      "stripe": "",
      "columns": _vm.columns,
      "data": _vm.tableData
    }
  }), _vm._v(" "), _c('Page', {
    staticClass: "paging",
    attrs: {
      "total": _vm.dataCount,
      "page-size": _vm.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "已标记的求助",
      "name": "remarkedMessage"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "RgbG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _vuedraggable = __webpack_require__("w/TU");

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

var _admin = __webpack_require__("4piF");

var _format = __webpack_require__("4/BI");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: "webAPP",
    components: {
        draggable: _vuedraggable2.default
    },
    data: function data() {
        return {
            productInfo: {},
            productInfoArea1: [],
            productInfoArea2: [],
            productInfoArea3: [],
            editable: false,
            isDragging: false,
            delayedDragging: false
        };
    },

    methods: {
        transDate: function transDate(time) {
            return (0, _format.format2Sec)(time);
        },
        orderList: function orderList() {
            this.productInfoArea1 = this.productInfo.productInfoArea1;
            this.productInfoArea2 = this.productInfo.productInfoArea2;
            this.productInfoArea3 = this.productInfo.productInfoArea3;
        },
        onMove: function onMove(_ref) {
            var relatedContext = _ref.relatedContext,
                draggedContext = _ref.draggedContext;

            var relatedElement = relatedContext.element;
            var draggedElement = draggedContext.element;
            return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed;
        },
        openDrag: function openDrag() {
            this.editable = true;
        },
        completeDrag: function completeDrag() {
            var _this = this;

            this.editable = false;
            for (var i = 1; i <= 3; i++) {
                this.changeOrder(this['productInfoArea' + i], i);
                this['productInfoArea' + i].forEach(function (item) {
                    _this.setData(item);
                });
            }
            this.$Message.success('完成排序！');
        },
        changeOrder: function changeOrder(list, area) {
            list.map(function (item, index) {
                item.areaId = area;
                item.sortId = index + 1;
                return item;
            });
        },
        createApp: function createApp(areaId, length) {
            var active = 'editWebAppDetail';
            var currentTag = localStorage.getItem('currentTag');
            if (currentTag !== active) {
                var tags = null;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(_admin.adminRouter), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var ele = _step.value;

                        if (ele.name === active) {
                            tags = {
                                title: ele.title,
                                name: ele.name,
                                path: ele.path
                            };
                            break;
                        } else {
                            if (ele.children.length) {
                                var _iteratorNormalCompletion2 = true;
                                var _didIteratorError2 = false;
                                var _iteratorError2 = undefined;

                                try {
                                    for (var _iterator2 = (0, _getIterator3.default)(ele.children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                        var val = _step2.value;

                                        if (val.name === active) {
                                            tags = {
                                                title: val.title,
                                                name: val.name,
                                                path: val.path
                                            };
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                            _iterator2.return();
                                        }
                                    } finally {
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                localStorage.setItem("currentTag", active);
                localStorage.setItem("areaId", areaId);
                localStorage.setItem("sortOrder", '');
                localStorage.setItem("length", length);
                this.$store.commit("updateCurrentTag", active);
                this.$store.commit("updateOpenedTags", [tags]);
                this.$store.commit("updateCurrentPath", active);
                this.$router.push({
                    name: active
                });
            }
        },
        showAppDetail: function showAppDetail(areaId, order) {
            var active = 'webAppDetail';
            var currentTag = localStorage.getItem('currentTag');
            if (currentTag !== active) {
                var tags = null;
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = (0, _getIterator3.default)(_admin.adminRouter), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var ele = _step3.value;

                        if (ele.name === active) {
                            tags = {
                                title: ele.title,
                                name: ele.name,
                                path: ele.path
                            };
                            break;
                        } else {
                            if (ele.children.length) {
                                var _iteratorNormalCompletion4 = true;
                                var _didIteratorError4 = false;
                                var _iteratorError4 = undefined;

                                try {
                                    for (var _iterator4 = (0, _getIterator3.default)(ele.children), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                        var val = _step4.value;

                                        if (val.name === active) {
                                            tags = {
                                                title: val.title,
                                                name: val.name,
                                                path: val.path
                                            };
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError4 = true;
                                    _iteratorError4 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                            _iterator4.return();
                                        }
                                    } finally {
                                        if (_didIteratorError4) {
                                            throw _iteratorError4;
                                        }
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }

                localStorage.setItem("currentTag", active);
                localStorage.setItem("areaId", areaId);
                localStorage.setItem("sortOrder", order);
                this.$store.commit("updateCurrentTag", active);
                this.$store.commit("updateOpenedTags", [tags]);
                this.$store.commit("updateCurrentPath", active);
                this.$router.push({
                    name: active
                });
            }
        },
        updateApp: function updateApp(areaId, order) {
            var active = 'editWebAppDetail';
            var currentTag = localStorage.getItem('currentTag');
            if (currentTag !== active) {
                var tags = null;
                var _iteratorNormalCompletion5 = true;
                var _didIteratorError5 = false;
                var _iteratorError5 = undefined;

                try {
                    for (var _iterator5 = (0, _getIterator3.default)(_admin.adminRouter), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                        var ele = _step5.value;

                        if (ele.name === active) {
                            tags = {
                                title: ele.title,
                                name: ele.name,
                                path: ele.path
                            };
                            break;
                        } else {
                            if (ele.children.length) {
                                var _iteratorNormalCompletion6 = true;
                                var _didIteratorError6 = false;
                                var _iteratorError6 = undefined;

                                try {
                                    for (var _iterator6 = (0, _getIterator3.default)(ele.children), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                        var val = _step6.value;

                                        if (val.name === active) {
                                            tags = {
                                                title: val.title,
                                                name: val.name,
                                                path: val.path
                                            };
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError6 = true;
                                    _iteratorError6 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                            _iterator6.return();
                                        }
                                    } finally {
                                        if (_didIteratorError6) {
                                            throw _iteratorError6;
                                        }
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError5 = true;
                    _iteratorError5 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion5 && _iterator5.return) {
                            _iterator5.return();
                        }
                    } finally {
                        if (_didIteratorError5) {
                            throw _iteratorError5;
                        }
                    }
                }

                localStorage.setItem("currentTag", active);
                localStorage.setItem("areaId", areaId);
                localStorage.setItem("sortOrder", order);
                this.$store.commit("updateCurrentTag", active);
                this.$store.commit("updateOpenedTags", [tags]);
                this.$store.commit("updateCurrentPath", active);
                this.$router.push({
                    name: active
                });
            }
        },
        appUp: function appUp(areaId, order) {
            var tempObj = this['productInfoArea' + areaId][order];
            tempObj.active = 1;
            this.setData(tempObj);
        },
        appDown: function appDown(areaId, order) {
            var tempObj = this['productInfoArea' + areaId][order];
            tempObj.active = 0;
            this.setData(tempObj);
        },
        deleteApp: function deleteApp(areaId, order) {
            var _this2 = this;

            var id = this['productInfoArea' + areaId][order].id;
            this.$http.post('/zm/WMWebsite/deleteProductInfo', { 'id': id }).then(function (res) {
                _this2.$Message.success("成功删除！");
                _this2['productInfoArea' + areaId].splice(order, 1);
                _this2.changeOrder(_this2['productInfoArea' + areaId], areaId);
                _this2['productInfoArea' + areaId].forEach(function (item) {
                    _this2.setData(item);
                });
            }, function (err) {
                _this2.$Message.error("提交失败！" + err.message);
            });
        },
        setData: function setData(obj) {
            var _this3 = this;

            this.$http.post('/zm/WMWebsite/updateProductInfo', obj).then(function (res) {}, function (err) {
                _this3.$Message.error("提交失败！" + err.message);
            });
        }
    },
    computed: {
        dragOptions: function dragOptions() {
            return {
                animation: 0,
                group: "description",
                disabled: !this.editable,
                ghostClass: "ghost"
            };
        }
    },
    watch: {
        isDragging: function isDragging(newValue) {
            var _this4 = this;

            if (newValue) {
                this.delayedDragging = true;
                return;
            }
            this.$nextTick(function () {
                _this4.delayedDragging = false;
            });
        }
    },

    activated: function activated() {
        var _this5 = this;

        this.$http.post('/zm/WMWebsite/queryProductInfos', {}).then(function (res) {
            var tempData = res.data.content;
            _this5.productInfo = tempData;
            for (var i = 1; i <= 3; i++) {
                _this5['productInfoArea' + i] = tempData['productInfoArea' + i];
            }
        });
    }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "RhdG":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "min-width": "900px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "26px",
      "display": "inline-block",
      "cursor": "pointer"
    }
  }, [_vm._v("产品管理")]), _vm._v(" "), _c('div', {
    staticClass: "formStyle"
  }, [_c('p', {
    staticClass: "formTitle"
  }, [_vm._v("产品详情填写")]), _vm._v(" "), _c('Form', {
    staticStyle: {
      "padding": "20px"
    },
    attrs: {
      "model": _vm.formItem,
      "label-width": 100
    }
  }, [_c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("视频上传")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Upload', {
    attrs: {
      "multiple": "",
      "type": "drag",
      "action": "/zm/cos/upload",
      "format": ['mp4'],
      "on-success": _vm.videoUploadSuccess
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 20px"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#3399ff"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "52"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click or drag videos here to upload")])], 1)])], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("视频地址")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('ul', _vm._l((_vm.videoPath), function(value, index) {
    return _c('li', {
      staticStyle: {
        "font-size": "1rem"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "dodgerblue"
      }
    }, [_vm._v(_vm._s(value.name))]), _vm._v(" " + _vm._s(value.path) + "\n              ")])
  }), 0)])], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("图片上传")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Upload', {
    attrs: {
      "multiple": "",
      "type": "drag",
      "action": "/zm/cos/upload",
      "format": ['jpg', 'jpeg', 'png'],
      "on-success": _vm.imgUploadSuccess
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 20px"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#3399ff"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "52"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click or drag images here to upload")])], 1)])], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("图片地址")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('ul', _vm._l((_vm.imgPath), function(value, index) {
    return _c('li', {
      staticStyle: {
        "font-size": "1rem"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "dodgerblue"
      }
    }, [_vm._v(_vm._s(value.name))]), _vm._v(" " + _vm._s(value.path) + "\n              ")])
  }), 0)])], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品名称")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入产品名称..."
    },
    model: {
      value: (_vm.formItem.productTitle),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productTitle", $$v)
      },
      expression: "formItem.productTitle"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品id")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入产品id..."
    },
    model: {
      value: (_vm.formItem.productId),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productId", $$v)
      },
      expression: "formItem.productId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品appid")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "软件有，硬件无.."
    },
    model: {
      value: (_vm.formItem.appid),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "appid", $$v)
      },
      expression: "formItem.appid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品简介")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入产品简介..."
    },
    model: {
      value: (_vm.formItem.productShortDescribe),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productShortDescribe", $$v)
      },
      expression: "formItem.productShortDescribe"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("详情")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 4,
        maxRows: 8
      },
      "placeholder": "请输入产品详情..."
    },
    model: {
      value: (_vm.formItem.productDescribe),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productDescribe", $$v)
      },
      expression: "formItem.productDescribe"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-right": "20%"
    },
    attrs: {
      "type": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitTotal.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ "RiA/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _icon = __webpack_require__("EMb8");

var _icon2 = _interopRequireDefault(_icon);

var _assist = __webpack_require__("9Xvl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//

var prefixCls = 'ivu-btn';

exports.default = {
    name: 'Button',
    components: { Icon: _icon2.default },
    props: {
        type: {
            validator: function validator(value) {
                return (0, _assist.oneOf)(value, ['primary', 'ghost', 'dashed', 'text', 'info', 'success', 'warning', 'error', 'default']);
            }
        },
        shape: {
            validator: function validator(value) {
                return (0, _assist.oneOf)(value, ['circle', 'circle-outline']);
            }
        },
        size: {
            validator: function validator(value) {
                return (0, _assist.oneOf)(value, ['small', 'large', 'default']);
            }
        },
        loading: Boolean,
        disabled: Boolean,
        htmlType: {
            default: 'button',
            validator: function validator(value) {
                return (0, _assist.oneOf)(value, ['button', 'submit', 'reset']);
            }
        },
        icon: String,
        long: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            showSlot: true
        };
    },

    computed: {
        classes: function classes() {
            var _ref;

            return ['' + prefixCls, (_ref = {}, (0, _defineProperty3.default)(_ref, prefixCls + '-' + this.type, !!this.type), (0, _defineProperty3.default)(_ref, prefixCls + '-long', this.long), (0, _defineProperty3.default)(_ref, prefixCls + '-' + this.shape, !!this.shape), (0, _defineProperty3.default)(_ref, prefixCls + '-' + this.size, !!this.size), (0, _defineProperty3.default)(_ref, prefixCls + '-loading', this.loading != null && this.loading), (0, _defineProperty3.default)(_ref, prefixCls + '-icon-only', !this.showSlot && (!!this.icon || this.loading)), _ref)];
        }
    },
    methods: {
        handleClick: function handleClick(event) {
            this.$emit('click', event);
        }
    },
    mounted: function mounted() {
        this.showSlot = this.$slots.default !== undefined;
    }
};

/***/ }),

/***/ "SC4N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _button = __webpack_require__("gMJu");

var _button2 = _interopRequireDefault(_button);

var _format = __webpack_require__("4/BI");

var _checkbox = __webpack_require__("56XX");

var _checkbox2 = _interopRequireDefault(_checkbox);

var _card = __webpack_require__("t2zW");

var _card2 = _interopRequireDefault(_card);

var _admin = __webpack_require__("4piF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    Card: _card2.default,
    Checkbox: _checkbox2.default,
    Button: _button2.default
  },
  name: "helpMessage",
  data: function data() {
    var _this = this;

    return {
      helpMessage: [], //后台传入的信息
      vitalInfo: "", //搜索框求助内容
      vitalNick: "", //搜索框盲人昵称
      askWay: "", //求助方式
      source: "", //用户来源
      checkWay: [],
      askWayArr: [{
        key: 0,
        content: "全选"
      }, {
        key: 1,
        content: "图片+文字"
      }, {
        key: 2,
        content: "图片+语音"
      }, {
        key: 3,
        content: "短视频"
      }, {
        key: 4,
        content: "实时视频"
      }],
      checkedTime: "" /*选择的时间*/
      , checkedHelpMessage: [], //已经选中的项目
      tableLoading: true, //加载状态
      helpContent: "", //求助内容
      blindNick: "", //盲人昵称
      filterInfo: {
        code: 0,
        channel: 0, //求助途径
        content: {}, //求助内容
        currPage: 1 //当前页
      },
      pageSize: 20, //每页显示条数
      pageTotal: 0,
      currPage: 1,
      columns1: [{
        type: "selection",
        width: 60,
        align: "center"
      }, {
        title: "Id",
        key: "id"
      }, {
        title: "求助时间",
        key: "createTime",
        width: 150,
        sortable: true,
        render: function render(h, params) {
          return h("div", (0, _format.format)(params.row.createTime, "yyyy-MM-dd hh:mm"));
        }
      }, {
        title: "求助方式",
        key: "status",
        width: 120,
        render: function render(h, params) {
          var content = "";
          switch (params.row.status) {
            case 1:
              content = "文字+图片";
              break;
            case 2:
              content = "图片+语音";
              break;
            case 3:
              content = "短视频";
              break;
            case 4:
              content = "实时视频";
              break;
            default:
              content = "未知";
              break;
          }
          return h("div", content);
        }
      }, {
        title: "盲人昵称",
        key: "nickname"
      }, {
        title: "问题缩略",
        key: "helpText",
        width: 200,
        render: function render(h, params) {
          return h("div", params.row.helpText ? params.row.helpText.length > 20 ? params.row.helpText.substr(0, 20) + "..." : params.row.helpText : "");
        }
      }, {
        title: "问题来源",
        key: "device",
        render: function render(h, params) {
          return h("div", params.row.channel === 1 ? "启明瞳app" : "启明瞳小程序");
        }
      }, {
        title: "详情",
        render: function render(h, params) {
          return h("Button", {
            props: {
              type: "primary",
              icon: "ios-arrow-right"
            },
            style: {
              border: "none",
              fontSize: "20px"
            },
            on: {
              click: function click() {
                var id = parseInt(_this.helpMessage[params.index].id);
                var helpInfo = {};
                var offerHelpInfos = [];
                _this.$http.post("/zm/help/getQuestionAndAnswer", { "id": id }).then(function (res) {
                  helpInfo = res.data.content.helpInfo;
                  offerHelpInfos = res.data.content.offerHelpInfos;
                  if (!helpInfo.openid) {
                    _this.$Message.error("获取信息失败");
                    return;
                  }
                  var active = "helpMessageDetail"; //下个版本更新url
                  _this.$http.post("/zm/backManage/queryAllQuestionsByOpenid", { "content": {}, "openid": helpInfo.openid }).then(function (res) {
                    if (_this.currentTag !== active) {
                      var tags = null;
                      var _iteratorNormalCompletion = true;
                      var _didIteratorError = false;
                      var _iteratorError = undefined;

                      try {
                        for (var _iterator = (0, _getIterator3.default)(_admin.adminRouter), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                          var ele = _step.value;

                          if (ele.name === active) {
                            tags = {
                              title: ele.title,
                              name: ele.name,
                              path: ele.path
                            };
                            break;
                          } else {
                            if (ele.children.length) {
                              var _iteratorNormalCompletion2 = true;
                              var _didIteratorError2 = false;
                              var _iteratorError2 = undefined;

                              try {
                                for (var _iterator2 = (0, _getIterator3.default)(ele.children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                  var val = _step2.value;

                                  if (val.name === active) {
                                    tags = {
                                      title: val.title,
                                      name: val.name,
                                      path: val.path
                                    };
                                    break;
                                  }
                                }
                              } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                              } finally {
                                try {
                                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                  }
                                } finally {
                                  if (_didIteratorError2) {
                                    throw _iteratorError2;
                                  }
                                }
                              }
                            }
                          }
                        }
                      } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                          }
                        } finally {
                          if (_didIteratorError) {
                            throw _iteratorError;
                          }
                        }
                      }

                      localStorage.setItem("currentTag", active);
                      _this.$store.commit("updateCurrentTag", active);
                      _this.$store.commit("updateOpenedTags", [tags]);
                      _this.$store.commit("updateCurrentPath", active);
                      (0, _assign2.default)(helpInfo, res);
                      _this.$router.push({
                        name: "helpMessageDetail",
                        params: {
                          "helpInfo": helpInfo,
                          "offerHelpInfos": offerHelpInfos
                        }
                      });
                    }
                  }, function (err) {
                    _this.$Message.error("请求失败：" + err.message);
                  });
                }, function (err) {
                  _this.$Message.error("请求失败：" + err.message);
                });
              }
            }
          });
        }
      }]
    };
  },
  created: function created() {
    var _this2 = this;

    this.$data.tableLoading = true;
    this.$http.post("/zm/backManage/queryHelpInfoByPage", this.filterInfo).then(function (res) {
      _this2.helpMessage = res.data.content;
      _this2.pageTotal = res.data.pageTotal;
      _this2.$data.tableLoading = false;
    }, function (err) {
      _this2.$Message.error("请求失败：" + err.message);
      _this2.$data.tableLoading = false;
    });
  },
  mounted: function mounted() {},

  methods: {
    /**
     * 选择时间
     */
    dateTimeChange: function dateTimeChange() {
      if (this.checkedTime[0] !== "") {
        this.filterInfo.content.startTime = Math.floor(this.checkedTime[0].getTime() / 1000);
        this.filterInfo.content.endTime = Math.floor(this.checkedTime[1].getTime() / 1000);
      } else {
        delete this.filterInfo.content["startTime"];
        delete this.filterInfo.content["endTime"];
      }
    },

    /**
     * 清空时间
     */
    dateTimeClear: function dateTimeClear() {
      delete this.filterInfo.content["startTime"];
      delete this.filterInfo.content["endTime"];
    },

    /**
     * 选择求助来源
     */
    sourceChange: function sourceChange() {
      if (this.source === "0") {
        delete this.filterInfo.content["channel"];
      } else {
        this.filterInfo.content.channel = this.source;
      }
    },

    /**
     * 求助方式
     */
    askWayChange: function askWayChange() {
      if (this.askWay === 0) {
        delete this.filterInfo.content["askWay"];
      } else {
        this.filterInfo.content.askWay = this.askWay;
      }
    },

    /**
     * 筛选、搜索
     */
    search: function search() {
      var _this3 = this;

      this.tableLoading = true;
      this.filterInfo.currPage = 1;
      this.currPage = 1;
      console.log((0, _stringify2.default)(this.filterInfo));
      this.$http.post("/zm/backManage/queryHelpInfoByPage", this.filterInfo).then(function (res) {
        _this3.helpMessage = res.data.content;
        _this3.pageTotal = res.data.pageTotal;
        _this3.$data.tableLoading = false;
      }, function (err) {
        _this3.$Message.error("请求失败：" + err.message);
        _this3.$data.tableLoading = false;
      });
    },

    /**
     * 输入求助内容
     */
    helpContentChange: function helpContentChange(e) {
      if (this.helpContent === "") {
        delete this.filterInfo.content["helpText"];
      } else {
        this.filterInfo.content.helpText = this.helpContent;
      }
    },

    /**
     * 输入盲人昵称
     */
    blindNickChange: function blindNickChange() {
      if (this.blindNick === "") {
        delete this.filterInfo.content["nickname"];
      } else {
        this.filterInfo.content.nickname = this.blindNick;
      }
    },
    handleSelectRow: function handleSelectRow() {
      //获取已经选中的项目
      this.checkedHelpMessage = this.$refs.selection.getSelection();
    },

    //翻页
    pageChange: function pageChange(page) {
      var _this4 = this;

      this.tableLoading = true;
      this.filterInfo.currPage = page;
      this.currPage = page;
      this.$http.post("/zm/backManage/queryHelpInfoByPage", this.filterInfo).then(function (res) {
        _this4.helpMessage = res.data.content;
        _this4.pageTotal = res.data.pageTotal;
        _this4.tableLoading = false;
      }, function (err) {
        _this4.$Message.error("请求失败：" + err.message);
        _this4.tableLoading = false;
      });
    }
  },

  filters: {}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "SNSX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SaVt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _expandRow = __webpack_require__("NlIO");

var _expandRow2 = _interopRequireDefault(_expandRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "templateMessage",
  components: { expandRow: _expandRow2.default },
  data: function data() {
    var _this = this;

    return {
      appids: ["wxcba996672c60318c", "wxa4137801758c1854", "wxcf77238b2c0d9de3"], //0:无障碍科技订阅号,1: 启明瞳服务号,2:我能帮帮忙服务号
      title: "", //标题
      industry: "", //行业
      skipUrl: "", //跳转url
      appid: "", //小程序appid
      pagepath: "", //小程序页面路径
      selectSex: 0, //按性别选择用户的openid
      selectProvince: [], //按省份选择用户openid
      totalFlag: true, //是否选择全部用户
      nickname: "", //按昵称选择用户openid
      timeDanwei: 1, //选择时间的单位
      timeSetting: 0, //设定的时间
      modalShow: false, //模态框显示
      peopleReturn: {
        "appid": "",
        "nickname": "",
        "sex": 0,
        "provinces": [] //用户所在省
      }, //返回后台的数据
      number: 0, //群发的人数
      sendPeople: [], //发消息的对象的openid
      totalPeople: [], //获取到的要发消息的所有人
      keywords: ["", "", "", "", "", "", "", ""], //发送的部分消息
      accessToken: ["", "", ""], //0:无障碍科技订阅号,1: 启明瞳服务号,2:我能帮帮忙服务号
      appid1: "",
      sendData: {
        "openids": [], //sendPeople取其每个人的openid
        "accessToken": "", //accessToken
        "templateMsgBody": {
          "template_id": "", //点击使用模板的时候自动填写
          "touser": "",
          "url": "https://www.bemyeyes.com.cn/notify/",
          // "miniprogram": {//之后动态添加
          //   "appid": "", //选择appid时自动填写
          //   "pagepath": ""
          // },
          "data": {
            "first": {
              "value": "",
              "color": "#000"
            },
            "keyword1": {
              "value": "",
              "color": "#000"
            },
            "keyword2": {
              "value": "",
              "color": "#000"
            },
            "keyword3": {
              "value": "",
              "color": "#000"
            },
            // "keyword4": {
            //   "value":"2014年9月22日",
            //   "color":"#000"
            // },
            "remark": {
              "value": "",
              "color": "#000"
            }
          }
        }
      }, //发送的消息

      /*启明瞳服务号*/
      template_list: [], //启明瞳服务号模板列表
      flag: false, //显示页面切换
      example: [], //模板使用时顶部展示
      content: [], //填写需要发送的消息
      columns: [{
        title: "序号",
        type: "index",
        key: "index",
        width: 60,
        align: "left"
      }, {
        title: "模板ID",
        key: "template_id",
        width: 350,
        align: "left"
      }, {
        title: "标题",
        key: "title",
        align: "left"
      }, {
        title: "一级行业",
        key: "primary_industry",
        align: "left"
      }, {
        title: "二级行业",
        key: "deputy_industry",
        align: "left"
      }, {
        title: "展开 / 收起",
        type: 'expand',
        width: 100,
        render: function render(h, params) {
          return h(_expandRow2.default, {
            props: {
              index: params.index,
              template_list: _this.template_list
            }
          });
        }
      }, {
        title: "操作",
        align: "center",
        render: function render(h, params) {
          return h('div', [h('Button', {
            props: {
              type: "primary"
            },
            style: {
              borderRadius: "20px"
            },
            on: {
              click: function click() {
                var tmp = "";
                tmp = _this.template_list[params.index].example;
                _this.example = tmp.split('\n');
                tmp = _this.template_list[params.index].content.replace(/\{{(.+?)\}}/g, "");
                _this.content = tmp.split('\n');

                _this.title = _this.template_list[params.index].title;
                _this.industry = _this.template_list[params.index].primary_industry;

                _this.sendData.templateMsgBody.template_id = _this.template_list[params.index].template_id;
                _this.flag = !_this.flag;
              }
            }
          }, "点击使用")]);
        }
      }], //启明瞳服务号模板列表表格列

      /*我能帮帮忙服务号*/
      template_list2: [], //我能帮帮忙服务号模板列表
      flag2: false, //显示页面切换
      example2: [], //页面切换后顶部展示
      content2: [], //填写需要发送的消息
      columns2: [{
        title: "序号",
        type: "index",
        key: "index",
        width: 60,
        align: "left"
      }, {
        title: "模板ID",
        key: "template_id",
        width: 350,
        align: "left"
      }, {
        title: "标题",
        key: "title",
        align: "left"
      }, {
        title: "一级行业",
        key: "primary_industry",
        align: "left"
      }, {
        title: "二级行业",
        key: "deputy_industry",
        align: "left"
      }, {
        title: "展开 / 收起",
        type: 'expand',
        width: 100,
        render: function render(h, params) {
          return h(_expandRow2.default, {
            props: {
              index: params.index,
              template_list: _this.template_list2
            }
          });
        }
      }, {
        title: "操作",
        align: "center",
        render: function render(h, params) {
          return h('div', [h('Button', {
            props: {
              type: "primary"
            },
            style: {
              borderRadius: "20px"
            },
            on: {
              click: function click() {
                var tmp = "";
                tmp = _this.template_list2[params.index].example;
                _this.example2 = tmp.split('\n');
                tmp = _this.template_list2[params.index].content.replace(/\{{(.+?)\}}/g, "");
                _this.content2 = tmp.split('\n');

                _this.title = _this.template_list2[params.index].title;
                _this.industry = _this.template_list2[params.index].primary_industry;

                _this.sendData.templateMsgBody.template_id = _this.template_list2[params.index].template_id;
                _this.flag2 = !_this.flag2;
              }
            }
          }, "点击使用")]);
        }
      }], //我能帮帮忙服务号模板列表表格列
      clockTime: null
    };
  },

  methods: {
    test: function test() {
      console.log(this.selectProvince);
    },
    makeSure: function makeSure() {
      this.modalShow = false;
      this.$refs.inputVal.focus();
      document.querySelector("#inputSee").scrollIntoView(true);
      document.querySelector("#inputSee2").scrollIntoView(true);
    },
    //模块框确认
    setAppid: function setAppid() {
      this.sendData.templateMsgBody.miniprogram = {}; //动态添加这个属性
      this.sendData.templateMsgBody.miniprogram.appid = this.appid1;
      /*小程序页面路径*/
      this.sendData.templateMsgBody.miniprogram.pagepath = this.pagepath;
    },
    //设置要发送的appid
    getSetTime: function getSetTime() {
      this.timeSetting = this.timeSetting * this.timeDanwei;
      console.log(this.timeSetting);
    },
    //获取定时的时间
    totalProvince: function totalProvince() {
      //选择全部城市
      if (this.totalFlag) {
        this.selectProvince = ["北京", "上海", "重庆", "深圳", "天津", "南京", "湖北", "湖南", "河北", "河南", "江苏", "浙江", "山西", "辽宁", "吉林", "福建", "广东", "山东", "江西", "四川", "陕西", "云南", "广西", "安徽", "宁夏", "青海", "西藏", "甘肃", "新疆", "黑龙江", "内蒙古", "香港", "澳门", "台湾", "海外"];
        this.totalFlag = false;
      } else {
        this.selectProvince = [];
        this.totalFlag = true;
      }
    },
    expanding: function expanding() {//展开详情时触发
    },
    selectPeople: function selectPeople(appid) {
      var _this2 = this;

      //已经选择的人数
      this.peopleReturn.appid = appid;
      this.peopleReturn.nickname = this.nickname;
      this.peopleReturn.provinces = this.selectProvince;
      this.peopleReturn.sex = this.selectSex;

      console.log(this.peopleReturn);
      this.$http.post('/zm/backManage/getAccountFollowerInfos', this.peopleReturn).then(function (res) {
        _this2.totalPeople = res.data.content;
        _this2.number = _this2.totalPeople.length;
      });
    },
    immedeSend: function immedeSend(content) {
      //立即发送
      this.sendData.accessToken = this.accessToken[1];
      if (confirm('请确定是否发送')) {
        this.sending(content);
      }
    },
    immedeSend2: function immedeSend2(content) {
      this.sendData.accessToken = this.accessToken[2];
      if (confirm('请确定是否发送')) {
        this.sending(content);
      }
    },
    sending: function sending(content) {
      var _this3 = this;

      this.sendData.templateMsgBody.data.first.value = this.keywords[0];
      this.sendData.templateMsgBody.data.keyword1.value = this.keywords[1];
      this.sendData.templateMsgBody.data.keyword2.value = this.keywords[2];
      if (content.length >= 5) {
        this.sendData.templateMsgBody.data.keyword3.value = this.keywords[3];
      }
      this.sendData.templateMsgBody.data.remark.value = this.keywords[content.length - 1];

      /*跳转url*/
      this.sendData.templateMsgBody.url = this.skipUrl;
      /*要发送的openid*/
      var i = void 0;
      for (i in this.totalPeople) {
        this.sendData.openids.push(this.totalPeople[i].openid);
      }

      //检测小程序appid是否已经选择
      if (this.sendData.templateMsgBody.hasOwnProperty("miniprogram")) {
        //判断是否有这个属性，有的话表示选择了小程序appid
        this.sendData.templateMsgBody.miniprogram.pagepath = this.pagepath;
        if (this.sendData.templateMsgBody.miniprogram.pagepath === "") {
          //如果页面路径没有填写
          this.modalShow = true;
          return;
        }
      }

      this.$http.post('/zm/backManage/sendTemplateMsg', this.sendData).then(function (res) {
        _this3.sendData.openids = [];
        _this3.$Message.success(res.content);
      }, function (err) {
        _this3.sendData.openids = [];
        _this3.$Message.error(err.content);
      });
    },
    //发送
    timedSend: function timedSend(content) {
      var _this4 = this;

      //定时发送
      if (confirm('请确定是否发送')) {
        this.clockTime = setTimeout(function () {
          _this4.immedeSend(content);
        }, this.timeSetting * 1000);
      }
    },
    timeSend2: function timeSend2(content) {}
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.clockTime);
  },
  mounted: function mounted() {},
  activated: function activated() {
    var _this5 = this;

    /*初始化数据*/
    this.flag = false;
    this.flag2 = false;
    this.keywords = ["", "", "", "", "", "", ""];

    // let accessToken = ["", "", ""];//0:无障碍科技订阅号,1: 启明瞳服务号,2:我能帮帮忙服务号

    /*启明瞳服务号:根据appid获取AccessToken*/
    this.$http.get("/zm/backManage/getAccessToken?appid=" + this.appids[1]).then(function (res) {
      _this5.accessToken[1] = res.data.content;

      /*根据AccessToken获取列表*/
      _this5.$http.get("/cgi-bin/template/get_all_private_template?access_token=" + _this5.accessToken[1]).then(function (res) {
        //启明瞳服务号
        _this5.template_list = res.data.template_list;
        _this5.template_list.splice(0, 1);
      });
    });

    /*我能帮帮忙服务号:根据appid获取AccessToken*/
    this.$http.get("/zm/backManage/getAccessToken?appid=" + this.appids[2]).then(function (res) {
      _this5.accessToken[2] = res.data.content;

      /*根据AccessToken获取列表*/
      _this5.$http.get("/cgi-bin/template/get_all_private_template?access_token=" + _this5.accessToken[2]).then(function (res) {
        //我能帮帮忙
        _this5.template_list2 = res.data.template_list;
        _this5.template_list2.splice(0, 1);
      });
    });
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "V3Wx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bg_01.347d548.jpg";

/***/ }),

/***/ "V6nq":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("MGgh")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("RgbG"),
  /* template */
  __webpack_require__("nE5R"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "VrLL":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("bT8n"),
  /* template */
  __webpack_require__("mvzA"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "WBak":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "min-width": "900px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "26px",
      "display": "inline-block",
      "cursor": "pointer"
    }
  }, [_vm._v("其他")])])
}]}

/***/ }),

/***/ "WMMa":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("kFXC")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("BAQ6"),
  /* template */
  __webpack_require__("ztek"),
  /* scopeId */
  "data-v-3976833e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "WPWB":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("rRdF")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("n0W8"),
  /* template */
  __webpack_require__("jop8"),
  /* scopeId */
  "data-v-70c3a676",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "Wo8S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XIde":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XMRc":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-container",
    attrs: {
      "id": "time-line"
    }
  }, [_c('div', [_c('div', {
    staticClass: "table-container",
    staticStyle: {
      "min-width": "1100px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "26px",
      "margin-top": "20px",
      "margin-left": "25px"
    }
  }, [_vm._v("盲人用户")]), _vm._v(" "), _c('Tabs', {
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "25px"
    },
    attrs: {
      "value": "name1"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "盲人",
      "name": "name1"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "14"
    }
  }, [_c('Row', {
    staticStyle: {
      "margin": "3% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "18"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "用户昵称"
    },
    nativeOn: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchName.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.nickNameSearch),
      callback: function($$v) {
        _vm.nickNameSearch = $$v
      },
      expression: "nickNameSearch"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-search"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.searchName.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-top": "8%",
      "margin-left": "70%"
    },
    attrs: {
      "type": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.putBlack.apply(null, arguments)
      }
    }
  }, [_vm._v("加入黑名单")])], 1)], 1), _vm._v(" "), _c('Card', {
    staticClass: "mainBox"
  }, [_c('Tabs', {
    attrs: {
      "value": "main1",
      "type": "card"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": _vm.totalUser,
      "name": "main1"
    }
  }, [_c('Table', {
    ref: "select",
    attrs: {
      "stripe": "",
      "columns": _vm.columnsMain,
      "data": _vm.bindUsers,
      "loading": _vm.tableLoading
    },
    on: {
      "on-selection-change": function($event) {
        return _vm.handleSelectRow()
      }
    }
  }), _vm._v(" "), _c('Page', {
    staticClass: "paging",
    attrs: {
      "total": _vm.dataCount,
      "page-size": _vm.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "黑名单",
      "name": "name2"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "14"
    }
  }, [_c('Row', {
    staticStyle: {
      "margin": "3% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "18"
    }
  }, [_c('Input', {
    attrs: {
      "type": "text",
      "placeholder": "用户昵称"
    },
    nativeOn: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchBlackName.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.nickNameSearch),
      callback: function($$v) {
        _vm.nickNameSearch = $$v
      },
      expression: "nickNameSearch"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "ios-search"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.searchBlackName.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-top": "8%",
      "margin-left": "70%"
    },
    attrs: {
      "type": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dragBlack.apply(null, arguments)
      }
    }
  }, [_vm._v("解除黑名单")])], 1)], 1), _vm._v(" "), _c('Card', {
    staticClass: "mainBox"
  }, [_c('Tabs', {
    attrs: {
      "value": "main1",
      "type": "card"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": _vm.totalUser,
      "name": "main1"
    }
  }, [_c('Table', {
    ref: "selection",
    attrs: {
      "stripe": "",
      "columns": _vm.columnsMain,
      "data": _vm.blackList,
      "loading": _vm.tableLoading
    },
    on: {
      "on-selection-change": function($event) {
        return _vm.handleSelectBlackRow()
      }
    }
  }), _vm._v(" "), _c('Page', {
    staticClass: "paging",
    attrs: {
      "total": _vm.dataCountBlack,
      "page-size": _vm.pageSizeBlack,
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePageBlack
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ "XcRv":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("eQ15")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("OIt8"),
  /* template */
  __webpack_require__("XMRc"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _admin = __webpack_require__("4piF");

var _Home = __webpack_require__("j7e0");

var _Home2 = _interopRequireDefault(_Home);

var _Login = __webpack_require__("lmfZ");

var _Login2 = _interopRequireDefault(_Login);

var _ = __webpack_require__("+H76");

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  routes: [{
    path: "*",
    component: _2.default
  }, {
    path: '/',
    name: 'home',
    component: _Home2.default
  }, {
    path: "/login",
    name: "login",
    props: { status: true },
    component: _Login2.default
  }, {
    path: "/registe",
    name: "registe",
    props: { status: false },
    component: _Login2.default
  }].concat((0, _toConsumableArray3.default)(_admin.adminRouter))
});

/***/ }),

/***/ "YuJl":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "editor",
    staticStyle: {
      "text-align": "left"
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ "ZJNI":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("KB42")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("L739"),
  /* template */
  __webpack_require__("pIGu"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "ZW+m":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tables-edit-outer"
  }, [(!_vm.isEditting) ? _c('div', {
    staticClass: "tables-edit-con"
  }, [(_vm.isTitle) ? _c('a', {
    staticClass: "value-con",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.editParams
    }
  }, [_vm._v(_vm._s(_vm.value))]) : _c('span', {
    staticClass: "value-con"
  }, [_vm._v(_vm._s(_vm.value))]), _vm._v(" "), (_vm.editable) ? _c('Button', {
    staticClass: "tables-edit-btn",
    staticStyle: {
      "padding": "2px 4px"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.startEdit
    }
  }, [_c('Icon', {
    attrs: {
      "type": "checkmark"
    }
  })], 1) : _vm._e()], 1) : _c('div', {
    staticClass: "tables-editting-con"
  }, [(_vm.isDate) ? _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "请选择日期时间"
    },
    on: {
      "on-change": _vm.handleInput
    },
    model: {
      value: (_vm.formItem.time),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "time", $$v)
      },
      expression: "formItem.time"
    }
  })], 1) : (_vm.isAlbum) ? _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "label": _vm.formItem.album
    },
    on: {
      "on-change": _vm.handleInput
    },
    model: {
      value: (_vm.formItem.albumId),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "albumId", $$v)
      },
      expression: "formItem.albumId"
    }
  }, _vm._l((_vm.albumList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1) : _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "72%"
    }
  }, [_c('Input', {
    staticClass: "tables-edit-input",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value": _vm.value
    },
    on: {
      "input": _vm.handleInput
    }
  })], 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "padding": "6px 4px"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.saveEdit
    }
  }, [_c('Icon', {
    attrs: {
      "type": "checkmark"
    }
  })], 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "padding": "6px 4px"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.canceltEdit
    }
  }, [_c('Icon', {
    attrs: {
      "type": "close"
    }
  })], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "920px",
      "closable": true,
      "mask-closable": false,
      "styles": {
        top: '5%'
      }
    },
    model: {
      value: (_vm.modal),
      callback: function($$v) {
        _vm.modal = $$v
      },
      expression: "modal"
    }
  }, [_c('p', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "16px",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("文章内容编辑")])]), _vm._v(" "), _c('Form', {
    ref: "formItem",
    staticClass: "materialForm",
    attrs: {
      "model": _vm.formItem,
      "label-width": 80,
      "rules": _vm.ruleValidate
    }
  }, [_c('FormItem', {
    attrs: {
      "prop": "title",
      "label": "推文标题"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "800px"
    },
    attrs: {
      "placeholder": "请输入",
      "clearable": ""
    },
    model: {
      value: (_vm.formItem.title),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "title", $$v)
      },
      expression: "formItem.title"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "推文链接"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "800px"
    },
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.formItem.url),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "url", $$v)
      },
      expression: "formItem.url"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "作者",
      "prop": "author"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.formItem.author),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "author", $$v)
      },
      expression: "formItem.author"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "更新时间",
      "prop": "time"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "type": "datetime",
      "placeholder": "选择日期",
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.time),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "time", $$v)
      },
      expression: "formItem.time"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "专辑",
      "prop": "album"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "label": _vm.formItem.album
    },
    model: {
      value: (_vm.formItem.albumId),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "albumId", $$v)
      },
      expression: "formItem.albumId"
    }
  }, _vm._l((_vm.albumList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "正文",
      "prop": "content"
    }
  }, [_c('Editor', {
    staticStyle: {
      "width": "800px"
    },
    model: {
      value: (_vm.formItem.content),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "content", $$v)
      },
      expression: "formItem.content"
    }
  }), _vm._v(" "), _c('Button', {
    on: {
      "click": _vm.getContent
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.formUrl,
      "target": "_blank"
    }
  }, [_vm._v("点击跳转到原文页面复制推文内容到文本框")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "size": "large"
    },
    on: {
      "click": _vm.cancelModalEdit
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loading2
    },
    on: {
      "click": _vm.saveModalEdit
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "ZXMG":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detail-container"
  }, [_c('p', {
    staticClass: "paraHead",
    staticStyle: {
      "font-size": "26px"
    }
  }, [_vm._v("求助消息详情\n    "), _c('Span', {
    staticClass: "paraHead"
  }, [_c('Button', {
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "type": "text"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.returnPage.apply(null, arguments)
      }
    }
  }, [_vm._v("返回之前页面")])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "paraHead"
  }, [_vm._v("盲人基本信息")]), _vm._v(" "), _c('Card', {
    staticClass: "bodyCard"
  }, [_c('Row', {
    attrs: {
      "gutter": 64
    }
  }, [_c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "background-color": "#fff"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.helpInfo.avatarUrl,
      "alt": "headUrl"
    }
  })])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("\n          昵称:\n          "), _c('span', {
    staticClass: "content",
    staticStyle: {
      "color": "rgba(56, 56, 56, 1)"
    }
  }, [_vm._v(_vm._s(_vm.helpInfo.nickname))])]), _vm._v(" "), _c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("\n          加入时间:\n          "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.helpInfo.createTime))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("\n          提问数量:\n          "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    staticClass: "answerInfo"
  }, [_vm._v(_vm._s(_vm.helpInfo.data.pageTotal))]), _vm._v("条\n          ")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "help-history"
  }, [_c('img', {
    attrs: {
      "src": "/static/rightArrow.png",
      "alt": ""
    },
    on: {
      "click": _vm.goHistory
    }
  })])], 1), _vm._v(" "), _c('p', {
    staticClass: "paraHead"
  }, [_vm._v("问题内容")]), _vm._v(" "), _c('Card', {
    staticClass: "bodyCard"
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.helpInfo.imageUrl),
      expression: "helpInfo.imageUrl"
    }],
    attrs: {
      "span": "4"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "180px",
      "height": "320px",
      "background-color": "#fff"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "180px",
      "height": "320px"
    },
    attrs: {
      "src": _vm.helpInfo.imageUrl,
      "onerror": "javascript:this.src='/static/imgError.png'",
      "alt": "图片加载失败"
    }
  })]), _vm._v(" "), _c('Button', {
    staticClass: "buttonStyle",
    attrs: {
      "type": "text",
      "icon": "ios-download-outline"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.downPic.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("保存")])]), _vm._v(" "), _c('Button', {
    staticClass: "buttonStyle",
    attrs: {
      "type": "text",
      "icon": "ios-search-strong"
    },
    on: {
      "click": function($event) {
        _vm.picModal = true
      }
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("放大")])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("求助文字")]), _vm._v(" "), _c('div', {
    staticClass: "innerCard"
  }, [_c('Card', {
    staticStyle: {
      "box-shadow": "0 5px 10px gray"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "line-height": "20px",
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(!_vm.helpInfo.helpText ? _vm.helpInfo.helpText : "无"))])])], 1), _vm._v(" "), _c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("求助语音")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.helpInfo.voiceUrl),
      expression: "helpInfo.voiceUrl"
    }],
    staticClass: "innerCard"
  }, [_c('audio', {
    attrs: {
      "controls": "controls",
      "preload": "none",
      "src": _vm.helpInfo.voiceUrl
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.helpInfo.voiceUrl),
      expression: "!helpInfo.voiceUrl"
    }],
    staticClass: "innerCard"
  }, [_c('Card', {
    staticStyle: {
      "box-shadow": "0 5px 10px gray",
      "height": "50px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "line-height": "20px",
      "text-align": "center"
    }
  }, [_vm._v("无")])])], 1), _vm._v(" "), _c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("求助视频")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.helpInfo.videoUrl),
      expression: "helpInfo.videoUrl"
    }],
    staticClass: "innerCard"
  }, [_c('video', {
    staticStyle: {
      "max-height": "300px"
    },
    attrs: {
      "controls": "controls",
      "src": _vm.helpInfo.videoUrl
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.helpInfo.videoUrl),
      expression: "!helpInfo.videoUrl"
    }],
    staticClass: "innerCard"
  }, [_c('Card', {
    staticStyle: {
      "box-shadow": "0 5px 10px gray",
      "height": "50px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "line-height": "20px",
      "text-align": "center"
    }
  }, [_vm._v("无")])])], 1), _vm._v(" "), _c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("求助进度")]), _vm._v(" "), _c('div', {
    staticClass: "innerCard"
  }, [_c('Progress', {
    attrs: {
      "percent": _vm.percentNum,
      "status": "active"
    }
  }), _vm._v(" "), _c('Button', {
    staticStyle: {
      "font-size": "20px"
    },
    attrs: {
      "icon": "android-call",
      "type": "text"
    }
  }), _vm._v(" "), _c('span', [_vm._v("客服回答:   无")])], 1), _vm._v(" "), _c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("求助时间")]), _vm._v(" "), _c('div', {
    staticClass: "innerCard"
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.helpInfo.createTime))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('div', {
    staticClass: "rightCard"
  }, [_c('div', {
    staticStyle: {
      "height": "40px",
      "background-color": "rgba(42, 130, 228, 1)"
    }
  }, [_c('p', {
    staticClass: "rightHead"
  }, [_vm._v("客服回答面板")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_vm._v("快捷选项")]), _vm._v(" "), _c('Button', {
    staticClass: "quickButton",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.chooseItem(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.quickItem1))]), _vm._v(" "), _c('Button', {
    staticClass: "quickButton",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.chooseItem(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.quickItem2))]), _vm._v(" "), _c('Button', {
    staticClass: "quickButton",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.chooseItem(3)
      }
    }
  }, [_vm._v(_vm._s(_vm.quickItem3))]), _vm._v(" "), _c('Button', {
    staticClass: "quickButton",
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.chooseItem(4)
      }
    }
  }, [_vm._v(_vm._s(_vm.quickItem4))]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "width": "350px",
      "height": "1px",
      "background-color": "rgba(42, 130, 228, 1)",
      "margin": "10px auto",
      "border": "none"
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.replyText),
      expression: "replyText"
    }],
    staticClass: "rightInnerCard",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.replyText)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.replyText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('Button', {
    staticClass: "submitButton",
    class: {
      'subBtn': _vm.successBtn
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "~click": function($event) {
        return _vm.successSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("成功提交")])], 1)])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "paraHead"
  }, [_vm._v("志愿者回复")]), _vm._v(" "), _c('Row', {
    staticClass: "code-row-bg",
    staticStyle: {
      "width": "96%"
    },
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, _vm._l((_vm.offerHelpInfos), function(item) {
    return _c('Col', {
      key: item.id,
      staticStyle: {
        "min-width": "450px"
      },
      attrs: {
        "span": "9"
      }
    }, [_c('div', {
      staticClass: "answerBox"
    }, [_c('div', {
      staticStyle: {
        "height": "30px",
        "background-color": "#2366B0"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "14px",
        "color": "#fff",
        "text-align": "center"
      }
    })]), _vm._v(" "), _c('Row', {
      staticClass: "code-row-bg",
      attrs: {
        "type": "flex"
      }
    }, [_c('Col', [_c('img', {
      staticClass: "volunteerHead",
      attrs: {
        "src": item.avatarUrl,
        "alt": "头像加载失败",
        "onerror": "javascript:this.src='/static/imgError.png'"
      }
    })]), _vm._v(" "), _c('Col', [_c('p', {
      staticStyle: {
        "font-size": "14px",
        "margin": "15px"
      }
    }, [_vm._v("昵称:\n              "), _c('br'), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "16px"
      }
    }, [_vm._v(_vm._s(item.nickname))])])]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "4",
        "offset": "5"
      }
    }, [_c('p', {
      staticStyle: {
        "font-size": "14px",
        "color": "#cccccc",
        "margin-top": "30px"
      }
    }, [_vm._v("详细信息")])]), _vm._v(" "), _c('Col', {
      attrs: {
        "offset": "1"
      }
    }, [_c('Button', {
      staticClass: "rightBtn",
      attrs: {
        "icon": "android-arrow-forward"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.volunterDetailBtn2.apply(null, arguments)
        }
      }
    })], 1)], 1), _vm._v(" "), _c('hr', {
      staticStyle: {
        "height": "1px",
        "background-color": "#cccccc",
        "border": "none"
      }
    }), _vm._v(" "), _c('p', {
      staticClass: "answerList"
    }, [_vm._v("回复内容:")]), _vm._v(" "), _c('Card', {
      staticClass: "textCard"
    }, [_c('p', {
      staticStyle: {
        "font-size": "16px",
        "line-height": "20px",
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(item.helpText))])]), _vm._v(" "), _c('p', {
      staticClass: "answerList"
    }, [_vm._v("回复时间:")]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "16px",
        "margin-left": "10%"
      }
    }, [_vm._v(_vm._s(_vm.format(item.updateTime)))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "16px",
        "margin-left": "10%"
      }
    }, [_vm._v("差值:" + _vm._s(_vm.diffTime(item.updateTime - item.createTime)))]), _vm._v(" "), _c('p', {
      staticClass: "answerList",
      staticStyle: {
        "margin-top": "20px"
      }
    }, [_vm._v("此次积分")]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "16px",
        "margin": "10px",
        "margin-left": "30%"
      }
    }, [_vm._v("爱心积分:   +" + _vm._s(item.point))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "16px",
        "margin": "10px",
        "margin-left": "30%"
      }
    }, [_vm._v("服务积分:   +" + _vm._s(item.gradePoint))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "16px",
        "margin": "10px",
        "margin-left": "30%"
      }
    }, [_vm._v("时间银行:   +" + _vm._s(item.timebank) + "s")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "block",
        "margin-left": "50%"
      }
    }, [_c('Button', {
      staticClass: "changeText",
      attrs: {
        "icon": "paintbrush",
        "type": "primary"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.volunterDetailBtn2.apply(null, arguments)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("修改数据")])], 1)], 1)])
  }), 1), _vm._v(" "), _c('Modal', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "width": "1000px",
      "footer-hide": ""
    },
    model: {
      value: (_vm.picModal),
      callback: function($$v) {
        _vm.picModal = $$v
      },
      expression: "picModal"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "1000px",
      "max-height": "670px"
    },
    attrs: {
      "src": _vm.helpInfo.imageUrl,
      "alt": "图片加载失败"
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "ZmhQ":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "min-width": "900px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "26px",
      "display": "inline-block",
      "cursor": "pointer"
    }
  }, [_vm._v("用户反馈消息")])])
}]}

/***/ }),

/***/ "a78U":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "min-width": "1100px"
    }
  }, [_c('Tabs', {
    attrs: {
      "value": _vm.appName
    },
    on: {
      "on-click": _vm.tabChanged
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "我能帮帮忙",
      "name": "I_Can_Help"
    }
  }, [_c('Card', {
    staticClass: "mainBody"
  }, [_c('div', {
    staticClass: "leftPanel"
  }, [_c('div', {
    staticClass: "phoneTitle"
  }, [_c('p', {
    staticStyle: {
      "color": "white",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.publicTitle))])]), _vm._v(" "), _c('draggable', _vm._b({
    staticClass: "list-group",
    attrs: {
      "tag": "ul",
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.menuList),
      callback: function($$v) {
        _vm.menuList = $$v
      },
      expression: "menuList"
    }
  }, 'draggable', _vm.dragOptions, false), [_vm._l((_vm.menuList), function(item, index) {
    return _c('li', {
      key: item.name,
      staticClass: "list-group-item",
      class: _vm.menuSize
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable),
        expression: "!editable"
      }],
      staticClass: "pre_menu_link",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.selectMenu(item, index)
        }
      }
    }, [_c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable),
        expression: "editable"
      }],
      staticClass: "pre_menu_link",
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), (_vm.selectedMenu.name === item.name) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable),
        expression: "!editable"
      }],
      staticClass: "sub_pre_menu"
    }, [(item['sub_button']) ? _c('ul', {
      staticClass: "sub_pre_menu_list"
    }, [_vm._l((item.sub_button), function(element, index2) {
      return _c('li', {
        key: element.name,
        staticClass: "sub-group-item"
      }, [_c('a', {
        staticClass: "pre_menu_link",
        attrs: {
          "href": "javascript:void(0)"
        },
        on: {
          "click": function($event) {
            return _vm.selectSubMenu(element, index, index2)
          }
        }
      }, [_c('span', {
        staticClass: "badge"
      }, [_vm._v(_vm._s(element.name))])])])
    }), _vm._v(" "), (item['sub_button'].length !== 5) ? _c('li', {
      staticClass: "add_list"
    }, [_c('a', {
      staticClass: "add_link",
      attrs: {
        "href": "javascript:void(0)",
        "title": "最多添加5个二级菜单",
        "draggable": "false"
      },
      on: {
        "click": function($event) {
          return _vm.addSubMenu(index)
        }
      }
    }, [_c('i', {
      staticClass: "add_icon"
    })])]) : _vm._e()], 2) : _c('ul', {
      staticClass: "sub_pre_menu_list"
    }, [_c('li', {
      staticClass: "add_list"
    }, [_c('a', {
      staticClass: "add_link",
      attrs: {
        "href": "javascript:void(0)",
        "title": "最多添加5个二级菜单",
        "draggable": "false"
      },
      on: {
        "click": function($event) {
          return _vm.addSubMenu(index)
        }
      }
    }, [_c('i', {
      staticClass: "add_icon"
    })])])]), _vm._v(" "), _c('i', {
      staticClass: "arrow_out"
    }), _vm._v(" "), _c('i', {
      staticClass: "arrow_in"
    })]) : _vm._e()])
  }), _vm._v(" "), (_vm.menuList.length !== 3) ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable),
      expression: "!editable"
    }],
    staticClass: "add_list",
    class: _vm.menuSize
  }, [_c('a', {
    staticClass: "add_link",
    attrs: {
      "href": "javascript:void(0)",
      "title": "最多添加3个一级菜单",
      "draggable": "false"
    },
    on: {
      "click": _vm.addMenu
    }
  }, [_c('i', {
    staticClass: "add_icon"
  })])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "position": "relative",
      "top": "520px"
    }
  }, [(!_vm.editable) ? _c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "default",
      "ghost": ""
    },
    on: {
      "click": _vm.startDrag
    }
  }, [_vm._v("菜单排序")]) : _vm._e(), _vm._v(" "), (_vm.editable) ? _c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "default",
      "ghost": ""
    },
    on: {
      "click": _vm.finishDrag
    }
  }, [_vm._v("完成")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rightPanel"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messageShow.show),
      expression: "messageShow.show"
    }],
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.messageShow.tip))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.messageShow.show),
      expression: "!messageShow.show"
    }],
    staticClass: "edit_area"
  }, [_c('div', {
    staticClass: "edit_area_header"
  }, [_c('div', {
    staticStyle: {
      "height": "20px"
    }
  }, [_c('h3', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.editAreaShow.title) + "名称")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.deletePublicMenu
    }
  }, [_vm._v("删除" + _vm._s(_vm.editAreaShow.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "edit_area_name"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editAreaShow.show),
      expression: "!editAreaShow.show"
    }]
  }, [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("已添加子菜单，仅可设置菜单名称。")]), _c('br')]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "16px",
      "margin-right": "16px"
    }
  }, [_vm._v(_vm._s(_vm.editAreaShow.title) + "名称")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-grid"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": function($event) {
        return _vm.disInRealtime(1)
      }
    },
    model: {
      value: (_vm.selectedBtn.name),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "name", $$v)
      },
      expression: "selectedBtn.name"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "small-title",
    staticStyle: {
      "font": "12px gray",
      "display": "inline-block"
    }
  }, [_vm._v("仅支持中英文和数字，字数不超过4个汉字或8个字母")])], 1)]), _vm._v(" "), (_vm.editAreaShow.show) ? _c('div', {
    staticClass: "edit_area_content"
  }, [_c('Row', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('Col', {
    staticStyle: {
      "font-size": "16px",
      "margin-right": "16px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v(_vm._s(_vm.editAreaShow.title) + "内容")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('RadioGroup', {
    on: {
      "on-change": _vm.changeType
    },
    model: {
      value: (_vm.menuType),
      callback: function($$v) {
        _vm.menuType = $$v
      },
      expression: "menuType"
    }
  }, [_c('Radio', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "label": "click"
    }
  }, [_vm._v("发送消息")]), _vm._v(" "), _c('Radio', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "label": "view"
    }
  }, [_vm._v("跳转网页")]), _vm._v(" "), _c('Radio', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "label": "miniprogram"
    }
  }, [_vm._v("跳转小程序")])], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuType === 'click'),
      expression: "menuType === 'click'"
    }]
  }, [_c('Tabs', {
    attrs: {
      "value": "text"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "图文消息",
      "name": "picandtext",
      "icon": "card"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "paintbrush",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("自建图文")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "share",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("转载文章")])])])])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "文字",
      "name": "text",
      "icon": "ios-paper"
    }
  }, [_c('div', {
    staticClass: "input-area"
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 6
    }
  })], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Col', {
    attrs: {
      "span": "19"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('Col', {
    staticStyle: {
      "color": "#888888"
    },
    attrs: {
      "span": "5"
    }
  }, [_vm._v("还可以输入字")])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "图片",
      "name": "pic",
      "icon": "image"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "image",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("上传图片")])])])])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "语音",
      "name": "voice",
      "icon": "ios-mic"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-mic",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("新建语音")])])])])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "视频",
      "name": "video",
      "icon": "ios-videocam"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-videocam",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("新建视频")])])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuType === 'view'),
      expression: "menuType === 'view'"
    }]
  }, [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("订阅者点击该" + _vm._s(_vm.editAreaShow.title) + "会跳到以下链接")]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("页面地址")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.viewUrl),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "viewUrl", $$v)
      },
      expression: "selectedBtn.viewUrl"
    }
  })], 1), _vm._v(" "), _c('Row', [_c('a', {
    staticClass: "delete-menu",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("从公众号图文消息中选择")])])], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuType === 'miniprogram'),
      expression: "menuType === 'miniprogram'"
    }]
  }, [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("订阅者点击该子菜单会跳到以下小程序")]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("小程序appID")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.appid),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "appid", $$v)
      },
      expression: "selectedBtn.appid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("小程序路径")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.miniProgramPagePath),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "miniProgramPagePath", $$v)
      },
      expression: "selectedBtn.miniProgramPagePath"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("备用网页")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "18"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.miniProgramUrl),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "miniProgramUrl", $$v)
      },
      expression: "selectedBtn.miniProgramUrl"
    }
  })], 1), _vm._v(" "), _c('Row', [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("旧版微信客户端无法支持小程序，用户点击菜单时将会打开备用网页。 ")])])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "edit_area_arrow"
  }, [_c('i', {
    staticClass: "edit_area_arrow_out"
  }), _vm._v(" "), _c('i', {
    staticClass: "edit_area_arrow_in"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "position": "relative",
      "top": "26px"
    }
  }, [_c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "success",
      "ghost": ""
    },
    on: {
      "click": _vm.saveChange
    }
  }, [_vm._v("保存并发布")]), _vm._v(" "), _c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "default",
      "ghost": "",
      "disabled": ""
    }
  }, [_vm._v("预览")])], 1)])])], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "无障碍科技",
      "name": "ACCESSIBILITY_TECHNOLOGY"
    }
  }, [_c('Card', {
    staticClass: "mainBody"
  }, [_c('div', {
    staticClass: "leftPanel"
  }, [_c('div', {
    staticClass: "phoneTitle"
  }, [_c('p', {
    staticStyle: {
      "color": "white",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.publicTitle))])]), _vm._v(" "), _c('draggable', _vm._b({
    staticClass: "list-group",
    attrs: {
      "tag": "ul",
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.menuList),
      callback: function($$v) {
        _vm.menuList = $$v
      },
      expression: "menuList"
    }
  }, 'draggable', _vm.dragOptions, false), [_vm._l((_vm.menuList), function(item, index) {
    return _c('li', {
      key: item.name,
      staticClass: "list-group-item",
      class: _vm.menuSize
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable),
        expression: "!editable"
      }],
      staticClass: "pre_menu_link",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.selectMenu(item, index)
        }
      }
    }, [_c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable),
        expression: "editable"
      }],
      staticClass: "pre_menu_link",
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), (_vm.selectedMenu.name === item.name) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable),
        expression: "!editable"
      }],
      staticClass: "sub_pre_menu"
    }, [(item['sub_button']) ? _c('ul', {
      staticClass: "sub_pre_menu_list"
    }, [_vm._l((item['sub_button']), function(element, index2) {
      return _c('li', {
        key: element.name,
        staticClass: "sub-group-item"
      }, [_c('a', {
        staticClass: "pre_menu_link",
        attrs: {
          "href": "javascript:void(0)"
        },
        on: {
          "click": function($event) {
            return _vm.selectSubMenu(element, index, index2)
          }
        }
      }, [_c('span', {
        staticClass: "badge"
      }, [_vm._v(_vm._s(element.name))])])])
    }), _vm._v(" "), (item['sub_button'].length !== 5) ? _c('li', {
      staticClass: "add_list"
    }, [_c('a', {
      staticClass: "add_link",
      attrs: {
        "href": "javascript:void(0)",
        "title": "最多添加5个二级菜单",
        "draggable": "false"
      },
      on: {
        "click": function($event) {
          return _vm.addSubMenu(index)
        }
      }
    }, [_c('i', {
      staticClass: "add_icon"
    })])]) : _vm._e()], 2) : _c('ul', {
      staticClass: "sub_pre_menu_list"
    }, [_c('li', {
      staticClass: "add_list"
    }, [_c('a', {
      staticClass: "add_link",
      attrs: {
        "href": "javascript:void(0)",
        "title": "最多添加5个二级菜单",
        "draggable": "false"
      },
      on: {
        "click": function($event) {
          return _vm.addSubMenu(index)
        }
      }
    }, [_c('i', {
      staticClass: "add_icon"
    })])])]), _vm._v(" "), _c('i', {
      staticClass: "arrow_out"
    }), _vm._v(" "), _c('i', {
      staticClass: "arrow_in"
    })]) : _vm._e()])
  }), _vm._v(" "), (_vm.menuList.length !== 3) ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable),
      expression: "!editable"
    }],
    staticClass: "add_list",
    class: _vm.menuSize
  }, [_c('a', {
    staticClass: "add_link",
    attrs: {
      "href": "javascript:void(0)",
      "title": "最多添加3个一级菜单",
      "draggable": "false"
    },
    on: {
      "click": _vm.addMenu
    }
  }, [_c('i', {
    staticClass: "add_icon"
  })])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "position": "relative",
      "top": "570px"
    }
  }, [(!_vm.editable) ? _c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "default",
      "ghost": ""
    },
    on: {
      "click": _vm.startDrag
    }
  }, [_vm._v("菜单排序")]) : _vm._e(), _vm._v(" "), (_vm.editable) ? _c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "default",
      "ghost": ""
    },
    on: {
      "click": _vm.finishDrag
    }
  }, [_vm._v("完成")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rightPanel"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messageShow.show),
      expression: "messageShow.show"
    }],
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.messageShow.tip))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.messageShow.show),
      expression: "!messageShow.show"
    }],
    staticClass: "edit_area"
  }, [_c('div', {
    staticClass: "edit_area_header"
  }, [_c('div', {
    staticStyle: {
      "height": "20px"
    }
  }, [_c('h3', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.editAreaShow.title) + "名称")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.deletePublicMenu
    }
  }, [_vm._v("删除" + _vm._s(_vm.editAreaShow.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "edit_area_name"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editAreaShow.show),
      expression: "!editAreaShow.show"
    }]
  }, [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("已添加子菜单，仅可设置菜单名称。")]), _c('br')]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "16px",
      "margin-right": "16px"
    }
  }, [_vm._v(_vm._s(_vm.editAreaShow.title) + "名称")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-grid"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.name),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "name", $$v)
      },
      expression: "selectedBtn.name"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "small-title",
    staticStyle: {
      "font": "12px gray",
      "display": "inline-block"
    }
  }, [_vm._v("仅支持中英文和数字，字数不超过4个汉字或8个字母")])], 1)]), _vm._v(" "), (_vm.editAreaShow.show) ? _c('div', {
    staticClass: "edit_area_content"
  }, [_c('Row', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('Col', {
    staticStyle: {
      "font-size": "16px",
      "margin-right": "16px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v(_vm._s(_vm.editAreaShow.title) + "内容")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('RadioGroup', {
    on: {
      "on-change": _vm.changeType
    },
    model: {
      value: (_vm.menuType),
      callback: function($$v) {
        _vm.menuType = $$v
      },
      expression: "menuType"
    }
  }, [_c('Radio', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "label": "click"
    }
  }, [_vm._v("发送消息")]), _vm._v(" "), _c('Radio', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "label": "view"
    }
  }, [_vm._v("跳转网页")]), _vm._v(" "), _c('Radio', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "label": "miniprogram"
    }
  }, [_vm._v("跳转小程序")])], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuType === 'click'),
      expression: "menuType === 'click'"
    }]
  }, [_c('Tabs', {
    attrs: {
      "value": "text"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "图文消息",
      "name": "picandtext",
      "icon": "card"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "paintbrush",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("自建图文")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "share",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("转载文章")])])])])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "文字",
      "name": "text",
      "icon": "ios-paper"
    }
  }, [_c('div', {
    staticClass: "input-area"
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 6
    }
  })], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Col', {
    attrs: {
      "span": "19"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('Col', {
    staticStyle: {
      "color": "#888888"
    },
    attrs: {
      "span": "5"
    }
  }, [_vm._v("还可以输入字")])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "图片",
      "name": "pic",
      "icon": "image"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "image",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("上传图片")])])])])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "语音",
      "name": "voice",
      "icon": "ios-mic"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-mic",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("新建语音")])])])])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "视频",
      "name": "video",
      "icon": "ios-videocam"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-videocam",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("新建视频")])])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuType === 'view'),
      expression: "menuType === 'view'"
    }]
  }, [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("订阅者点击该" + _vm._s(_vm.editAreaShow.title) + "会跳到以下链接")]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("页面地址")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.viewUrl),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "viewUrl", $$v)
      },
      expression: "selectedBtn.viewUrl"
    }
  })], 1), _vm._v(" "), _c('Row', [_c('a', {
    staticClass: "delete-menu",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("从公众号图文消息中选择")])])], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuType === 'miniprogram'),
      expression: "menuType === 'miniprogram'"
    }]
  }, [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("订阅者点击该子菜单会跳到以下小程序")]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("小程序appID")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.appid),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "appid", $$v)
      },
      expression: "selectedBtn.appid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("小程序路径")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.miniProgramPagePath),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "miniProgramPagePath", $$v)
      },
      expression: "selectedBtn.miniProgramPagePath"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("备用网页")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "18"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.miniProgramUrl),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "miniProgramUrl", $$v)
      },
      expression: "selectedBtn.miniProgramUrl"
    }
  })], 1), _vm._v(" "), _c('Row', [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("旧版微信客户端无法支持小程序，用户点击菜单时将会打开备用网页。 ")])])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "edit_area_arrow"
  }, [_c('i', {
    staticClass: "edit_area_arrow_out"
  }), _vm._v(" "), _c('i', {
    staticClass: "edit_area_arrow_in"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "position": "relative",
      "top": "26px"
    }
  }, [_c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "success",
      "ghost": ""
    },
    on: {
      "click": _vm.saveChange
    }
  }, [_vm._v("保存并发布")]), _vm._v(" "), _c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "default",
      "ghost": "",
      "disabled": ""
    }
  }, [_vm._v("预览")])], 1)])])], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "启明瞳",
      "name": "qmtfwh"
    }
  }, [_c('Card', {
    staticClass: "mainBody"
  }, [_c('div', {
    staticClass: "leftPanel"
  }, [_c('div', {
    staticClass: "phoneTitle"
  }, [_c('p', {
    staticStyle: {
      "color": "white",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.publicTitle))])]), _vm._v(" "), _c('draggable', _vm._b({
    staticClass: "list-group",
    attrs: {
      "tag": "ul",
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.menuList),
      callback: function($$v) {
        _vm.menuList = $$v
      },
      expression: "menuList"
    }
  }, 'draggable', _vm.dragOptions, false), [_vm._l((_vm.menuList), function(item, index) {
    return _c('li', {
      key: item.name,
      staticClass: "list-group-item",
      class: _vm.menuSize
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable),
        expression: "!editable"
      }],
      staticClass: "pre_menu_link",
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.selectMenu(item, index)
        }
      }
    }, [_c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), _c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.editable),
        expression: "editable"
      }],
      staticClass: "pre_menu_link",
      attrs: {
        "href": "javascript:void(0)"
      }
    }, [_c('span', {
      staticClass: "badge"
    }, [_vm._v(_vm._s(item.name))])]), _vm._v(" "), (_vm.selectedMenu.name === item.name) ? _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editable),
        expression: "!editable"
      }],
      staticClass: "sub_pre_menu"
    }, [(item['sub_button']) ? _c('ul', {
      staticClass: "sub_pre_menu_list"
    }, [_vm._l((item['sub_button']), function(element, index2) {
      return _c('li', {
        key: element.name,
        staticClass: "sub-group-item"
      }, [_c('a', {
        staticClass: "pre_menu_link",
        attrs: {
          "href": "javascript:void(0)"
        },
        on: {
          "click": function($event) {
            return _vm.selectSubMenu(element, index, index2)
          }
        }
      }, [_c('span', {
        staticClass: "badge"
      }, [_vm._v(_vm._s(element.name))])])])
    }), _vm._v(" "), (item['sub_button'].length !== 5) ? _c('li', {
      staticClass: "add_list"
    }, [_c('a', {
      staticClass: "add_link",
      attrs: {
        "href": "javascript:void(0)",
        "title": "最多添加5个二级菜单",
        "draggable": "false"
      },
      on: {
        "click": function($event) {
          return _vm.addSubMenu(index)
        }
      }
    }, [_c('i', {
      staticClass: "add_icon"
    })])]) : _vm._e()], 2) : _c('ul', {
      staticClass: "sub_pre_menu_list"
    }, [_c('li', {
      staticClass: "add_list"
    }, [_c('a', {
      staticClass: "add_link",
      attrs: {
        "href": "javascript:void(0)",
        "title": "最多添加5个二级菜单",
        "draggable": "false"
      },
      on: {
        "click": function($event) {
          return _vm.addSubMenu(index)
        }
      }
    }, [_c('i', {
      staticClass: "add_icon"
    })])])]), _vm._v(" "), _c('i', {
      staticClass: "arrow_out"
    }), _vm._v(" "), _c('i', {
      staticClass: "arrow_in"
    })]) : _vm._e()])
  }), _vm._v(" "), (_vm.menuList.length !== 3) ? _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editable),
      expression: "!editable"
    }],
    staticClass: "add_list",
    class: _vm.menuSize
  }, [_c('a', {
    staticClass: "add_link",
    attrs: {
      "href": "javascript:void(0)",
      "title": "最多添加3个一级菜单",
      "draggable": "false"
    },
    on: {
      "click": _vm.addMenu
    }
  }, [_c('i', {
    staticClass: "add_icon"
  })])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "position": "relative",
      "top": "570px"
    }
  }, [(!_vm.editable) ? _c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "default",
      "ghost": ""
    },
    on: {
      "click": _vm.startDrag
    }
  }, [_vm._v("菜单排序")]) : _vm._e(), _vm._v(" "), (_vm.editable) ? _c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "default",
      "ghost": ""
    },
    on: {
      "click": _vm.finishDrag
    }
  }, [_vm._v("完成")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "rightPanel"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messageShow.show),
      expression: "messageShow.show"
    }],
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.messageShow.tip))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.messageShow.show),
      expression: "!messageShow.show"
    }],
    staticClass: "edit_area"
  }, [_c('div', {
    staticClass: "edit_area_header"
  }, [_c('div', {
    staticStyle: {
      "height": "20px"
    }
  }, [_c('h3', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.editAreaShow.title) + "名称")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": _vm.deletePublicMenu
    }
  }, [_vm._v("删除" + _vm._s(_vm.editAreaShow.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "edit_area_name"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editAreaShow.show),
      expression: "!editAreaShow.show"
    }]
  }, [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("已添加子菜单，仅可设置菜单名称。")]), _c('br')]), _vm._v(" "), _c('label', {
    staticStyle: {
      "font-size": "16px",
      "margin-right": "16px"
    }
  }, [_vm._v(_vm._s(_vm.editAreaShow.title) + "名称")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-grid"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.name),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "name", $$v)
      },
      expression: "selectedBtn.name"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "small-title",
    staticStyle: {
      "font": "12px gray",
      "display": "inline-block"
    }
  }, [_vm._v("仅支持中英文和数字，字数不超过4个汉字或8个字母")])], 1)]), _vm._v(" "), (_vm.editAreaShow.show) ? _c('div', {
    staticClass: "edit_area_content"
  }, [_c('Row', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('Col', {
    staticStyle: {
      "font-size": "16px",
      "margin-right": "16px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v(_vm._s(_vm.editAreaShow.title) + "内容")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('RadioGroup', {
    on: {
      "on-change": _vm.changeType
    },
    model: {
      value: (_vm.menuType),
      callback: function($$v) {
        _vm.menuType = $$v
      },
      expression: "menuType"
    }
  }, [_c('Radio', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "label": "click"
    }
  }, [_vm._v("发送消息")]), _vm._v(" "), _c('Radio', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "label": "view"
    }
  }, [_vm._v("跳转网页")]), _vm._v(" "), _c('Radio', {
    staticStyle: {
      "font-size": "16px"
    },
    attrs: {
      "label": "miniprogram"
    }
  }, [_vm._v("跳转小程序")])], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuType === 'click'),
      expression: "menuType === 'click'"
    }]
  }, [_c('Tabs', {
    attrs: {
      "value": "text"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "图文消息",
      "name": "picandtext",
      "icon": "card"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "paintbrush",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("自建图文")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "share",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("转载文章")])])])])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "文字",
      "name": "text",
      "icon": "ios-paper"
    }
  }, [_c('div', {
    staticClass: "input-area"
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "rows": 6
    }
  })], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('Col', {
    attrs: {
      "span": "19"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('Col', {
    staticStyle: {
      "color": "#888888"
    },
    attrs: {
      "span": "5"
    }
  }, [_vm._v("还可以输入字")])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "图片",
      "name": "pic",
      "icon": "image"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "image",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("上传图片")])])])])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "语音",
      "name": "voice",
      "icon": "ios-mic"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-mic",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("新建语音")])])])])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "视频",
      "name": "video",
      "icon": "ios-videocam"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "center"
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-folder-outline",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("从素材库选择")])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('div', {
    staticClass: "inner-div"
  }, [_c('p', {
    staticClass: "icon-color",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-videocam",
      "size": "30"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "icon-color"
  }, [_vm._v("新建视频")])])])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuType === 'view'),
      expression: "menuType === 'view'"
    }]
  }, [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("订阅者点击该" + _vm._s(_vm.editAreaShow.title) + "会跳到以下链接")]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("页面地址")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.viewUrl),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "viewUrl", $$v)
      },
      expression: "selectedBtn.viewUrl"
    }
  })], 1), _vm._v(" "), _c('Row', [_c('a', {
    staticClass: "delete-menu",
    attrs: {
      "href": "javascript:void(0);"
    }
  }, [_vm._v("从公众号图文消息中选择")])])], 1)], 1)], 1), _vm._v(" "), _c('Card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.menuType === 'miniprogram'),
      expression: "menuType === 'miniprogram'"
    }]
  }, [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("订阅者点击该子菜单会跳到以下小程序")]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("小程序appID")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.appid),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "appid", $$v)
      },
      expression: "selectedBtn.appid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("小程序路径")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.miniProgramPagePath),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "miniProgramPagePath", $$v)
      },
      expression: "selectedBtn.miniProgramPagePath"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('Col', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "span": "3"
    }
  }, [_vm._v("备用网页")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "18"
    }
  }, [_c('Row', [_c('Input', {
    staticStyle: {
      "width": "350px"
    },
    on: {
      "on-change": _vm.disInRealtime
    },
    model: {
      value: (_vm.selectedBtn.miniProgramUrl),
      callback: function($$v) {
        _vm.$set(_vm.selectedBtn, "miniProgramUrl", $$v)
      },
      expression: "selectedBtn.miniProgramUrl"
    }
  })], 1), _vm._v(" "), _c('Row', [_c('p', {
    staticClass: "small-title"
  }, [_vm._v("旧版微信客户端无法支持小程序，用户点击菜单时将会打开备用网页。 ")])])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "edit_area_arrow"
  }, [_c('i', {
    staticClass: "edit_area_arrow_out"
  }), _vm._v(" "), _c('i', {
    staticClass: "edit_area_arrow_in"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "position": "relative",
      "top": "26px"
    }
  }, [_c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "success",
      "ghost": ""
    },
    on: {
      "click": _vm.saveChange
    }
  }, [_vm._v("保存并发布")]), _vm._v(" "), _c('Button', {
    staticClass: "orderBtn",
    attrs: {
      "type": "default",
      "ghost": "",
      "disabled": ""
    }
  }, [_vm._v("预览")])], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "helpInfo",
    attrs: {
      "slot": "extra"
    },
    slot: "extra"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "http://kf.qq.com/faq/120911VrYVrA150210BBJvei.html"
    }
  }, [_vm._v("自定义菜单使用说明\n          "), _c('Icon', {
    attrs: {
      "type": "ios-book-outline"
    }
  })], 1)])], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "温馨提示"
    },
    on: {
      "on-ok": _vm.handleConfirm
    },
    model: {
      value: (_vm.handleTips.show),
      callback: function($$v) {
        _vm.$set(_vm.handleTips, "show", $$v)
      },
      expression: "handleTips.show"
    }
  }, [_c('Row', {
    staticClass: "code-row-bg",
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("Hzbo"),
      "alt": "",
      "width": "50px",
      "height": "50px"
    }
  })]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "18"
    }
  }, [_c('Row', [_vm._v(_vm._s(_vm.handleTips.title))]), _vm._v(" "), _c('Row', {
    staticClass: "small-title"
  }, [_vm._v(_vm._s(_vm.handleTips.tips))])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "bT8n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _isNan = __webpack_require__("MICi");

var _isNan2 = _interopRequireDefault(_isNan);

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assist = __webpack_require__("9Xvl");

var _calcTextareaHeight = __webpack_require__("tIEP");

var _calcTextareaHeight2 = _interopRequireDefault(_calcTextareaHeight);

var _emitter = __webpack_require__("pEmh");

var _emitter2 = _interopRequireDefault(_emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixCls = 'ivu-input'; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: 'Input',
    mixins: [_emitter2.default],
    props: {
        type: {
            validator: function validator(value) {
                return (0, _assist.oneOf)(value, ['text', 'textarea', 'password', 'url', 'email', 'date']);
            },

            default: 'text'
        },
        value: {
            type: [String, Number],
            default: ''
        },
        size: {
            validator: function validator(value) {
                return (0, _assist.oneOf)(value, ['small', 'large', 'default']);
            }
        },
        placeholder: {
            type: String,
            default: ''
        },
        maxlength: {
            type: Number
        },
        disabled: {
            type: Boolean,
            default: false
        },
        icon: String,
        autosize: {
            type: [Boolean, Object],
            default: false
        },
        rows: {
            type: Number,
            default: 2
        },
        readonly: {
            type: Boolean,
            default: false
        },
        name: {
            type: String
        },
        number: {
            type: Boolean,
            default: false
        },
        autofocus: {
            type: Boolean,
            default: false
        },
        spellcheck: {
            type: Boolean,
            default: false
        },
        autocomplete: {
            validator: function validator(value) {
                return (0, _assist.oneOf)(value, ['on', 'off']);
            },

            default: 'off'
        },
        clearable: {
            type: Boolean,
            default: false
        },
        elementId: {
            type: String
        },
        wrap: {
            validator: function validator(value) {
                return (0, _assist.oneOf)(value, ['hard', 'soft']);
            },

            default: 'soft'
        }
    },
    data: function data() {
        return {
            currentValue: this.value,
            prefixCls: prefixCls,
            prepend: true,
            append: true,
            slotReady: false,
            textareaStyles: {}
        };
    },

    computed: {
        wrapClasses: function wrapClasses() {
            var _ref;

            return [prefixCls + '-wrapper', (_ref = {}, (0, _defineProperty3.default)(_ref, prefixCls + '-wrapper-' + this.size, !!this.size), (0, _defineProperty3.default)(_ref, prefixCls + '-type', this.type), (0, _defineProperty3.default)(_ref, prefixCls + '-group', this.prepend || this.append), (0, _defineProperty3.default)(_ref, prefixCls + '-group-' + this.size, (this.prepend || this.append) && !!this.size), (0, _defineProperty3.default)(_ref, prefixCls + '-group-with-prepend', this.prepend), (0, _defineProperty3.default)(_ref, prefixCls + '-group-with-append', this.append), (0, _defineProperty3.default)(_ref, prefixCls + '-hide-icon', this.append), _ref)];
        },
        inputClasses: function inputClasses() {
            var _ref2;

            return ['' + prefixCls, (_ref2 = {}, (0, _defineProperty3.default)(_ref2, prefixCls + '-' + this.size, !!this.size), (0, _defineProperty3.default)(_ref2, prefixCls + '-disabled', this.disabled), _ref2)];
        },
        textareaClasses: function textareaClasses() {
            return ['' + prefixCls, (0, _defineProperty3.default)({}, prefixCls + '-disabled', this.disabled)];
        }
    },
    methods: {
        handleEnter: function handleEnter(event) {
            this.$emit('on-enter', event);
        },
        handleKeydown: function handleKeydown(event) {
            this.$emit('on-keydown', event);
        },
        handleKeypress: function handleKeypress(event) {
            this.$emit('on-keypress', event);
        },
        handleKeyup: function handleKeyup(event) {
            this.$emit('on-keyup', event);
        },
        handleIconClick: function handleIconClick(event) {
            this.$emit('on-click', event);
        },
        handleFocus: function handleFocus(event) {
            this.$emit('on-focus', event);
        },
        handleBlur: function handleBlur(event) {
            this.$emit('on-blur', event);
            if (!(0, _assist.findComponentUpward)(this, ['DatePicker', 'TimePicker', 'Cascader', 'Search'])) {
                this.dispatch('FormItem', 'on-form-blur', this.currentValue);
            }
        },
        handleInput: function handleInput(event) {
            var value = event.target.value;
            if (this.number) value = (0, _isNan2.default)(Number(value)) ? value : Number(value);
            this.$emit('input', value);
            this.setCurrentValue(value);
            this.$emit('on-change', event);
        },
        handleChange: function handleChange(event) {
            this.$emit('on-input-change', event);
        },
        setCurrentValue: function setCurrentValue(value) {
            var _this = this;

            if (value === this.currentValue) return;
            this.$nextTick(function () {
                _this.resizeTextarea();
            });
            this.currentValue = value;
            if (!(0, _assist.findComponentUpward)(this, ['DatePicker', 'TimePicker', 'Cascader', 'Search'])) {
                this.dispatch('FormItem', 'on-form-change', value);
            }
        },
        resizeTextarea: function resizeTextarea() {
            var autosize = this.autosize;
            if (!autosize || this.type !== 'textarea') {
                return false;
            }

            var minRows = autosize.minRows;
            var maxRows = autosize.maxRows;

            this.textareaStyles = (0, _calcTextareaHeight2.default)(this.$refs.textarea, minRows, maxRows);
        },
        focus: function focus() {
            if (this.type === 'textarea') {
                this.$refs.textarea.focus();
            } else {
                this.$refs.input.focus();
            }
        },
        blur: function blur() {
            if (this.type === 'textarea') {
                this.$refs.textarea.blur();
            } else {
                this.$refs.input.blur();
            }
        },
        handleClear: function handleClear() {
            var e = { target: { value: '' } };
            this.$emit('input', '');
            this.setCurrentValue('');
            this.$emit('on-change', e);
        }
    },
    watch: {
        value: function value(val) {
            this.setCurrentValue(val);
        }
    },
    mounted: function mounted() {
        if (this.type !== 'textarea') {
            this.prepend = this.$slots.prepend !== undefined;
            this.append = this.$slots.append !== undefined;
        } else {
            this.prepend = false;
            this.append = false;
        }
        this.slotReady = true;
        this.resizeTextarea();
    }
};

/***/ }),

/***/ "c4q/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "caS/":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "min-width": "900px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "26px",
      "display": "inline-block",
      "cursor": "pointer"
    }
  }, [_vm._v("应用详情")]), _vm._v(" "), _c('div', {
    staticClass: "formStyle"
  }, [_c('Form', {
    staticStyle: {
      "padding": "20px"
    },
    attrs: {
      "model": _vm.formItem,
      "label-width": 100
    }
  }, [_c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("应用Logo")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.formItem.appLogo
    }
  })])], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品名称")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.productTitle),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productTitle", $$v)
      },
      expression: "formItem.productTitle"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("包名")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.packageName),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "packageName", $$v)
      },
      expression: "formItem.packageName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("Appid")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.appid),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "appid", $$v)
      },
      expression: "formItem.appid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品id")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.productId),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productId", $$v)
      },
      expression: "formItem.productId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("应用版本")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.appVersion),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "appVersion", $$v)
      },
      expression: "formItem.appVersion"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("上架时间")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.time),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "time", $$v)
      },
      expression: "formItem.time"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("应用类别")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formItem.appCategory),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "appCategory", $$v)
      },
      expression: "formItem.appCategory"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1",
      "disabled": ""
    }
  }, [_vm._v("启明应用")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2",
      "disabled": ""
    }
  }, [_vm._v("启明游戏")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3",
      "disabled": ""
    }
  }, [_vm._v("其他应用")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "4",
      "disabled": ""
    }
  }, [_vm._v("其他游戏")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "5",
      "disabled": ""
    }
  }, [_vm._v("未分类")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品简介")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "type": "textarea"
    },
    model: {
      value: (_vm.formItem.productShortDescribe),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productShortDescribe", $$v)
      },
      expression: "formItem.productShortDescribe"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品详情")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "type": "textarea",
      "autosize": {
        minRows: 4,
        maxRows: 8
      }
    },
    model: {
      value: (_vm.formItem.productDescribe),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productDescribe", $$v)
      },
      expression: "formItem.productDescribe"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("展示视频")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('video', {
    staticStyle: {
      "max-height": "300px"
    },
    attrs: {
      "controls": "controls",
      "src": _vm.formItem.playerSrc
    }
  })])], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("展示图片")]), _vm._v(" "), _c('Col', {
    staticClass: "formItemShow",
    attrs: {
      "span": "15"
    }
  }, _vm._l((_vm.imgList), function(item) {
    return _c('div', {
      staticClass: "showImg"
    }, [_c('img', {
      staticStyle: {
        "width": "200px",
        "height": "300px"
      },
      attrs: {
        "src": item
      }
    })])
  }), 0)], 1)], 1), _vm._v(" "), _c('formItem', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.editAppDetail(_vm.formItem.areaId, _vm.sortOrder)
      }
    }
  }, [_vm._v("更新版本")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ "dg/3":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [(_vm.showHead) ? _c('div', {
    class: _vm.headClasses
  }, [_vm._t("title", function() {
    return [(_vm.title) ? _c('p', [(_vm.icon) ? _c('Icon', {
      attrs: {
        "type": _vm.icon
      }
    }) : _vm._e(), _vm._v("\n            " + _vm._s(_vm.title) + "\n        ")], 1) : _vm._e()]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.showExtra) ? _c('div', {
    class: _vm.extraClasses
  }, [_vm._t("extra")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    class: _vm.bodyClasses,
    style: (_vm.bodyStyles)
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ "dgke":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("p0Qu")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("w4OT"),
  /* template */
  __webpack_require__("ZmhQ"),
  /* scopeId */
  "data-v-a0aa2510",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "e3Xd":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tag-container"
  }, [_c('div', {
    staticClass: "tag-group",
    style: (_vm.styleObj)
  }, [_c('transition-group', {
    attrs: {
      "tag": "div",
      "name": "taglist-moving-animation"
    }
  }, _vm._l((_vm.openedTags), function(item, index) {
    return _c('Tag', {
      key: item.name,
      ref: item.name,
      refInFor: true,
      attrs: {
        "type": "dot",
        "name": item.name,
        "closable": item.name === 'admin' ? false : true,
        "color": item.name === _vm.currentTag ? 'blue' : 'default'
      },
      on: {
        "on-close": _vm.closeTag
      },
      nativeOn: {
        "click": function($event) {
          return _vm.linkTo(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tag-list-drop"
  }, [_c('Dropdown', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "transfer": "",
      "trigger": "click",
      "placement": "bottom-start"
    },
    on: {
      "on-click": _vm.handleTagsOption
    }
  }, [_c('Button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("\n          标签选项 "), _c('Icon', {
    attrs: {
      "type": "arrow-down-b"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "clearAll"
    }
  }, [_vm._v("关闭所有")]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "clearOthers"
    }
  }, [_vm._v("关闭其他")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ "eQ15":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eh8g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _format = __webpack_require__("4/BI");

var _admin = __webpack_require__("4piF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "editWebAppDetail",
    data: function data() {
        return {
            isNew: false,
            pageInfo: {},
            formItem: {},
            sortOrder: 0,
            productType: 5,
            apkName: '',
            logoVisible: false,
            logoUpload: [],
            videoUpload: [],
            imgUpload: [],
            imgVisible: false,
            imgShow: '',
            apkProgress: false,
            imgProgress: false,
            logoProgress: false,
            videoProgress: false
        };
    },

    methods: {
        /*通用上传控件*/
        handleFormatError: function handleFormatError() {
            this.$Message.error('文件格式错误');
        },
        handleMaxSize: function handleMaxSize() {
            this.$Message.error('文件体积过大');
        },

        /*apk上传控件*/
        checkApkUpload: function checkApkUpload(file) {
            if (this.apkName !== '') {
                this.$Message.error('只能上传一个apk文件');
                return false;
            }
            this.apkName = file.name;
        },
        handleApkUpload: function handleApkUpload(res, file, list) {
            this.apkProgress = true;
        },
        apkUploadSuccess: function apkUploadSuccess(res, file) {
            this.formItem.downloadUrl = res.content;
            this.apkProgress = false;
            this.$Message.success('上传成功');
        },
        apkUploadFail: function apkUploadFail(res, file) {
            this.apkName = '';
            this.formItem.downloadUrl = '';
            this.apkProgress = false;
            this.$Message.error('上传失败，请重新上传');
        },
        removeAPK: function removeAPK() {
            this.apkName = '';
            this.formItem.downloadUrl = '';
        },

        /*logo上传控件*/
        logoUploadSuccess: function logoUploadSuccess(res, file) {
            this.formItem.appLogo = res.content;
            this.logoUpload.push(res.content);
            this.logoProgress = false;
            this.$Message.success('上传成功');
        },
        logoUploadFail: function logoUploadFail() {
            this.formItem.appLogo = '';
            this.logoUpload = [];
            this.logoProgress = false;
            this.$Message.error('上传失败，请重新上传');
        },
        checkLogoUpload: function checkLogoUpload() {
            if (this.logoUpload.length > 0) {
                this.$Message.error('只能上传一个Logo文件');
                return false;
            }
        },
        handleLogoUpload: function handleLogoUpload(res, file, list) {
            this.logoProgress = true;
        },
        handleLogoView: function handleLogoView() {
            this.logoVisible = true;
        },
        handleLogoRemove: function handleLogoRemove() {
            this.logoUpload = [];
            this.formItem.appLogo = '';
        },

        /*视频上传控件*/
        videoUploadSuccess: function videoUploadSuccess(res, file) {
            this.formItem.playerSrc = res.content;
            this.videoUpload.push(res.content);
            this.videoProgress = false;
            this.$Message.success('上传成功');
        },
        videoUploadFail: function videoUploadFail() {
            this.formItem.playerSrc = '';
            this.videoUpload = [];
            this.videoProgress = false;
            this.$Message.error('上传失败，请重新上传');
        },
        handleVideoUpload: function handleVideoUpload(res, file, list) {
            this.videoProgress = true;
        },
        checkVideoUpload: function checkVideoUpload() {
            if (this.videoUpload.length > 0) {
                this.$Message.error('只能上传一个视频文件');
                return false;
            }
        },
        removeVideo: function removeVideo() {
            this.formItem.playerSrc = '';
            this.videoUpload = [];
        },

        /*展示图上传控件*/
        imgUploadSuccess: function imgUploadSuccess(res, file) {
            this.imgUpload.push(res.content);
            this.imgProgress = false;
            this.$Message.success('上传成功');
        },
        handleImgUpload: function handleImgUpload(res, file, list) {
            this.imgProgress = true;
        },
        checkImgUpload: function checkImgUpload(file) {
            if (this.imgUpload.length > 4) {
                this.$Message.error('最多只能上传5张截图');
                return false;
            }
        },
        handleImgView: function handleImgView(url) {
            this.imgVisible = true;
            this.imgShow = url;
        },
        handleImgRemove: function handleImgRemove(url) {
            this.imgUpload.splice(this.imgUpload.indexOf(url), 1);
        },
        showAppDetail: function showAppDetail(areaId, order) {
            var active = 'webAppDetail';
            var currentTag = localStorage.getItem('currentTag');
            if (currentTag !== active) {
                var tags = null;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(_admin.adminRouter), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var ele = _step.value;

                        if (ele.name === active) {
                            tags = {
                                title: ele.title,
                                name: ele.name,
                                path: ele.path
                            };
                            break;
                        } else {
                            if (ele.children.length) {
                                var _iteratorNormalCompletion2 = true;
                                var _didIteratorError2 = false;
                                var _iteratorError2 = undefined;

                                try {
                                    for (var _iterator2 = (0, _getIterator3.default)(ele.children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                        var val = _step2.value;

                                        if (val.name === active) {
                                            tags = {
                                                title: val.title,
                                                name: val.name,
                                                path: val.path
                                            };
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                            _iterator2.return();
                                        }
                                    } finally {
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                localStorage.setItem("currentTag", active);
                localStorage.setItem("areaId", areaId);
                localStorage.setItem("sortOrder", order);
                this.$store.commit("updateCurrentTag", active);
                this.$store.commit("updateOpenedTags", [tags]);
                this.$store.commit("updateCurrentPath", active);
                this.$router.push({
                    name: active
                });
            }
        },
        saveChange: function saveChange() {
            var _this = this;

            this.formItem.posterSrc = this.imgUpload[0];
            for (var i = 1; i < this.imgUpload.length; i++) {
                this.formItem.posterSrc = this.formItem.posterSrc + '分割' + this.imgUpload[i];
            }
            if (this.formItem.createDate) {
                this.formItem.createDate = this.formItem.time.getTime();
            }
            var areaId = this.formItem.areaId;
            delete this.formItem.time;
            this.$http.post('/zm/WMWebsite/updateProductInfo', this.formItem).then(function (res) {
                if (res.data.code === -1) {
                    _this.$Message.error(res.data.errorMsg);
                } else {
                    _this.$Message.success("上产成功！");
                    _this.showAppDetail(areaId, _this.sortOrder);
                }
                _this.formItem = {};
                _this.logoUpload = [];
                _this.videoUpload = [];
                _this.imgUpload = [];
            }, function (err) {
                _this.$Message.error("提交失败！" + err.message);
            });
        },
        submitTotal: function submitTotal() {
            var _this2 = this;

            this.formItem.posterSrc = this.imgUpload[0];
            for (var i = 1; i < this.imgUpload.length; i++) {
                this.formItem.posterSrc = this.formItem.posterSrc + '分割' + this.imgUpload[i];
            }
            if (this.formItem.createDate) {
                this.formItem.createDate = this.formItem.time.getTime();
            }
            var areaId = this.formItem.areaId;
            delete this.formItem.time;
            this.$http.post('/zm/WMWebsite/addProductInfo', this.formItem).then(function (res) {
                if (res.data.code === -1) {
                    _this2.$Message.error(res.data.errorMsg);
                } else {
                    _this2.$Message.success("上产成功！");
                    _this2.showAppDetail(areaId, _this2.sortOrder);
                }
                _this2.formItem = {};
                _this2.logoUpload = [];
                _this2.videoUpload = [];
                _this2.imgUpload = [];
            }, function (err) {
                _this2.$Message.error("上传失败！" + err.message);
            });
        }
    },

    watch: {},
    created: function created() {},
    activated: function activated() {
        var _this3 = this;

        this.apkName = '';
        this.formItem = {};
        this.logoUpload = [];
        this.videoUpload = [];
        this.imgUpload = [];
        var areaId = Number(localStorage.getItem('areaId'));
        var area = 'productInfoArea' + areaId;
        var sortOrder = localStorage.getItem('sortOrder');
        if (sortOrder !== '') {
            this.isNew = false;
            var order = Number(sortOrder);
            this.sortOrder = order;
            this.$http.post('/zm/WMWebsite/queryProductInfos', {}).then(function (res) {
                var tempData = res.data.content;
                _this3.formItem = tempData[area][order];
                _this3.formItem.time = (0, _format.format2Sec)(_this3.formItem.createDate);
                if (_this3.formItem.posterSrc) {
                    _this3.imgUpload = _this3.formItem.posterSrc.split('分割');
                }
                if (_this3.formItem.appLogo) {
                    _this3.logoUpload.push(_this3.formItem.appLogo);
                }
                if (_this3.formItem.playerSrc) {
                    _this3.videoUpload.push(_this3.formItem.playerSrc);
                }
                if (_this3.apkName) {
                    _this3.apkName = _this3.formItem.downloadUrl;
                }
                _this3.formItem.appCategory = String(_this3.formItem.appCategory);
            });
        } else {
            this.isNew = true;
            var length = Number(localStorage.getItem('length'));
            this.formItem.areaId = areaId;
            this.formItem.sortId = length;
            this.sortOrder = length;
        }
    }
};

/***/ }),

/***/ "f87Q":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fDCX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fZhn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g6Jh":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message-container"
  }, [_c('Tooltip', {
    staticClass: "message-tip",
    attrs: {
      "content": _vm.value > 0 ? '有' + _vm.value + '条未读信息' : '无未读信息',
      "type": "ios-bell",
      "placement": "bottom"
    }
  }, [_c('Badge', {
    attrs: {
      "count": _vm.value,
      "dot": ""
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-bell",
      "size": "22"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "gMJu":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("RiA/"),
  /* template */
  __webpack_require__("ueoP"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "gcER":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "min-width": "1100px"
    }
  }, [_c('p', {
    staticClass: "paraHead",
    staticStyle: {
      "font-size": "26px"
    }
  }, [_vm._v("盲人用户详情")]), _vm._v(" "), _c('Card', {
    staticClass: "bodyCard"
  }, [_c('Row', {
    attrs: {
      "gutter": 64
    }
  }, [_c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "background-color": "#fff"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.blindUser.avatarUrl,
      "alt": "headUrl"
    }
  })])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("昵称:"), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.blindUser.nickname))])]), _vm._v(" "), _c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("加入时间:"), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.blindUser.createDate))])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("提问数量:\n        "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    staticClass: "answerInfo"
  }, [_vm._v(_vm._s(_vm.blindUser.helpInfoCount))]), _vm._v("条")])]), _vm._v(" "), _c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("城市:\n        "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    staticClass: "answerInfo"
  }, [_vm._v(_vm._s(_vm.blindUser.city))])])]), _vm._v(" "), _c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("性别:\n        "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    staticClass: "answerInfo"
  }, [_vm._v(_vm._s(_vm.blindUser.sex))])])])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('p', {
    staticClass: "basicInfo"
  }, [_vm._v("便签:\n        "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('span', {
    staticClass: "answerInfo"
  }, [_vm._v(_vm._s(_vm.blindUser.tag))])])])])], 1)], 1), _vm._v(" "), _c('p', {
    staticClass: "paraHead",
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("提问历史")]), _vm._v(" "), _c('Tabs', {
    staticStyle: {
      "margin": "25px",
      "width": "95%"
    },
    attrs: {
      "value": "totalMessage"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "全部消息",
      "name": "totalMessage"
    }
  }, [_c('table', {
    staticClass: "fourDiv"
  }, [_c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "width": "25%"
    }
  }, [_c('div', {
    staticClass: "innerDiv"
  }, [_c('div', {
    staticClass: "divHead"
  }, [_vm._v("\n                时间\n              ")]), _vm._v(" "), _c('Button', {
    staticClass: "btn",
    staticStyle: {
      "border": "none",
      "background-color": "rgb(245,247,249)"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getAllTime.apply(null, arguments)
      }
    }
  }, [_c('Radio', {
    staticStyle: {
      "font-size": "14px",
      "margin": "5% 0 5% -20%"
    },
    on: {
      "on-change": function($event) {}
    },
    model: {
      value: (_vm.totalTime),
      callback: function($$v) {
        _vm.totalTime = $$v
      },
      expression: "totalTime"
    }
  }, [_vm._v("所有时间")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("最近 "), _c('span', [_c('Select', {
    staticStyle: {
      "width": "60%"
    },
    model: {
      value: (_vm.recentTime),
      callback: function($$v) {
        _vm.recentTime = $$v
      },
      expression: "recentTime"
    }
  }, _vm._l((_vm.timeList), function(timer) {
    return _c('Option', {
      key: timer.value,
      attrs: {
        "value": timer.value
      }
    }, [_vm._v(_vm._s(timer.label))])
  }), 1)], 1)]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "80%",
      "margin": "5%"
    },
    attrs: {
      "type": "date",
      "placeholder": "起始时间"
    },
    model: {
      value: (_vm.fromTime),
      callback: function($$v) {
        _vm.fromTime = $$v
      },
      expression: "fromTime"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "16px",
      "margin-left": "-70%"
    }
  }, [_vm._v("至")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "80%",
      "margin": "5%"
    },
    attrs: {
      "type": "date",
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.toTime),
      callback: function($$v) {
        _vm.toTime = $$v
      },
      expression: "toTime"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "0 -50% 3% 0"
    }
  }, [_vm._v("设为默认 "), _c('i-switch', {
    on: {
      "on-change": _vm.change1
    },
    model: {
      value: (_vm.switch1),
      callback: function($$v) {
        _vm.switch1 = $$v
      },
      expression: "switch1"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center",
      "width": "25%"
    }
  }, [_c('div', {
    staticClass: "innerDiv"
  }, [_c('div', {
    staticClass: "divHead"
  }, [_vm._v("\n                盲人评分\n              ")]), _vm._v(" "), _c('Button', {
    staticClass: "btn",
    staticStyle: {
      "border": "none",
      "background-color": "rgb(245,247,249)"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getAllRate.apply(null, arguments)
      }
    }
  }, [_c('Radio', {
    staticStyle: {
      "font-size": "14px",
      "margin": "5% 0 5% -50%"
    },
    model: {
      value: (_vm.totalRate),
      callback: function($$v) {
        _vm.totalRate = $$v
      },
      expression: "totalRate"
    }
  }, [_vm._v("所有评分")])], 1), _vm._v(" "), _c('CheckboxGroup', {
    model: {
      value: (_vm.rateArr),
      callback: function($$v) {
        _vm.rateArr = $$v
      },
      expression: "rateArr"
    }
  }, [_c('Checkbox', {
    staticClass: "pInCheck",
    attrs: {
      "label": "5星"
    }
  }, [_c('Rate', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.rate5),
      callback: function($$v) {
        _vm.rate5 = $$v
      },
      expression: "rate5"
    }
  })], 1), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    attrs: {
      "label": "4星"
    }
  }, [_c('Rate', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.rate4),
      callback: function($$v) {
        _vm.rate4 = $$v
      },
      expression: "rate4"
    }
  })], 1), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    attrs: {
      "label": "3星"
    }
  }, [_c('Rate', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.rate3),
      callback: function($$v) {
        _vm.rate3 = $$v
      },
      expression: "rate3"
    }
  })], 1), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    attrs: {
      "label": "2星"
    }
  }, [_c('Rate', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.rate2),
      callback: function($$v) {
        _vm.rate2 = $$v
      },
      expression: "rate2"
    }
  })], 1), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    attrs: {
      "label": "1星"
    }
  }, [_c('Rate', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.rate1),
      callback: function($$v) {
        _vm.rate1 = $$v
      },
      expression: "rate1"
    }
  })], 1), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    attrs: {
      "label": "0星"
    }
  }, [_vm._v("未评价")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "4% -50% 3% 0"
    }
  }, [_vm._v("设为默认 "), _c('i-switch', {
    on: {
      "on-change": _vm.change2
    },
    model: {
      value: (_vm.switch2),
      callback: function($$v) {
        _vm.switch2 = $$v
      },
      expression: "switch2"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center",
      "width": "25%"
    }
  }, [_c('div', {
    staticClass: "innerDiv"
  }, [_c('div', {
    staticClass: "divHead"
  }, [_vm._v("\n                当前进度\n              ")]), _vm._v(" "), _c('Button', {
    staticClass: "btn",
    staticStyle: {
      "border": "none",
      "background-color": "rgb(245,247,249)"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.getAllProcess.apply(null, arguments)
      }
    }
  }, [_c('Radio', {
    staticStyle: {
      "font-size": "14px",
      "margin": "5% 0 5% -20%"
    },
    model: {
      value: (_vm.totalProcess),
      callback: function($$v) {
        _vm.totalProcess = $$v
      },
      expression: "totalProcess"
    }
  }, [_vm._v("所有进度")])], 1), _vm._v(" "), _c('CheckboxGroup', {
    model: {
      value: (_vm.processArr),
      callback: function($$v) {
        _vm.processArr = $$v
      },
      expression: "processArr"
    }
  }, [_c('Checkbox', {
    staticClass: "pInCheck",
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "label": "zero"
    }
  }, [_vm._v(" 0人回复")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "label": "twenty"
    }
  }, [_vm._v(" 25%回复")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "label": "fifty"
    }
  }, [_vm._v(" 50%回复")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "label": "seventy"
    }
  }, [_vm._v(" 75%回复")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "label": "hundred"
    }
  }, [_vm._v(" 100%回复")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "label": "manager"
    }
  }, [_vm._v(" 已有管理员回复")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "2% -50% 2% 0"
    }
  }, [_vm._v("设为默认 "), _c('i-switch', {
    on: {
      "on-change": _vm.change3
    },
    model: {
      value: (_vm.switch3),
      callback: function($$v) {
        _vm.switch3 = $$v
      },
      expression: "switch3"
    }
  })], 1)], 1)]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center",
      "width": "25%"
    }
  }, [_c('div', {
    staticClass: "innerDiv"
  }, [_c('div', {
    staticClass: "divHead"
  }, [_vm._v("\n                求助方式\n              ")]), _vm._v(" "), _c('CheckboxGroup', {
    model: {
      value: (_vm.wayArr),
      callback: function($$v) {
        _vm.wayArr = $$v
      },
      expression: "wayArr"
    }
  }, [_c('Checkbox', {
    staticClass: "pInCheck",
    staticStyle: {
      "margin-top": "10%"
    },
    attrs: {
      "label": "picAndWord"
    }
  }, [_vm._v("图片 + 文字")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    staticStyle: {
      "margin-top": "10%"
    },
    attrs: {
      "label": "picAndVoice"
    }
  }, [_vm._v("图片 + 语音")]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "width": "80%",
      "margin": "10% auto",
      "border": "1px solid #CCCCCC"
    }
  }), _vm._v(" "), _c('Checkbox', {
    staticClass: "pInCheck",
    attrs: {
      "label": "shortVideo"
    }
  }, [_vm._v("短视频")])], 1), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin": "7% -50% 2% 0"
    }
  }, [_vm._v("设为默认 "), _c('i-switch', {
    on: {
      "on-change": _vm.change4
    },
    model: {
      value: (_vm.switch4),
      callback: function($$v) {
        _vm.switch4 = $$v
      },
      expression: "switch4"
    }
  })], 1)], 1)])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('hr', {
    staticStyle: {
      "width": "98%",
      "margin": "1% auto",
      "border": "1px solid #CCCCCC"
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('Button', {
    staticStyle: {
      "width": "5%",
      "margin": "0 1% 1% 0"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.resetAll.apply(null, arguments)
      }
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "width": "5%",
      "margin": "0 0 1% 1%"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.searchQus.apply(null, arguments)
      }
    }
  }, [_vm._v("筛选")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "searchCard"
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-left": "40%",
      "margin-top": "1%"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.searchItem.apply(null, arguments)
      }
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "10"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "type": "text",
      "placeholder": "问题关键字",
      "clearable": ""
    },
    on: {
      "on-change": _vm.summaryChange,
      "on-enter": _vm.searchItem
    },
    model: {
      value: (_vm.vitalWord),
      callback: function($$v) {
        _vm.vitalWord = $$v
      },
      expression: "vitalWord"
    }
  }, [_c('Button', {
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "slot": "append",
      "icon": "close-circled"
    },
    on: {
      "click": _vm.clearInputInfo
    },
    slot: "append"
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Table', {
    staticClass: "mainTable",
    attrs: {
      "stripe": "",
      "columns": _vm.columns,
      "data": _vm.tableData
    }
  }), _vm._v(" "), _c('Page', {
    staticClass: "paging",
    attrs: {
      "total": _vm.dataCount,
      "page-size": _vm.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "gxDU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _format = __webpack_require__("4/BI");

var _admin = __webpack_require__("4piF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Utils from '../../utils/util.js';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "blindDetail",
  data: function data() {
    var _this = this;

    return {
      blindUser: {
        "avatarUrl": "",
        "nickname": "", //昵称
        "createDate": "", //加入时间
        "helpInfoCount": 0, //提问数量
        "city": "", //城市
        "sex": "", //性别
        "tag": "" //被提问数量
      },
      /*时间模块的相关参数*/
      totalTime: true, //所有时间单选按钮
      recentTime: "一周", //选择列表最近的时间
      timeList: [{
        value: '一天',
        label: '一天'
      }, {
        value: '一周',
        label: '一周'
      }, {
        value: '一月',
        label: '一月'
      }, {
        value: '一年',
        label: '一年'
      }],
      fromTime: "", //起始时间
      toTime: "", //结束时间
      switch1: true, //第一个设为默认

      /*盲人评分模块的相关参数*/
      totalRate: true, //所有评分单选按钮
      rate5: 5,
      rate4: 4,
      rate3: 3,
      rate2: 2,
      rate1: 1,
      check: "",
      rateArr: ['5星', '4星', '3星', '2星', '1星', '0星'], //获取盲人评分数组
      switch2: true, //第二个设为默认

      /*当前进度模块的相关参数*/
      totalProcess: true, //所有进度单选按钮
      processArr: ['zero', 'twenty', 'fifty', 'seventy', 'hundred', 'manager'], //获取当前进度数组
      switch3: true, //第三个设为默认

      /*求助方式模块的相关参数*/
      wayArr: ['picAndWord', 'picAndVoice', 'shortVideo'], //求助方式选项数组
      switch4: true,
      vitalWord: "", //搜索框的内容
      columns: [{
        title: 'ID',
        key: "id",
        align: 'center'
      }, {
        title: "求助时间",
        key: "updateTime",
        align: 'center',
        sortable: true,
        render: function render(h, params) {
          return h("div", (0, _format.format)(params.row.updateTime, "yyyy-MM-dd hh:mm"));
        }
      }, {
        title: "求助方式",
        key: "askWay",
        align: 'center',
        render: function render(h, params) {
          return h('div', (0, _format.formatAskWay)(params.row.askWay));
        }
      }, {
        title: "盲人昵称",
        key: "nickname",
        align: 'center'
      }, {
        title: "问题缩略",
        key: "helpText",
        align: 'center'
      }, {
        title: "当前进度",
        key: "process",
        align: 'center'
      }, {
        title: '详情',
        align: 'center',
        render: function render(h, params) {
          return h('Button', {
            props: {
              type: "primary",
              icon: "ios-arrow-right"
            },
            style: {
              border: 'none',
              fontSize: "20px"
            },
            on: {
              click: function click() {
                //转到求助消息详情页面
                var id = parseInt(params.row.id);
                var helpInfo = {};
                var offerHelpInfos = [];
                _this.$http.post("/zm/help/getQuestionAndAnswer", { "id": id }).then(function (res) {
                  helpInfo = res.data.content.helpInfo;
                  offerHelpInfos = res.data.content.offerHelpInfos;
                  if (!helpInfo.openid) {
                    _this.$Message.error("获取信息失败");
                    return;
                  }
                  var active = "helpMessageManage"; //下个版本更新url
                  _this.$http.post("/zm/backManage/queryAllQuestionsByOpneid", {
                    "content": {},
                    "openid": helpInfo.openid
                  }).then(function (res) {
                    if (_this.currentTag !== active) {
                      var tags = null;
                      var _iteratorNormalCompletion = true;
                      var _didIteratorError = false;
                      var _iteratorError = undefined;

                      try {
                        for (var _iterator = (0, _getIterator3.default)(_admin.adminRouter), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                          var ele = _step.value;

                          if (ele.name === active) {
                            tags = {
                              title: ele.title,
                              name: ele.name,
                              path: ele.path
                            };
                            break;
                          } else {
                            if (ele.children.length) {
                              var _iteratorNormalCompletion2 = true;
                              var _didIteratorError2 = false;
                              var _iteratorError2 = undefined;

                              try {
                                for (var _iterator2 = (0, _getIterator3.default)(ele.children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                  var val = _step2.value;

                                  if (val.name === active) {
                                    tags = {
                                      title: val.title,
                                      name: val.name,
                                      path: val.path
                                    };
                                    break;
                                  }
                                }
                              } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                              } finally {
                                try {
                                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                  }
                                } finally {
                                  if (_didIteratorError2) {
                                    throw _iteratorError2;
                                  }
                                }
                              }
                            }
                          }
                        }
                      } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                      } finally {
                        try {
                          if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                          }
                        } finally {
                          if (_didIteratorError) {
                            throw _iteratorError;
                          }
                        }
                      }

                      localStorage.setItem("currentTag", active);
                      _this.$store.commit("updateCurrentTag", active);
                      _this.$store.commit("updateOpenedTags", [tags]);
                      _this.$store.commit("updateCurrentPath", active);
                      (0, _assign2.default)(helpInfo, res);
                      _this.$router.push({
                        name: "helpMessageManage",
                        params: {
                          "helpInfo": helpInfo,
                          "offerHelpInfos": offerHelpInfos
                        }
                      });
                    }
                  }, function (err) {
                    _this.$Message.error("请求失败：" + err.message);
                  });
                });
              }
            }
          });
        }
      }],
      dataCount: 0, //初始化信息总条数
      pageSize: 20, //每页条数
      tableLoading: false, //表格是否加载
      dataSearch: //请求的数据
      {
        "code": 0,
        "content": {},
        "currPage": 1,
        "pageSize": 20,
        "pageTotal": 0
      },
      tableData: []
    };
  },
  destroyed: function destroyed() {
    this.$router.go(-1);
  },

  methods: {
    // functionA(){ //调用menu-list的函数用于切换页面
    //   Utils.$emit('demo', 'helpMessageManage');
    // },
    change1: function change1() {
      //第一个设为默认
      if (this.switch1) {
        this.totalTime = true;
        this.recentTime = "一周";
        this.fromTime = "";
        this.toTime = "";
      } else {
        this.totalTime = false;
      }
    },
    change2: function change2() {
      //第二个设为默认
      if (!this.switch2) {
        this.totalRate = false;
        this.rateArr = [];
      } else {
        this.rateArr = ['5星', '4星', '3星', '2星', '1星', '0星'];
        this.totalRate = true;
      }
    },
    change3: function change3() {
      //第三个设为默认
      if (!this.switch3) {
        this.totalProcess = false;
        this.processArr = [];
      } else {
        this.totalProcess = true;
        this.processArr = ['zero', 'twenty', 'fifty', 'seventy', 'hundred', 'manager'];
      }
    },
    change4: function change4() {
      if (!this.switch4) {
        this.wayArr = [];
      } else {
        this.wayArr = ['picAndWord', 'picAndVoice', 'shortVideo'];
      }
    },
    getAllTime: function getAllTime() {
      /*所有时间单选按钮*/
      this.totalTime = !this.totalTime;
      if (!this.totalTime) {
        this.switch1 = false;
      }
    },
    getAllRate: function getAllRate() {
      /*点击所有评分*/
      if (!this.totalRate) {
        this.totalRate = true;
        this.rateArr = ['5星', '4星', '3星', '2星', '1星', '0星'];
        this.switch2 = true;
      } else {
        this.totalRate = false;
        this.rateArr = [];
        this.switch2 = false;
      }
    },
    getAllProcess: function getAllProcess() {
      /*点击所有进度*/
      if (!this.totalProcess) {
        this.totalProcess = true;
        this.processArr = ['zero', 'twenty', 'fifty', 'seventy', 'hundred', 'manager'];
        this.switch3 = true;
      } else {
        this.totalProcess = false;
        this.processArr = [];
        this.switch3 = false;
      }
    },
    resetAll: function resetAll() {
      //重置
      this.switch1 = true;
      this.switch2 = true;
      this.switch3 = true;
      this.switch4 = true;
      this.change1();
      this.change2();
      this.change3();
      this.change4();
    },
    searchQus: function searchQus() {
      //筛选
      console.log("选择列表最近的时间   :" + this.recentTime);
      console.log("起始时间  :" + this.fromTime);
      console.log("结束时间   :" + this.toTime);
      console.log("盲人评分数组   :" + this.rateArr);
      console.log("当前进度数组   :" + this.processArr);
      console.log("求助方式数组   :" + this.wayArr);
    },
    clearInputInfo: function clearInputInfo() {
      //清除搜索框的内容
      this.vitalWord = "";
    },
    summaryChange: function summaryChange() {
      //搜索框中的内容改变触发
      if (this.vitalWord === "") {
        delete this.dataSearch.content["helpText"];
      } else {
        this.dataSearch.content.helpText = this.vitalWord;
      }
    },
    searchItem: function searchItem() {
      var _this2 = this;

      //点击搜索
      this.tableLoading = true;
      this.dataSearch.currPage = 1;
      this.currPage = 1;
      var openId = this.$route.query.openId;
      this.$http.post('/zm/backManage/queryAllQuestionsByOpenid?openid=' + openId, this.dataSearch).then(function (res) {
        _this2.tableData = res.data.content;
        _this2.dataCount = res.data.pageTotal;
        _this2.pageSize = res.data.pageSize;
        _this2.$data.tableLoading = false;
      });
    },
    changePage: function changePage(index) {
      var _this3 = this;

      //改变页数
      this.dataSearch.currPage = index;
      // console.log(this.dataSearch);
      var openId = this.$route.query.openId;
      this.tableLoading = true;
      this.$http.post('/zm/backManage/queryAllQuestionsByOpenid?openid=' + openId, this.dataSearch).then(function (res) {
        _this3.tableData = res.data.content;
        _this3.dataCount = res.data.pageTotal;
        _this3.pageSize = res.data.pageSize;
        _this3.tableLoading = false;
      });
    },
    getData: function getData() {
      var _this4 = this;

      //获取数据
      var id = this.$route.query.id;
      var openId = this.$route.query.openId;
      // console.log(id);
      // console.log(openId);
      this.$http.post('/zm/backManage/queryAskerInfoDetail?id=' + id + '&openid=' + openId).then(function (res) {
        _this4.blindUser = res.data.content;

        _this4.dataSearch.content = { "openid": openId }; //修改传回去的参数
        /*获取这个盲人提问的所有问题*/
        _this4.$http.post('/zm/backManage/queryAllQuestionsByOpenid?openid=' + openId, _this4.dataSearch).then(function (res) {
          _this4.tableData = res.data.content;
          _this4.dataCount = res.data.pageTotal;
          _this4.pageSize = res.data.pageSize;
        });
      }, function (err) {
        _this4.$Message.error("请求失败：" + err.message);
        _this4.tableLoading = false;
      });
    }
  },
  watch: {},
  activated: function activated() {
    this.getData();
  },
  mounted: function mounted() {}
};

/***/ }),

/***/ "hnz0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hsz7":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("ygWc")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("N1/5"),
  /* template */
  __webpack_require__("RhdG"),
  /* scopeId */
  "data-v-7051de8a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "i3pt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iQH9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.84d4431.png";

/***/ }),

/***/ "j7e0":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("XIde")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("t5eG"),
  /* template */
  __webpack_require__("G5xB"),
  /* scopeId */
  "data-v-602501ef",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "jY36":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout",
    class: {
      'layout-hide-text': _vm.shrink
    }
  }, [_c('Row', {
    attrs: {
      "type": "flex"
    }
  }, [_c('Col', {
    staticClass: "layout-menu-left"
  }, [_c('menu-lists', {
    attrs: {
      "shrink": _vm.shrink
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticClass: "layout-menu-right"
  }, [_c('div', {
    staticClass: "layout-header"
  }, [_c('div', {
    staticClass: "header-menu"
  }, [_c('Button', {
    staticClass: "menu-btn",
    attrs: {
      "type": "text"
    },
    on: {
      "click": _vm.toggleClick
    }
  }, [(_vm.shrink) ? _c('Icon', {
    attrs: {
      "type": "arrow-right-c",
      "size": "32"
    }
  }) : _c('Icon', {
    attrs: {
      "type": "navicon",
      "size": "32"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "header-panel"
  }, [_c('div', {
    staticClass: "header-panel-icon"
  }, [_c('message-tip', {
    model: {
      value: (_vm.mesCount),
      callback: function($$v) {
        _vm.mesCount = $$v
      },
      expression: "mesCount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "header-panel-user"
  }, [_c('Dropdown', {
    staticClass: "header-dropdown",
    attrs: {
      "transfer": "",
      "trigger": "click"
    },
    on: {
      "on-click": _vm.handleDropdown
    }
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "data-uid": _vm.userInfo.uid
    }
  }, [_vm._v("\n                " + _vm._s(_vm.userInfo.user) + "\n                "), _c('Icon', {
    attrs: {
      "type": "arrow-down-b"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "userCenter"
    }
  }, [_vm._v("个人中心")]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "logout"
    }
  }, [_vm._v("退出登录")])], 1)], 1), _vm._v(" "), _c('Avatar', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.avatarSrc
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "header-breadcrumb"
  }, [_c('Breadcrumb', _vm._l((_vm.currentPath), function(item, index) {
    return _c('BreadcrumbItem', {
      key: item.name,
      attrs: {
        "href": _vm.showHref(item, index)
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tags-wrap"
  }, [_c('tag-lists', {
    attrs: {
      "shrink": _vm.shrink,
      "offsetLeft": _vm.tagOffsetLeft
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "layout-content"
  }, [_c('div', {
    staticClass: "layout-page"
  }, [_c('keep-alive', [_c('router-view')], 1)], 1)])])], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "jlNB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jop8":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.searchable) ? _c('div', {
    staticClass: "search-con"
  }, [_c('Form', {
    ref: "searchForm",
    staticStyle: {
      "display": "inline-block",
      "width": "100%"
    },
    attrs: {
      "model": _vm.searchValue
    }
  }, [_c('div', {
    staticClass: "search-item"
  }, [_c('span', [_vm._v("文章标题: ")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "100px",
      "float": "right"
    },
    attrs: {
      "clearable": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.searchValue.title),
      callback: function($$v) {
        _vm.$set(_vm.searchValue, "title", $$v)
      },
      expression: "searchValue.title"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "search-item"
  }, [_c('span', [_vm._v("作者: ")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "100px",
      "float": "right"
    },
    attrs: {
      "clearable": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.searchValue.author),
      callback: function($$v) {
        _vm.$set(_vm.searchValue, "author", $$v)
      },
      expression: "searchValue.author"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "search-item"
  }, [_c('span', [_vm._v("专辑: ")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "100px",
      "float": "right"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    model: {
      value: (_vm.searchValue.albumId),
      callback: function($$v) {
        _vm.$set(_vm.searchValue, "albumId", $$v)
      },
      expression: "searchValue.albumId"
    }
  }, _vm._l((_vm.backAlbumList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search-item"
  }, [_c('span', [_vm._v("发布平台: ")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "100px",
      "float": "right"
    },
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    on: {
      "on-change": _vm.platChange,
      "on-clear": _vm.platClear
    },
    model: {
      value: (_vm.publicPlat),
      callback: function($$v) {
        _vm.publicPlat = $$v
      },
      expression: "publicPlat"
    }
  }, _vm._l((_vm.platList), function(item) {
    return _c('Option', {
      key: item.name,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search-item"
  }, [_c('span', [_vm._v("更新时间: ")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "300px",
      "float": "right"
    },
    attrs: {
      "type": "datetimerange",
      "placeholder": "开始时间-结束时间",
      "clearable": ""
    },
    on: {
      "on-change": _vm.dateTimeChange,
      "on-clear": _vm.dateTimeClear
    },
    model: {
      value: (_vm.checkedTime),
      callback: function($$v) {
        _vm.checkedTime = $$v
      },
      expression: "checkedTime"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    staticStyle: {
      "display": "inline-block",
      "float": "right"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_vm._v("重置")]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "trigger": "click"
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-left": "8px"
    }
  }, [_vm._v("\n            更多操作\n            "), _c('Icon', {
    attrs: {
      "type": "ios-arrow-down"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    nativeOn: {
      "click": function($event) {
        return _vm.addBackAlbum.apply(null, arguments)
      }
    }
  }, [_vm._v("新建专辑")]), _vm._v(" "), _c('DropdownItem', {
    nativeOn: {
      "click": function($event) {
        return _vm.updateBackAlbum.apply(null, arguments)
      }
    }
  }, [_vm._v("编辑专辑")]), _vm._v(" "), _c('DropdownItem', {
    nativeOn: {
      "click": function($event) {
        return _vm.deleteBackAlbum.apply(null, arguments)
      }
    }
  }, [_vm._v("删除专辑")]), _vm._v(" "), _c('DropdownItem', {
    nativeOn: {
      "click": function($event) {
        return _vm.updateData.apply(null, arguments)
      }
    }
  }, [_vm._v("同步")])], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('Table', {
    ref: "tablesMain",
    attrs: {
      "data": _vm.insideTableData,
      "columns": _vm.insideColumns,
      "stripe": _vm.stripe,
      "border": _vm.border,
      "show-header": _vm.showHeader,
      "width": _vm.width,
      "height": _vm.height,
      "loading": _vm.loading,
      "disabled-hover": _vm.disabledHover,
      "highlight-row": _vm.highlightRow,
      "row-class-name": _vm.rowClassName,
      "size": _vm.size,
      "no-data-text": _vm.noDataText,
      "no-filtered-data-text": _vm.noFilteredDataText
    },
    on: {
      "on-current-change": _vm.onCurrentChange,
      "on-select": _vm.onSelect,
      "on-select-cancel": _vm.onSelectCancel,
      "on-select-all": _vm.onSelectAll,
      "on-select-all-cancel": _vm.onSelectAllCancel,
      "on-selection-change": _vm.onSelectionChange,
      "on-sort-change": _vm.onSortChange,
      "on-filter-change": _vm.onFilterChange,
      "on-row-click": _vm.onRowClick,
      "on-row-dblclick": _vm.onRowDblclick,
      "on-expand": _vm.onExpand
    }
  }, [_vm._t("header", null, {
    "slot": "header"
  }), _vm._v(" "), _vm._t("footer", null, {
    "slot": "footer"
  }), _vm._v(" "), _vm._t("loading", null, {
    "slot": "loading"
  })], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px",
      "overflow": "hidden"
    }
  }, [(_vm.showDelete) ? _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('Button', {
    attrs: {
      "type": "error"
    },
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("删除")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.insidePageTotal,
      "current": _vm.insideCurrPage,
      "show-sizer": "",
      "show-elevator": "",
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePage,
      "on-page-size-change": _vm.changePageSize
    }
  })], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "closable": false,
      "mask-closable": false,
      "width": "450px"
    },
    model: {
      value: (_vm.otherHandle),
      callback: function($$v) {
        _vm.otherHandle = $$v
      },
      expression: "otherHandle"
    }
  }, [_c('Form', {
    ref: "albumInput",
    attrs: {
      "model": _vm.albumInput,
      "rules": _vm.ruleValidate
    }
  }, [(_vm.isAddAlbum) ? _c('FormItem', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "prop": "newAlbum",
      "label": "请输入新建专辑名称："
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "placeholder": "请输入",
      "clearable": ""
    },
    model: {
      value: (_vm.albumInput.newAlbum),
      callback: function($$v) {
        _vm.$set(_vm.albumInput, "newAlbum", $$v)
      },
      expression: "albumInput.newAlbum"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isUpdateAlbum) ? _c('FormItem', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "prop": "album",
      "label": "请选择要修改的专辑名："
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "180px",
      "float": "left"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.albumInput.albumId),
      callback: function($$v) {
        _vm.$set(_vm.albumInput, "albumId", $$v)
      },
      expression: "albumInput.albumId"
    }
  }, _vm._l((_vm.backAlbumList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "94px"
    }
  }, [_vm._v("修改为：")]), _vm._v(" "), _c('Input', {
    staticStyle: {
      "width": "180px",
      "margin-left": "9px"
    },
    attrs: {
      "placeholder": "请输入",
      "clearable": ""
    },
    model: {
      value: (_vm.albumInput.album),
      callback: function($$v) {
        _vm.$set(_vm.albumInput, "album", $$v)
      },
      expression: "albumInput.album"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isDeleteAlbum) ? _c('FormItem', {
    staticStyle: {
      "display": "inline"
    },
    attrs: {
      "prop": "albumIds",
      "label": "请选择要删除的专辑："
    }
  }, [_c('Select', {
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "placeholder": "请选择",
      "multiple": ""
    },
    model: {
      value: (_vm.albumInput.albumIds),
      callback: function($$v) {
        _vm.$set(_vm.albumInput, "albumIds", $$v)
      },
      expression: "albumInput.albumIds"
    }
  }, _vm._l((_vm.backAlbumList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "size": "large"
    },
    on: {
      "click": _vm.cancelHandle
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.creatLoading
    },
    on: {
      "click": _vm.saveHandle
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ "kFXC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kTqd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuedraggable = __webpack_require__("w/TU");

var _vuedraggable2 = _interopRequireDefault(_vuedraggable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "publicSetting",
  components: {
    draggable: _vuedraggable2.default
  },
  data: function data() {
    return {
      editable: false,
      isDragging: false,
      delayedDragging: false,
      menuOrder: [],
      handleTips: {
        show: false,
        tips: '',
        title: ''
      },
      menuType: 'miniprogram',
      publicMenu: {}, //公众号菜单数据
      menuList: [], //公众号一级菜单内容
      appName: 'I_Can_Help', //公众号的name值
      publicTitle: '我能帮帮忙', //显示的公众号标题
      selectedBtn: {},
      selectedMenu: {}, //选中的一级菜单信息
      selectedSubMenu: {}, //选中的二级菜单信息
      newMenu: {
        name: '新菜单',
        type: 'view',
        url: ''
      },
      newSubMenu: {
        name: '新子菜单',
        type: 'view',
        url: ''
      },
      editAreaShow: { //控制菜单编辑内容显示
        show: false,
        title: '菜单'
      },
      messageShow: { //控制提示信息显示
        show: true,
        tip: '点击左侧菜单进行编辑操作'
      },
      sendBtnData: {}

    };
  },

  methods: {
    tabChanged: function tabChanged(name) {
      var _this = this;

      this.appName = name;
      switch (name) {
        case 'I_Can_Help':
          this.publicTitle = '我能帮帮忙';
          break;
        case 'ACCESSIBILITY_TECHNOLOGY':
          this.publicTitle = '无障碍科技';
          break;
        case 'qmtfwh':
          this.publicTitle = '启明瞳';
          break;
        default:
          this.publicTitle = '我能帮帮忙';
          break;
      }
      this.publicMenu = {};
      this.menuList = [];
      this.$http.post('/zm/backManage/getWXPublicNumberMenu?appName=' + this.appName).then(function (res) {
        _this.publicMenu = JSON.parse(res.data.content);
        var tempList = _this.publicMenu.selfmenu_info.button;
        for (var i = 0; i < tempList.length; i++) {
          if (tempList[i]['sub_button'] && tempList[i].sub_button['list'] && tempList[i].sub_button.list.length !== 0) {
            var tempArr = tempList[i].sub_button.list;
            tempList[i].sub_button = [];
            tempList[i].sub_button = tempArr;
          }
        }
        _this.menuList = tempList;
      }, function (err) {
        _this.$Message.error("请求失败：" + err.message);
      });
    },
    selectMenu: function selectMenu(item, index) {
      this.messageShow.show = false;
      this.selectedMenu = item;
      this.selectedBtn = {};
      this.selectedBtn.type = 'btn';
      this.selectedBtn.name = item.name;
      this.selectedBtn.menuIndex = index;
      if (item.type) {
        this.menuType = item.type;
        if (item.type === 'view') {
          this.selectedBtn.viewUrl = item.url;
        }
        if (item.type === 'miniprogram') {
          this.selectedBtn.miniProgramPagePath = item.pagepath;
          this.selectedBtn.miniProgramUrl = item.url;
          this.selectedBtn.appid = item.appid;
        }
      }
      if (item['sub_button'] && item.sub_button.length !== 0) {
        this.editAreaShow.show = false;
      } else {
        this.editAreaShow.show = true;
      }
      this.editAreaShow.title = '菜单';
    },
    selectSubMenu: function selectSubMenu(item, index, index2) {
      this.messageShow.show = false;
      this.selectedSubMenu = item;
      this.selectedBtn = {};
      this.selectedBtn.type = 'subBtn';
      this.selectedBtn.name = item.name;
      this.selectedBtn.menuIndex = index;
      this.selectedBtn.subMenuIndex = index2;
      if (item.type) {
        this.menuType = item.type;
        if (item.type === 'view') {
          this.selectedBtn.viewUrl = item.url;
        }
        if (item.type === 'miniprogram') {
          this.selectedBtn.miniProgramPagePath = item.pagepath;
          this.selectedBtn.miniProgramUrl = item.url;
          this.selectedBtn.appid = item.appid;
        }
      }
      this.editAreaShow.show = true;
      this.editAreaShow.title = '子菜单';
    },
    addMenu: function addMenu() {
      var i = this.menuList.length + 1;
      var menu = {};
      menu.name = this.newMenu.name + i;
      menu.type = this.newMenu.type;
      this.menuList.push(menu);
      this.selectMenu(menu, this.menuList.length - 1);
    },
    addSubMenu: function addSubMenu(index) {
      if (this.menuList[index]['sub_button'] && this.menuList[index].sub_button.length !== 0) {
        var i = this.menuList[index].sub_button.length + 1;
        var subMenu = {};
        subMenu.name = this.newSubMenu.name + i;
        subMenu.type = this.newSubMenu.type;
        this.menuList[index].sub_button.push(subMenu);
        this.selectSubMenu(subMenu, index, this.menuList[index].sub_button.length - 1);
      } else {
        this.handleTips.show = true;
        this.handleTips.title = '子菜单确认';
        this.handleTips.tips = '添加子菜单后，一级菜单的内容将被清除。确定添加子菜单？';
      }
    },
    changeType: function changeType(type) {
      //发送消息  跳转网页  跳转小程序
      this.menuType = type;
    },
    //改变 菜单内容 的显示
    handleConfirm: function handleConfirm() {
      if (this.handleTips.title === '子菜单确认') {
        var index = this.selectedBtn.menuIndex;
        this.menuList[index] = {
          name: this.menuList[index].name,
          sub_button: []
        };
        var i = this.menuList[index].sub_button.length + 1;
        var subMenu = {};
        subMenu.name = this.newSubMenu.name + i;
        subMenu.type = this.newSubMenu.type;
        this.menuList[index].sub_button.push(subMenu);
        this.selectSubMenu(subMenu, index, this.menuList[index].sub_button.length - 1);
        this.handleTips.show = false;
      } else if (this.handleTips.title === '删除确认') {
        if (this.selectedBtn.type === 'subBtn') {
          this.menuList[this.selectedBtn.menuIndex].sub_button.splice(this.selectedBtn.subMenuIndex, 1);
          this.messageShow.show = true;
        } else if (this.selectedBtn.type === 'btn') {
          this.menuList.splice(this.selectedBtn.menuIndex, 1);
          this.messageShow.show = true;
        }
      }
    },
    deletePublicMenu: function deletePublicMenu() {
      this.handleTips.show = true;
      this.handleTips.title = '删除确认';
      this.handleTips.tips = '删除后“' + this.selectedBtn.name + '”菜单下设置的内容将被删除';
    },
    disInRealtime: function disInRealtime(e) {
      if (this.selectedBtn.type === 'subBtn') {
        var tempObj = this.menuList[this.selectedBtn.menuIndex].sub_button[this.selectedBtn.subMenuIndex];
        if (this.menuType === 'view') {
          tempObj = {};
          tempObj.name = this.selectedBtn.name;
          tempObj.type = this.menuType;
          tempObj.url = this.selectedBtn.viewUrl;
        } else if (this.menuType === 'miniprogram') {
          tempObj = {};
          tempObj.name = this.selectedBtn.name;
          tempObj.type = this.menuType;
          tempObj.url = this.selectedBtn.miniProgramUrl;
          tempObj.pagepath = this.selectedBtn.miniProgramPagePath;
          tempObj.appid = this.selectedBtn.appid;
        }
        this.menuList[this.selectedBtn.menuIndex].sub_button[this.selectedBtn.subMenuIndex] = tempObj;
      } else if (this.selectedBtn.type === 'btn') {
        var _tempObj = this.menuList[this.selectedBtn.menuIndex];
        _tempObj.name = this.selectedBtn.name;
        if (this.editAreaShow.show) {
          if (this.menuType === 'view') {
            _tempObj = {};
            _tempObj.name = this.selectedBtn.name;
            _tempObj.type = this.menuType;
            _tempObj.url = this.selectedBtn.viewUrl;
          } else if (this.menuType === 'miniprogram') {
            _tempObj = {};
            _tempObj.name = this.selectedBtn.name;
            _tempObj.type = this.menuType;
            _tempObj.url = this.selectedBtn.miniProgramUrl;
            _tempObj.pagepath = this.selectedBtn.miniProgramPagePath;
            _tempObj.appid = this.selectedBtn.appid;
          }
        }
        this.menuList[this.selectedBtn.menuIndex] = _tempObj;
      }
    },
    startDrag: function startDrag() {
      this.editable = !this.editable;
      this.messageShow.show = true;
      this.messageShow.tip = '拖拽左侧菜单进行排序操作';
    },
    finishDrag: function finishDrag() {
      this.editable = !this.editable;
      this.messageShow.tip = '点击左侧菜单进行编辑操作';
    },
    onMove: function onMove(_ref) {
      var relatedContext = _ref.relatedContext,
          draggedContext = _ref.draggedContext;

      var relatedElement = relatedContext.element;
      var draggedElement = draggedContext.element;
      return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed;
    },
    saveChange: function saveChange() {
      var _this2 = this;

      this.sendBtnData.appName = this.appName;
      this.sendBtnData.button = this.menuList;
      console.log(this.sendBtnData);
      this.$http.post('/zm/backManage/updateWXPublicNumberMenu', this.sendBtnData).then(function (res) {
        if (res.data.content) {
          if (res.data.content === '更新成功') {
            _this2.$Message.success(res.data.content);
          } else {
            _this2.$Message.error(res.data.content);
          }
        }
        if (res.data.errorMsg) {
          _this2.$Message.error('操作失败' + res.data.errorMsg);
        }
      }, function (err) {
        _this2.$Message.error("请求失败：" + err.message);
      });
    }
  },
  computed: {
    menuSize: function menuSize() {
      return {
        sizeOf1: this.menuList.length === 0,
        sizeOf2: this.menuList.length === 1,
        sizeOf3: this.menuList.length === 2 || this.menuList.length === 3
      };
    },
    dragOptions: function dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost"
      };
    }
  },
  watch: {
    isDragging: function isDragging(newValue) {
      var _this3 = this;

      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(function () {
        _this3.delayedDragging = false;
      });
    }
  },
  created: function created() {
    var _this4 = this;

    this.$http.post('/zm/backManage/getWXPublicNumberMenu?appName=' + this.appName).then(function (res) {
      _this4.publicMenu = JSON.parse(res.data.content);
      var tempList = _this4.publicMenu.selfmenu_info.button;
      for (var i = 0; i < tempList.length; i++) {
        if (tempList[i]['sub_button'] && tempList[i].sub_button['list'] && tempList[i].sub_button.list.length !== 0) {
          var tempArr = tempList[i].sub_button.list;
          tempList[i].sub_button = [];
          tempList[i].sub_button = tempArr;
        }
      }
      _this4.menuList = tempList;
    }, function (err) {
      _this4.$Message.error("请求失败：" + err.message);
    });
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "lmfZ":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("5enB")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("FviQ"),
  /* template */
  __webpack_require__("8zdW"),
  /* scopeId */
  "data-v-7b3fbaee",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "mODz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _format = __webpack_require__("4/BI");

var _admin = __webpack_require__("4piF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "newsInfo",
    data: function data() {
        return {
            formItem: {},
            imgPath: [] //上传的图片地址
        };
    },

    methods: {
        editNewsInfo: function editNewsInfo(id) {
            var active = 'editNewsInfo';
            var currentTag = localStorage.getItem('currentTag');
            if (currentTag !== active) {
                var tags = null;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(_admin.adminRouter), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var ele = _step.value;

                        if (ele.name === active) {
                            tags = {
                                title: ele.title,
                                name: ele.name,
                                path: ele.path
                            };
                            break;
                        } else {
                            if (ele.children.length) {
                                var _iteratorNormalCompletion2 = true;
                                var _didIteratorError2 = false;
                                var _iteratorError2 = undefined;

                                try {
                                    for (var _iterator2 = (0, _getIterator3.default)(ele.children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                        var val = _step2.value;

                                        if (val.name === active) {
                                            tags = {
                                                title: val.title,
                                                name: val.name,
                                                path: val.path
                                            };
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                            _iterator2.return();
                                        }
                                    } finally {
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                localStorage.setItem("currentTag", active);
                localStorage.setItem("newsId", id);
                this.$store.commit("updateCurrentTag", active);
                this.$store.commit("updateOpenedTags", [tags]);
                this.$store.commit("updateCurrentPath", active);
                this.$router.push({
                    name: active
                });
            }
        }
    },
    activated: function activated() {
        var _this = this;

        this.formItem = {};
        var id = Number(localStorage.getItem('newsId'));
        this.$http.get('/zm/WMWebsite/queryNewsInfos').then(function (res) {
            var tempList = res.data.content;
            tempList.forEach(function (item) {
                if (item.id === id) {
                    _this.formItem = item;
                    _this.formItem.time = (0, _format.format2Sec)(_this.formItem.publicDate);
                    _this.formItem.newsCategory = String(_this.formItem.newsCategory);
                }
            });
        });
    }
};

/***/ }),

/***/ "mULj":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("ngxf")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("eh8g"),
  /* template */
  __webpack_require__("ql3x"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "mvzA":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.wrapClasses
  }, [(_vm.type !== 'textarea') ? [(_vm.prepend) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slotReady),
      expression: "slotReady"
    }],
    class: [_vm.prefixCls + '-group-prepend']
  }, [_vm._t("prepend")], 2) : _vm._e(), _vm._v(" "), (_vm.clearable && _vm.currentValue) ? _c('i', {
    staticClass: "ivu-icon",
    class: ['ivu-icon-ios-close', _vm.prefixCls + '-icon', _vm.prefixCls + '-icon-clear', _vm.prefixCls + '-icon-normal'],
    on: {
      "click": _vm.handleClear
    }
  }) : (_vm.icon) ? _c('i', {
    staticClass: "ivu-icon",
    class: ['ivu-icon-' + _vm.icon, _vm.prefixCls + '-icon', _vm.prefixCls + '-icon-normal'],
    on: {
      "click": _vm.handleIconClick
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.icon) ? _c('i', {
    staticClass: "ivu-icon ivu-icon-load-c ivu-load-loop",
    class: [_vm.prefixCls + '-icon', _vm.prefixCls + '-icon-validate']
  }) : _vm._e()]), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.inputClasses,
    attrs: {
      "id": _vm.elementId,
      "autocomplete": _vm.autocomplete,
      "spellcheck": _vm.spellcheck,
      "type": _vm.type,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "maxlength": _vm.maxlength,
      "readonly": _vm.readonly,
      "name": _vm.name,
      "number": _vm.number,
      "autofocus": _vm.autofocus
    },
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleEnter.apply(null, arguments)
      }, _vm.handleKeyup],
      "keypress": _vm.handleKeypress,
      "keydown": _vm.handleKeydown,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "input": _vm.handleInput,
      "change": _vm.handleChange
    }
  }), _vm._v(" "), (_vm.append) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.slotReady),
      expression: "slotReady"
    }],
    class: [_vm.prefixCls + '-group-append']
  }, [_vm._t("append")], 2) : _vm._e()] : _c('textarea', {
    ref: "textarea",
    class: _vm.textareaClasses,
    style: (_vm.textareaStyles),
    attrs: {
      "id": _vm.elementId,
      "wrap": _vm.wrap,
      "autocomplete": _vm.autocomplete,
      "spellcheck": _vm.spellcheck,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "rows": _vm.rows,
      "maxlength": _vm.maxlength,
      "readonly": _vm.readonly,
      "name": _vm.name,
      "autofocus": _vm.autofocus
    },
    domProps: {
      "value": _vm.currentValue
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleEnter.apply(null, arguments)
      }, _vm.handleKeyup],
      "keypress": _vm.handleKeypress,
      "keydown": _vm.handleKeydown,
      "focus": _vm.handleFocus,
      "blur": _vm.handleBlur,
      "input": _vm.handleInput
    }
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ "n0W8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _edit = __webpack_require__("5QFy");

var _edit2 = _interopRequireDefault(_edit);

__webpack_require__("IwIZ");

var _format = __webpack_require__("4/BI");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Tables',
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    albumList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    currPage: Number,
    pageSize: Number,
    pageTotal: Number,
    appName: String,
    size: String,
    width: {
      type: [Number, String]
    },
    height: {
      type: [Number, String]
    },
    stripe: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    highlightRow: {
      type: Boolean,
      default: false
    },
    rowClassName: {
      type: Function,
      default: function _default() {
        return '';
      }
    },
    context: {
      type: Object
    },
    noDataText: {
      type: String
    },
    noFilteredDataText: {
      type: String
    },
    disabledHover: {
      type: Boolean
    },
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * @description 全局设置是否可编辑
     */
    editable: {
      type: Boolean,
      default: false
    },
    /**
     * @description 是否可搜索
     */
    searchable: {
      type: Boolean,
      default: false
    }
  },
  /**
   * Events
   * @on-start-edit 返回值 {Object} ：同iview中render函数中的params对象 { row, index, column }
   * @on-cancel-edit 返回值 {Object} 同上
   * @on-save-edit 返回值 {Object} ：除上面三个参数外，还有一个value: 修改后的数据
   */
  data: function data() {
    return {
      checkedTime: [],
      publicPlat: '',
      platList: [{
        name: '小程序',
        value: 'miniappPublic'
      }, {
        name: '官网',
        value: 'websitePublic'
      }, {
        name: 'APP',
        value: 'appPublic'
      }],
      currAppName: '',
      pageResultVo: {},
      insideCurrPage: 1,
      insidePageSize: 10,
      insidePageTotal: 0,
      insideColumns: [],
      insideTableData: [],
      edittingCellId: '',
      edittingText: '',
      searchValue: {}, //查询数据
      showDelete: false,
      otherHandle: false, //控制其他操作弹窗
      isAddAlbum: false, //控制新增专辑弹窗
      isUpdateAlbum: false,
      isDeleteAlbum: false,
      creatLoading: false,
      backAlbumList: [], //获取所有专辑列表
      albumInput: {}, //专辑编辑表单
      ruleValidate: {
        newAlbum: [{ required: true, message: '专辑名不能为空', trigger: 'blur' }, { type: 'string', max: 10, message: '不能超过10个字符', trigger: 'blur' }],
        album: [{ required: true, message: '不能为空', trigger: 'blur' }, { type: 'string', max: 10, message: '不能超过10个字符', trigger: 'blur' }]
      }
    };
  },

  methods: {
    handleColumns: function handleColumns(columns) {
      var _this = this;

      this.insideColumns = columns.map(function (item, index) {
        var res = item;
        if (res.editable) res = _this.suportEdit(res, index);
        if (res.key === 'handle') res = _this.surportHandle(res);
        return res;
      });
    },
    handleTableData: function handleTableData() {
      this.insidePageTotal = this.pageTotal;
      this.insideCurrPage = this.currPage;
      this.insidePageTotal = this.pageTotal;
      this.backAlbumList = this.albumList;
      this.currAppName = this.appName;
      this.insideTableData = this.value.map(function (item, index) {
        var res = item;
        res.initRowIndex = index;
        return res;
      });
    },
    handleSubmit: function handleSubmit() {
      this.pageResultVo = {};
      this.searchValue.appName = this.currAppName;
      this.pageResultVo.content = this.searchValue;
      this.pageResultVo.currPage = 0;
      this.pageResultVo.pageSize = this.insidePageSize;
      console.log(this.pageResultVo);
      this.getInsideTableData();
    },
    handleReset: function handleReset() {
      this.searchValue = {};
      this.publicPlat = null;
      this.checkedTime = null;
    },
    suportEdit: function suportEdit(item, index) {
      var _this2 = this;

      item.render = function (h, params) {
        return h(_edit2.default, {
          props: {
            params: params,
            value: _this2.insideTableData[params.index][params.column.key],
            edittingCellId: _this2.edittingCellId,
            editable: _this2.editable,
            albumList: _this2.backAlbumList
          },
          on: {
            'input': function input(val) {
              _this2.edittingText = '';
              _this2.edittingText = val;
            },
            'on-start-edit': function onStartEdit(params) {
              _this2.edittingCellId = 'editting-' + params.index + '-' + params.column.key;
              _this2.$emit('on-start-edit', params);
            },
            'on-cancel-edit': function onCancelEdit(params) {
              _this2.edittingCellId = '';
              _this2.$emit('on-cancel-edit', params);
            },
            'on-save-edit': function onSaveEdit(params) {
              var obj = {};
              var tempArr = _this2.insideTableData;
              _this2.insideTableData = [];
              if (_this2.edittingText !== '') {
                obj.id = params.row.id;
                obj.index = params.row.initRowIndex;
                if (params.column.key === 'album') {
                  obj.albumId = _this2.edittingText;
                  params.row[params.column.key] = _this2.getAlbumName(_this2.edittingText);
                } else {
                  obj[params.column.key] = _this2.edittingText;
                  params.row[params.column.key] = _this2.edittingText;
                }
              }
              _this2.setBackMaterial(obj);
              tempArr[params.index] = params.row;
              _this2.insideTableData = tempArr;
              _this2.edittingCellId = '';
            },
            'on-save-modal': function onSaveModal(params) {
              _this2.setBackMaterial(params.row);
              var tempArr = _this2.insideTableData;
              _this2.insideTableData = [];
              params.row.album = _this2.getAlbumName(params.row.albumId);
              tempArr[params.index] = params.row;
              _this2.insideTableData = tempArr;
            }
          }
        });
      };
      return item;
    },
    getInsideTableData: function getInsideTableData() {
      var _this3 = this;

      this.$http.post('/zm/backManage/queryBackMaterialListByPage', this.pageResultVo).then(function (res) {
        _this3.insideCurrPage = res.data.currPage;
        _this3.insidePageSize = res.data.pageSize;
        _this3.insidePageTotal = res.data.pageTotal;
        var tempData = res.data.content;
        tempData.map(function (item, index) {
          var res1 = item;
          res1.initRowIndex = index;
          if (res1.updateTime) {
            res1.time = (0, _format.format2Sec)(res1.updateTime);
          }
          res1.album = _this3.getAlbumName(res1.albumId);
          return res1;
        });
        _this3.insideTableData = tempData;
        _this3.$Message.success('查询成功');
      }, function (err) {
        _this3.$Message.error("请求失败：" + err.message);
      });
    },
    surportHandle: function surportHandle(item) {
      var _this4 = this;

      item.render = function (h, params) {
        return h('div', [h('Poptip', {
          props: {
            confirm: true,
            title: params.row.miniappPublic === 1 ? '您确定从小程序上撤下吗？' : '您确定要发布到小程序上吗？',
            transfer: true
          },
          on: {
            'on-ok': function onOk() {
              params.row.miniappPublic = (params.row.miniappPublic + 1) % 2;
              var obj = {};
              obj.id = params.row.id;
              obj.miniappPublic = params.row.miniappPublic;
              _this4.setBackMaterial(obj);
            },
            'on-cancel': function onCancel() {}
          } }, [h('Button', {
          props: {
            size: 'small',
            type: params.row.miniappPublic === 1 ? 'primary' : 'default'
          },
          style: {
            marginRight: '10px'
          }
        }, '小程序')]), h('Poptip', {
          props: {
            confirm: true,
            title: params.row.websitePublic === 1 ? '您确定从官网上撤下吗？' : '您确定要发布到官网上吗？',
            transfer: true
          },
          on: {
            'on-ok': function onOk() {
              params.row.websitePublic = (params.row.websitePublic + 1) % 2;
              var obj = {};
              obj.id = params.row.id;
              obj.websitePublic = params.row.websitePublic;
              _this4.setBackMaterial(obj);
            },
            'on-cancel': function onCancel() {}
          } }, [h('Button', {
          props: {
            size: 'small',
            type: params.row.websitePublic === 1 ? 'primary' : 'default'
          },
          style: {
            marginRight: '10px'
          }
        }, '官网')]), h('Poptip', {
          props: {
            confirm: true,
            title: params.row.appPublic === 1 ? '您确定从APP上撤下吗？' : '您确定要发布到APP上吗？',
            transfer: true
          },
          on: {
            'on-ok': function onOk() {
              params.row.appPublic = (params.row.appPublic + 1) % 2;
              var obj = {};
              obj.id = params.row.id;
              obj.appPublic = params.row.appPublic;
              _this4.setBackMaterial(obj);
            },
            'on-cancel': function onCancel() {}
          } }, [h('Button', {
          props: {
            size: 'small',
            type: params.row.appPublic === 1 ? 'primary' : 'default'
          },
          style: {
            marginRight: '10px'
          }
        }, 'APP')])]);
      };
      return item;
    },
    changePage: function changePage(currPage) {
      this.pageResultVo = {};
      this.insideCurrPage = currPage;
      this.pageResultVo.content = { appName: this.currAppName };
      this.pageResultVo.currPage = this.insideCurrPage;
      this.pageResultVo.pageSize = this.insidePageSize;
      this.getInsideTableData();
    },
    changePageSize: function changePageSize(pageSize) {
      this.pageResultVo = {};
      this.insidePageSize = pageSize;
      this.pageResultVo.content = { appName: this.currAppName };
      this.pageResultVo.currPage = this.insideCurrPage;
      this.pageResultVo.pageSize = this.insidePageSize;
      this.getInsideTableData();
    },
    addBackAlbum: function addBackAlbum() {
      //显示新增专辑弹框
      this.albumInput = {};
      this.otherHandle = true;
      this.isAddAlbum = true;
    },
    updateBackAlbum: function updateBackAlbum() {
      this.albumInput = {};
      this.otherHandle = true;
      this.isUpdateAlbum = true;
    },
    deleteBackAlbum: function deleteBackAlbum() {
      this.albumInput = {};
      this.otherHandle = true;
      this.isDeleteAlbum = true;
    },
    saveHandle: function saveHandle() {
      var _this5 = this;

      //执行操作
      this.creatLoading = true;
      setTimeout(function () {
        _this5.creatLoading = false;
        _this5.$refs["albumInput"].validate(function (valid) {
          if (valid) {
            if (_this5.isAddAlbum) {
              for (var i = 0; i < _this5.backAlbumList.length; i++) {
                if (_this5.albumInput.newAlbum === _this5.backAlbumList[i].name) {
                  _this5.$Message.error('该专辑名已存在！');
                  return;
                }
              }
              _this5.$http.post("/zm/backManage/addBackAlbum", { "name": _this5.albumInput.newAlbum }).then(function () {
                _this5.$Message.success('操作成功!');
                _this5.otherHandle = false;
                _this5.isAddAlbum = false;
                _this5.getBackAlbumList(); //执行操作后更新专辑列表
              }, function (err) {
                _this5.$Message.error("操作失败：" + err.message);
              });
            }
            if (_this5.isUpdateAlbum) {
              for (var _i = 0; _i < _this5.backAlbumList.length; _i++) {
                if (_this5.albumInput.album === _this5.backAlbumList[_i].name) {
                  _this5.$Message.error('该专辑名已存在！');
                  return;
                }
              }
              _this5.$http.post("/zm/backManage/updateBackAlbum", { "name": _this5.albumInput.album,
                "id": _this5.albumInput.albumId }).then(function () {
                _this5.$Message.success('操作成功!');
                _this5.otherHandle = false;
                _this5.isUpdateAlbum = false;
                _this5.getBackAlbumList(); //执行操作后更新专辑列表
              }, function (err) {
                _this5.$Message.error("操作失败：" + err.message);
              });
            }
            if (_this5.isDeleteAlbum) {
              _this5.$http.post("/zm/backManage/deleteBackAlbum", { "backAlbumIds": _this5.albumInput.albumIds }).then(function () {
                _this5.$Message.success('操作成功!');
                _this5.otherHandle = false;
                _this5.isDeleteAlbum = false;
                _this5.getBackAlbumList(); //执行操作后更新专辑列表
              }, function (err) {
                _this5.$Message.error("操作失败：" + err.message);
              });
            }
          } else {
            _this5.$Message.error('操作失败!');
          }
        });
      }, 1000);
    },
    cancelHandle: function cancelHandle() {
      //取消操作
      this.otherHandle = false;
      this.isAddAlbum = false;
      this.isUpdateAlbum = false;
      this.isDeleteAlbum = false;
    },
    updateData: function updateData() {
      var _this6 = this;

      console.log({ "appName": this.currAppName });
      this.$http.post('/zm/backManage/synchroBackMaterial', { "appName": this.currAppName }).then(function (res) {
        if (res.data.content === '同步失败') {
          _this6.$Message.error(res.data.content);
        } else {
          _this6.$Message.success(res.data.content);
        }
      }, function (err) {
        _this6.$Message.error("请求失败：" + err.message);
      });
    },
    getBackAlbumList: function getBackAlbumList() {
      var _this7 = this;

      this.$http.post("/zm/backManage/queryAlbumList", {}).then(function (res) {
        _this7.backAlbumList = res.data.content;
        console.log("获取专辑列表");
      }, function (err) {
        _this7.$Message.error("请求失败：" + err.message);
      });
    },
    getAlbumName: function getAlbumName(id) {
      var name = void 0;
      for (var i = 0; i < this.backAlbumList.length; i++) {
        if (id === this.backAlbumList[i].id) {
          name = this.backAlbumList[i].name;
          break;
        } else {
          name = '请添加所属专辑';
        }
      }
      return name;
    },
    setBackMaterial: function setBackMaterial(obj) {
      var _this8 = this;

      this.$http.post('zm/backManage/updateBackMaterial', obj).then(function () {
        _this8.$Message.success('操作成功!');
      }, function (err) {
        _this8.$Message.error("请求失败：" + err.message);
      });
    },
    handleClear: function handleClear(e) {
      if (e.target.value === '') this.insideTableData = this.value;
    },
    exportCsv: function exportCsv(params) {
      this.$refs.tablesMain.exportCsv(params);
    },
    clearCurrentRow: function clearCurrentRow() {
      this.$refs.talbesMain.clearCurrentRow();
    },
    onCurrentChange: function onCurrentChange(currentRow, oldCurrentRow) {
      this.$emit('on-current-change', currentRow, oldCurrentRow);
    },
    onSelect: function onSelect(selection, row) {
      this.$emit('on-select', selection, row);
    },
    onSelectCancel: function onSelectCancel(selection, row) {
      this.$emit('on-select-cancel', selection, row);
    },
    onSelectAll: function onSelectAll(selection) {
      this.$emit('on-select-all', selection);
    },
    onSelectAllCancel: function onSelectAllCancel(selection) {
      this.$emit('on-select-all-cancel', selection);
    },
    onSelectionChange: function onSelectionChange(selection) {
      this.$emit('on-selection-change', selection);
      this.showDelete = true;
      if (selection.length === 0) {
        this.showDelete = false;
      }
    },
    onSortChange: function onSortChange(column, key, order) {
      this.$emit('on-sort-change', column, key, order);
    },
    onFilterChange: function onFilterChange(row) {
      this.$emit('on-filter-change', row);
    },
    onRowClick: function onRowClick(row, index) {
      this.$emit('on-row-click', row, index);
    },
    onRowDblclick: function onRowDblclick(row, index) {
      this.$emit('on-row-dblclick', row, index);
    },
    onExpand: function onExpand(row, status) {
      this.$emit('on-expand', row, status);
    },
    platChange: function platChange(value) {
      delete this.searchValue['miniappPublic'];
      delete this.searchValue['websitePublic'];
      delete this.searchValue['appPublic'];
      if (value) {
        this.searchValue[value] = 1;
      }
    },
    platClear: function platClear() {
      delete this.searchValue['miniappPublic'];
      delete this.searchValue['websitePublic'];
      delete this.searchValue['appPublic'];
    },

    /**
     * 选择时间
     */
    dateTimeChange: function dateTimeChange(time) {
      if (time[0] !== "") {
        this.searchValue.updateTimeStart = time[0];
        this.searchValue.updateTimeEnd = time[1];
      } else {
        delete this.searchValue["updateTimeStart"];
        delete this.searchValue["updateTimeEnd"];
      }
    },

    /**
     * 清空时间
     */
    dateTimeClear: function dateTimeClear() {
      delete this.searchValue["updateTimeStart"];
      delete this.searchValue["updateTimeEnd"];
    }
  },
  watch: {
    columns: function columns(_columns) {
      this.handleColumns(_columns);
    },
    value: function value(val) {
      this.handleTableData();
    }
  },
  created: function created() {
    this.handleColumns(this.columns);
    this.handleTableData();
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "nE5R":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "min-width": "900px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "26px",
      "display": "inline-block",
      "cursor": "pointer"
    }
  }, [_vm._v("官网APP管理")]), _vm._v(" "), _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "handle-area"
  }, [_c('div', {
    staticClass: "handle-button"
  }, [(!_vm.editable) ? _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openDrag
    }
  }, [_vm._v("拖拽排序")]) : _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.completeDrag
    }
  }, [_vm._v("完成排序")]), _vm._v(" "), (_vm.editable) ? _c('Button', {
    on: {
      "click": _vm.orderList
    }
  }, [_vm._v("重置排序")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "main-area"
  }, [_c('Card', {
    staticClass: "sub-area"
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("官网一级展示区产品内容")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "slot": "extra",
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.createApp(1, _vm.productInfoArea1.length)
      }
    },
    slot: "extra"
  }, [_vm._v("添加应用")]), _vm._v(" "), _c('draggable', _vm._b({
    attrs: {
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.productInfoArea1),
      callback: function($$v) {
        _vm.productInfoArea1 = $$v
      },
      expression: "productInfoArea1"
    }
  }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
    staticClass: "list-group",
    attrs: {
      "type": "transition",
      "tag": "ul"
    }
  }, _vm._l((_vm.productInfoArea1), function(item, index) {
    return _c('li', {
      key: item.id,
      staticClass: "list-group-item"
    }, [_c('Card', {
      staticClass: "app-content"
    }, [_c('div', {
      staticClass: "app-logo"
    }, [_c('img', {
      attrs: {
        "src": item.appLogo
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "app-info"
    }, [_c('span', {
      staticStyle: {
        "font-size": "16px",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item.productTitle))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("应用版本: " + _vm._s(item.appVersion))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("上架时间: " + _vm._s(_vm.transDate(item.createDate)))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("下载量: " + _vm._s(item.downloadCount))])]), _vm._v(" "), _c('div', {
      staticClass: "app-handle"
    }, [_c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.showAppDetail(item.areaId, index)
        }
      }
    }, [_vm._v("应用详情")]), _vm._v(" "), _c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.updateApp(item.areaId, index)
        }
      }
    }, [_vm._v("更新版本")]), _vm._v(" "), (item.active === 1) ? _c('Button', {
      attrs: {
        "type": "error"
      },
      on: {
        "click": function($event) {
          return _vm.appDown(item.areaId, index)
        }
      }
    }, [_vm._v("下架应用")]) : _c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.appUp(item.areaId, index)
        }
      }
    }, [_vm._v("上架应用")]), _vm._v(" "), _c('Button', {
      attrs: {
        "type": "error"
      },
      on: {
        "click": function($event) {
          return _vm.deleteApp(item.areaId, index)
        }
      }
    }, [_vm._v("删除应用")])], 1)])], 1)
  }), 0)], 1)], 1), _vm._v(" "), _c('Card', {
    staticClass: "sub-area"
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("官网二级展示区产品内容")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "slot": "extra",
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.createApp(2, _vm.productInfoArea2.length)
      }
    },
    slot: "extra"
  }, [_vm._v("添加应用")]), _vm._v(" "), _c('draggable', _vm._b({
    attrs: {
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.productInfoArea2),
      callback: function($$v) {
        _vm.productInfoArea2 = $$v
      },
      expression: "productInfoArea2"
    }
  }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
    staticClass: "list-group",
    attrs: {
      "type": "transition",
      "tag": "ul"
    }
  }, _vm._l((_vm.productInfoArea2), function(item, index) {
    return _c('li', {
      key: item.id,
      staticClass: "list-group-item"
    }, [_c('Card', {
      staticClass: "app-content"
    }, [_c('div', {
      staticClass: "app-logo"
    }, [_c('img', {
      attrs: {
        "src": item.appLogo
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "app-info"
    }, [_c('span', {
      staticStyle: {
        "font-size": "16px",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item.productTitle))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("应用版本: " + _vm._s(item.appVersion))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("上架时间: " + _vm._s(_vm.transDate(item.createDate)))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("下载量: " + _vm._s(item.downloadCount))])]), _vm._v(" "), _c('div', {
      staticClass: "app-handle"
    }, [_c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.showAppDetail(item.areaId, index)
        }
      }
    }, [_vm._v("应用详情")]), _vm._v(" "), _c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.updateApp(item.areaId, index)
        }
      }
    }, [_vm._v("更新版本")]), _vm._v(" "), (item.active === 1) ? _c('Button', {
      attrs: {
        "type": "error"
      },
      on: {
        "click": function($event) {
          return _vm.appDown(item.areaId, index)
        }
      }
    }, [_vm._v("下架应用")]) : _c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.appUp(item.areaId, index)
        }
      }
    }, [_vm._v("上架应用")]), _vm._v(" "), _c('Button', {
      attrs: {
        "type": "error"
      },
      on: {
        "click": function($event) {
          return _vm.deleteApp(item.areaId, index)
        }
      }
    }, [_vm._v("删除应用")])], 1)])], 1)
  }), 0)], 1)], 1), _vm._v(" "), _c('Card', {
    staticClass: "sub-area"
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("官网三级展示区产品内容")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "slot": "extra",
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.createApp(3, _vm.productInfoArea3.length)
      }
    },
    slot: "extra"
  }, [_vm._v("添加应用")]), _vm._v(" "), _c('draggable', _vm._b({
    attrs: {
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.productInfoArea3),
      callback: function($$v) {
        _vm.productInfoArea3 = $$v
      },
      expression: "productInfoArea3"
    }
  }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
    staticClass: "list-group",
    attrs: {
      "type": "transition",
      "tag": "ul"
    }
  }, _vm._l((_vm.productInfoArea3), function(item, index) {
    return _c('li', {
      key: item.id,
      staticClass: "list-group-item"
    }, [_c('Card', {
      staticClass: "app-content"
    }, [_c('div', {
      staticClass: "app-logo"
    }, [_c('img', {
      attrs: {
        "src": item.appLogo
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "app-info"
    }, [_c('span', {
      staticStyle: {
        "font-size": "16px",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item.productTitle))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("应用版本: " + _vm._s(item.appVersion))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("上架时间: " + _vm._s(_vm.transDate(item.createDate)))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("下载量: " + _vm._s(item.downloadCount))])]), _vm._v(" "), _c('div', {
      staticClass: "app-handle"
    }, [_c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.showAppDetail(item.areaId, index)
        }
      }
    }, [_vm._v("应用详情")]), _vm._v(" "), _c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.updateApp(item.areaId, index)
        }
      }
    }, [_vm._v("更新版本")]), _vm._v(" "), (item.active === 1) ? _c('Button', {
      attrs: {
        "type": "error"
      },
      on: {
        "click": function($event) {
          return _vm.appDown(item.areaId, index)
        }
      }
    }, [_vm._v("下架应用")]) : _c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.appUp(item.areaId, index)
        }
      }
    }, [_vm._v("上架应用")]), _vm._v(" "), _c('Button', {
      attrs: {
        "type": "error"
      },
      on: {
        "click": function($event) {
          return _vm.deleteApp(item.areaId, index)
        }
      }
    }, [_vm._v("删除应用")])], 1)])], 1)
  }), 0)], 1)], 1)], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ "nKAD":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("GFSd")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("Di+W"),
  /* template */
  __webpack_require__("jY36"),
  /* scopeId */
  "data-v-2a27d36f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "nX10":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("KX8I")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("nyTP"),
  /* template */
  __webpack_require__("uJYQ"),
  /* scopeId */
  "data-v-1c9a7bf0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "ngxf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nj25":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comp-container"
  }, [_c('h1', [_vm._v("通知")])])
}]}

/***/ }),

/***/ "nyTP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _format = __webpack_require__("4/BI");

var _admin = __webpack_require__("4piF");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
    name: "editNewsInfo",
    data: function data() {
        return {
            formItem: {},
            imgPath: [], //上传的图片地址
            isNew: true
        };
    },

    methods: {
        copyTo: function copyTo(value) {
            this.formItem.titleImgUrl = value;
        },
        showNewsInfo: function showNewsInfo(id) {
            var active = 'newsInfo';
            var currentTag = localStorage.getItem('currentTag');
            if (currentTag !== active) {
                var tags = null;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(_admin.adminRouter), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var ele = _step.value;

                        if (ele.name === active) {
                            tags = {
                                title: ele.title,
                                name: ele.name,
                                path: ele.path
                            };
                            break;
                        } else {
                            if (ele.children.length) {
                                var _iteratorNormalCompletion2 = true;
                                var _didIteratorError2 = false;
                                var _iteratorError2 = undefined;

                                try {
                                    for (var _iterator2 = (0, _getIterator3.default)(ele.children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                        var val = _step2.value;

                                        if (val.name === active) {
                                            tags = {
                                                title: val.title,
                                                name: val.name,
                                                path: val.path
                                            };
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                            _iterator2.return();
                                        }
                                    } finally {
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                localStorage.setItem("currentTag", active);
                localStorage.setItem("newsId", id);
                this.$store.commit("updateCurrentTag", active);
                this.$store.commit("updateOpenedTags", [tags]);
                this.$store.commit("updateCurrentPath", active);
                this.$router.push({
                    name: active
                });
            }
        },
        backToList: function backToList() {
            var active = 'newsManager';
            var currentTag = localStorage.getItem('currentTag');
            if (currentTag !== active) {
                var tags = null;
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = (0, _getIterator3.default)(_admin.adminRouter), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var ele = _step3.value;

                        if (ele.name === active) {
                            tags = {
                                title: ele.title,
                                name: ele.name,
                                path: ele.path
                            };
                            break;
                        } else {
                            if (ele.children.length) {
                                var _iteratorNormalCompletion4 = true;
                                var _didIteratorError4 = false;
                                var _iteratorError4 = undefined;

                                try {
                                    for (var _iterator4 = (0, _getIterator3.default)(ele.children), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                        var val = _step4.value;

                                        if (val.name === active) {
                                            tags = {
                                                title: val.title,
                                                name: val.name,
                                                path: val.path
                                            };
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError4 = true;
                                    _iteratorError4 = err;
                                } finally {
                                    try {
                                        if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                            _iterator4.return();
                                        }
                                    } finally {
                                        if (_didIteratorError4) {
                                            throw _iteratorError4;
                                        }
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }

                localStorage.setItem("currentTag", active);
                this.$store.commit("updateCurrentTag", active);
                this.$store.commit("updateOpenedTags", [tags]);
                this.$store.commit("updateCurrentPath", active);
                this.$router.push({
                    name: active
                });
            }
        },
        uploadSuccess: function uploadSuccess(res, file) {
            this.imgPath.push({ name: file.name, path: res.content });
        },
        //获取图像地址
        submitTotal: function submitTotal() {
            var _this = this;

            this.formItem.publicDate = this.formItem.time.getTime();
            delete this.formItem.time;
            this.$http.post('/zm/WMWebsite/addNewsInfo', this.formItem).then(function (res) {
                _this.$Message.success("上传成功！");
                _this.backToList();
                _this.formItem = {
                    titleImgUrl: "", //封面图
                    mainTitle: "", //主标题
                    source: "", //文章来源
                    publicDate: "", //发布日期
                    summary: "", //文章简介
                    content: "" //文章内容
                };
                _this.imgPath = [];
            }, function (err) {
                _this.$Message.error("上传失败！" + err.message);
            });
        },
        //上传
        saveChange: function saveChange() {
            var _this2 = this;

            this.formItem.publicDate = this.formItem.time.getTime();
            var id = this.formItem.id;
            delete this.formItem.time;
            this.$http.post('/zm/WMWebsite/updateNewsInfos', this.formItem).then(function (res) {
                _this2.$Message.success("提交成功！");
                _this2.showNewsInfo(id);
                _this2.formItem = {
                    titleImgUrl: '填入上传地址中的Url'
                };
                _this2.imgPath = [];
            }, function (err) {
                _this2.$Message.error("提交失败！" + err.message);
            });
        }
    },

    activated: function activated() {
        var _this3 = this;

        var id = localStorage.getItem('newsId');
        if (id !== '') {
            this.isNew = false;
            this.$http.get('/zm/WMWebsite/queryNewsInfos').then(function (res) {
                var tempList = res.data.content;
                tempList.forEach(function (item) {
                    if (item.id === Number(id)) {
                        _this3.formItem = item;
                        _this3.formItem.time = (0, _format.format2Sec)(_this3.formItem.publicDate);
                        _this3.formItem.newsCategory = String(_this3.formItem.newsCategory);
                    }
                });
            });
        } else {
            this.isNew = true;
            this.formItem = {
                titleImgUrl: '填入上传地址中的Url'
            };
        }
    }
};

/***/ }),

/***/ "oCbg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oFuF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = new _vue2.default();

/***/ }),

/***/ "oGzK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oRfq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _assist = __webpack_require__("9Xvl");

var _emitter = __webpack_require__("pEmh");

var _emitter2 = _interopRequireDefault(_emitter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var prefixCls = 'ivu-checkbox';

exports.default = {
    name: 'Checkbox',
    mixins: [_emitter2.default],
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        value: {
            type: [String, Number, Boolean],
            default: false
        },
        trueValue: {
            type: [String, Number, Boolean],
            default: true
        },
        falseValue: {
            type: [String, Number, Boolean],
            default: false
        },
        label: {
            type: [String, Number, Boolean]
        },
        indeterminate: {
            type: Boolean,
            default: false
        },
        size: {
            validator: function validator(value) {
                return (0, _assist.oneOf)(value, ['small', 'large', 'default']);
            }
        },
        name: {
            type: String
        }
    },
    data: function data() {
        return {
            model: [],
            currentValue: this.value,
            group: false,
            showSlot: true,
            parent: (0, _assist.findComponentUpward)(this, 'CheckboxGroup'),
            focusInner: false
        };
    },

    computed: {
        wrapClasses: function wrapClasses() {
            var _ref;

            return [prefixCls + '-wrapper', (_ref = {}, (0, _defineProperty3.default)(_ref, prefixCls + '-group-item', this.group), (0, _defineProperty3.default)(_ref, prefixCls + '-wrapper-checked', this.currentValue), (0, _defineProperty3.default)(_ref, prefixCls + '-wrapper-disabled', this.disabled), (0, _defineProperty3.default)(_ref, prefixCls + '-' + this.size, !!this.size), _ref)];
        },
        checkboxClasses: function checkboxClasses() {
            var _ref2;

            return ['' + prefixCls, (_ref2 = {}, (0, _defineProperty3.default)(_ref2, prefixCls + '-checked', this.currentValue), (0, _defineProperty3.default)(_ref2, prefixCls + '-disabled', this.disabled), (0, _defineProperty3.default)(_ref2, prefixCls + '-indeterminate', this.indeterminate), _ref2)];
        },
        innerClasses: function innerClasses() {
            return [prefixCls + '-inner', (0, _defineProperty3.default)({}, prefixCls + '-focus', this.focusInner)];
        },
        inputClasses: function inputClasses() {
            return prefixCls + '-input';
        }
    },
    mounted: function mounted() {
        this.parent = (0, _assist.findComponentUpward)(this, 'CheckboxGroup');
        if (this.parent) {
            this.group = true;
        }

        if (this.group) {
            this.parent.updateModel(true);
        } else {
            this.updateModel();
            this.showSlot = this.$slots.default !== undefined;
        }
    },

    methods: {
        change: function change(event) {
            if (this.disabled) {
                return false;
            }

            var checked = event.target.checked;
            this.currentValue = checked;

            var value = checked ? this.trueValue : this.falseValue;
            this.$emit('input', value);

            if (this.group) {
                this.parent.change(this.model);
            } else {
                this.$emit('on-change', value);
                this.dispatch('FormItem', 'on-form-change', value);
            }
        },
        updateModel: function updateModel() {
            this.currentValue = this.value === this.trueValue;
        },
        onBlur: function onBlur() {
            this.focusInner = false;
        },
        onFocus: function onFocus() {
            this.focusInner = true;
        }
    },
    watch: {
        value: function value(val) {
            if (val === this.trueValue || val === this.falseValue) {
                this.updateModel();
            } else {
                throw 'Value should be trueValue or falseValue.';
            }
        }
    }
};

/***/ }),

/***/ "odpv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/avatar.b76ab7f.jpg";

/***/ }),

/***/ "osGv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _mixin = __webpack_require__("vsZy");

var _mixin2 = _interopRequireDefault(_mixin);

var _admin = __webpack_require__("4piF");

var _util = __webpack_require__("oFuF");

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "menuLists",
  mixins: [_mixin2.default], // 用来更高效的实现组件内容的复用
  props: ["shrink"],
  data: function data() {
    return {};
  },

  methods: {
    changeMenu: function changeMenu(active) {
      //active就是当前页面的名字
      if (this.currentTag !== active) {
        var tags = null;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = (0, _getIterator3.default)(_admin.adminRouter), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var ele = _step.value;

            if (ele.name === active) {
              tags = {
                title: ele.title,
                name: ele.name,
                path: ele.path
              };
              break;
            } else {
              if (ele.children.length) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                  for (var _iterator2 = (0, _getIterator3.default)(ele.children), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var val = _step2.value;

                    if (val.name === active) {
                      tags = {
                        title: val.title,
                        name: val.name,
                        path: val.path
                      };
                      break;
                    }
                  }
                } catch (err) {
                  _didIteratorError2 = true;
                  _iteratorError2 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                      _iterator2.return();
                    }
                  } finally {
                    if (_didIteratorError2) {
                      throw _iteratorError2;
                    }
                  }
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        localStorage.setItem("currentTag", active);
        this.$store.commit("updateCurrentTag", active);
        this.$store.commit("updateOpenedTags", [tags]);
        this.$store.commit("updateCurrentPath", active);
        this.$router.push({
          name: active
        });
      }
    },
    changeSubmenu: function changeSubmenu(arr) {
      this.$store.commit("openedSubmenu", arr);
      localStorage.setItem("openedSubmenu", (0, _stringify2.default)(arr));
    }
  },
  mounted: function mounted() {
    var that = this;
    _util2.default.$on('demo', function (msg) {
      // console.log(msg);
      that.changeMenu(msg);
    });
  },
  created: function created() {}
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "p0Qu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pIGu":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "min-width": "900px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "26px",
      "display": "inline-block",
      "cursor": "pointer"
    }
  }, [_vm._v("官网新闻管理")]), _vm._v(" "), _c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "main-area"
  }, [_c('Card', {
    staticClass: "sub-area"
  }, [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("官网新闻展示区内容")]), _vm._v(" "), _c('a', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "slot": "extra",
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.addNews()
      }
    },
    slot: "extra"
  }, [_vm._v("添加新闻")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.newsList), function(item, index) {
    return _c('li', {
      key: item.id,
      staticClass: "list-group-item"
    }, [_c('Card', {
      staticClass: "app-content"
    }, [_c('div', {
      staticClass: "app-logo"
    }, [_c('img', {
      attrs: {
        "src": item.titleImgUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "app-info"
    }, [_c('span', {
      staticStyle: {
        "font-size": "16px",
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(item.mainTitle))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("类别: " + _vm._s(_vm.getName(item.newsCategory)))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("来源: " + _vm._s(item.source))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("发布时间: " + _vm._s(_vm.transDate(item.publicDate)))])]), _vm._v(" "), _c('div', {
      staticClass: "app-handle"
    }, [_c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.showNewsInfo(item.id)
        }
      }
    }, [_vm._v("新闻详情")]), _vm._v(" "), _c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.updateNewsInfo(item.id)
        }
      }
    }, [_vm._v("更新内容")]), _vm._v(" "), (item.active === 1) ? _c('Button', {
      attrs: {
        "type": "error"
      },
      on: {
        "click": function($event) {
          return _vm.newsDown(index)
        }
      }
    }, [_vm._v("下架新闻")]) : _c('Button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.newsUp(index)
        }
      }
    }, [_vm._v("上架新闻")]), _vm._v(" "), _c('Button', {
      attrs: {
        "type": "error"
      },
      on: {
        "click": function($event) {
          return _vm.deleteNews(item.id, index)
        }
      }
    }, [_vm._v("删除新闻")])], 1)])], 1)
  }), 0)])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ "payt":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("c4q/")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("SC4N"),
  /* template */
  __webpack_require__("8XIX"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "ql3x":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "min-width": "900px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "26px",
      "display": "inline-block",
      "cursor": "pointer"
    }
  }, [_vm._v("应用编辑")]), _vm._v(" "), _c('div', {
    staticClass: "formStyle"
  }, [_c('Form', {
    staticStyle: {
      "padding": "20px"
    },
    attrs: {
      "model": _vm.formItem,
      "label-width": 100
    }
  }, [_c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("上传应用")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Upload', {
    staticClass: "uploadAPK",
    attrs: {
      "show-upload-list": false,
      "action": "/zm/cos/upload",
      "accept": ".apk",
      "format": ['apk'],
      "before-upload": _vm.checkApkUpload,
      "on-success": _vm.apkUploadSuccess,
      "on-error": _vm.apkUploadFail,
      "on-remove": _vm.removeAPK,
      "on-progress": _vm.handleApkUpload,
      "on-format-error": _vm.handleFormatError,
      "on-exceeded-size": _vm.handleMaxSize
    }
  }, [_c('div', [(_vm.apkProgress) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }, [_c('div', [_vm._v("上传中")])]) : _vm._e(), _vm._v(" "), _c('Input', {
    attrs: {
      "placeholder": "点击上传APK"
    },
    model: {
      value: (_vm.apkName),
      callback: function($$v) {
        _vm.apkName = $$v
      },
      expression: "apkName"
    }
  })], 1)])], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("应用logo")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_vm._l((_vm.logoUpload), function(item) {
    return _c('div', {
      staticClass: "logo-upload-list"
    }, [
      [_c('img', {
        attrs: {
          "src": item
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "logo-upload-list-cover"
      }, [_c('Icon', {
        staticStyle: {
          "padding-right": "10px"
        },
        attrs: {
          "type": "ios-eye-outline",
          "size": "30"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.handleLogoView.apply(null, arguments)
          }
        }
      }), _vm._v(" "), _c('Icon', {
        staticStyle: {
          "padding-right": "10px"
        },
        attrs: {
          "type": "ios-trash-outline",
          "size": "30"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.handleLogoRemove.apply(null, arguments)
          }
        }
      })], 1)]
    ], 2)
  }), _vm._v(" "), _c('Upload', {
    staticStyle: {
      "display": "inline-block",
      "width": "100px"
    },
    attrs: {
      "show-upload-list": false,
      "accept": ".jpg,.jpeg,.png",
      "format": ['jpg', 'jpeg', 'png'],
      "max-size": 2048,
      "on-progress": _vm.handleLogoUpload,
      "on-error": _vm.logoUploadFail,
      "on-success": _vm.logoUploadSuccess,
      "on-format-error": _vm.handleFormatError,
      "on-exceeded-size": _vm.handleMaxSize,
      "before-upload": _vm.checkLogoUpload,
      "type": "drag",
      "action": "/zm/cos/upload"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.logoUpload.length < 1),
      expression: "logoUpload.length < 1"
    }],
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "line-height": "100px"
    }
  }, [(_vm.logoProgress) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }, [_c('div', [_vm._v("上传中")])]) : _vm._e(), _vm._v(" "), _c('Icon', {
    staticStyle: {
      "padding-top": "30px"
    },
    attrs: {
      "type": "ios-camera",
      "size": "40"
    }
  })], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "预览"
    },
    model: {
      value: (_vm.logoVisible),
      callback: function($$v) {
        _vm.logoVisible = $$v
      },
      expression: "logoVisible"
    }
  }, [(_vm.logoVisible) ? _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.formItem.appLogo
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("需上传完整正方形图标，尺寸：216*216px")])], 2)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品名称")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入产品名称..."
    },
    model: {
      value: (_vm.formItem.productTitle),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productTitle", $$v)
      },
      expression: "formItem.productTitle"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("包名")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "clearable": "",
      "placeholder": "填写包名，如：mobi.accessible.qimingxing"
    },
    model: {
      value: (_vm.formItem.packageName),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "packageName", $$v)
      },
      expression: "formItem.packageName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("Appid")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "clearable": "",
      "placeholder": "微信开发平台应用展示的AppID"
    },
    model: {
      value: (_vm.formItem.appid),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "appid", $$v)
      },
      expression: "formItem.appid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品id")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入产品id..."
    },
    model: {
      value: (_vm.formItem.productId),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productId", $$v)
      },
      expression: "formItem.productId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("应用版本")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "clearable": "",
      "placeholder": "请输入版本号，如V1.0.1"
    },
    model: {
      value: (_vm.formItem.appVersion),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "appVersion", $$v)
      },
      expression: "formItem.appVersion"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("上架时间")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "type": "datetime",
      "clearable": "",
      "placeholder": "选择上架时间"
    },
    model: {
      value: (_vm.formItem.time),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "time", $$v)
      },
      expression: "formItem.time"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("应用类别")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formItem.appCategory),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "appCategory", $$v)
      },
      expression: "formItem.appCategory"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("启明应用")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("启明游戏")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v("其他应用")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "4"
    }
  }, [_vm._v("其他游戏")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "5"
    }
  }, [_vm._v("未分类")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品简介")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "maxlength": 30,
      "placeholder": "请输入一句话简介，限30字"
    },
    model: {
      value: (_vm.formItem.productShortDescribe),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productShortDescribe", $$v)
      },
      expression: "formItem.productShortDescribe"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品详情")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "maxlength": 2000,
      "autosize": {
        minRows: 4,
        maxRows: 8
      },
      "placeholder": "应用介绍，20-2000字之间"
    },
    model: {
      value: (_vm.formItem.productDescribe),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productDescribe", $$v)
      },
      expression: "formItem.productDescribe"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("展示视频")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_vm._l((_vm.videoUpload), function(item) {
    return _c('div', [
      [_c('video', {
        staticStyle: {
          "width": "200px",
          "height": "300px"
        },
        attrs: {
          "controls": "controls",
          "src": item
        }
      }), _vm._v(" "), _c('Button', {
        staticStyle: {
          "margin-bottom": "30px"
        },
        on: {
          "click": _vm.removeVideo
        }
      }, [_vm._v("删除视频")])]
    ], 2)
  }), _vm._v(" "), _c('Upload', {
    staticStyle: {
      "display": "inline-block",
      "width": "200px"
    },
    attrs: {
      "show-upload-list": false,
      "accept": ".mp4",
      "format": ['mp4'],
      "on-error": _vm.videoUploadFail,
      "on-remove": _vm.removeVideo,
      "on-progress": _vm.handleVideoUpload,
      "on-success": _vm.videoUploadSuccess,
      "on-format-error": _vm.handleFormatError,
      "on-exceeded-size": _vm.handleMaxSize,
      "before-upload": _vm.checkVideoUpload,
      "type": "drag",
      "action": "/zm/cos/upload"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.videoUpload.length < 1),
      expression: "videoUpload.length < 1"
    }],
    staticStyle: {
      "width": "200px",
      "height": "300px",
      "line-height": "300px"
    }
  }, [(_vm.videoProgress) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }, [_c('div', [_vm._v("上传中")])]) : _vm._e(), _vm._v(" "), _c('Icon', {
    staticStyle: {
      "padding-top": "30px"
    },
    attrs: {
      "type": "ios-camera",
      "size": "40"
    }
  })], 1)])], 2)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("展示截图")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_vm._l((_vm.imgUpload), function(item) {
    return _c('div', {
      staticClass: "img-upload-list"
    }, [
      [_c('img', {
        attrs: {
          "src": item
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "img-upload-list-cover"
      }, [_c('Icon', {
        staticStyle: {
          "padding-right": "10px"
        },
        attrs: {
          "type": "ios-eye-outline",
          "size": "30"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.handleImgView(item)
          }
        }
      }), _vm._v(" "), _c('Icon', {
        staticStyle: {
          "padding-right": "10px"
        },
        attrs: {
          "type": "ios-trash-outline",
          "size": "30"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.handleImgRemove(item)
          }
        }
      })], 1)]
    ], 2)
  }), _vm._v(" "), _c('Upload', {
    staticStyle: {
      "display": "inline-block",
      "width": "200px"
    },
    attrs: {
      "show-upload-list": false,
      "accept": ".jpg,.jpeg,.png",
      "format": ['jpg', 'jpeg', 'png'],
      "max-size": 2048,
      "on-progress": _vm.handleImgUpload,
      "on-success": _vm.imgUploadSuccess,
      "on-format-error": _vm.handleFormatError,
      "on-exceeded-size": _vm.handleMaxSize,
      "before-upload": _vm.checkImgUpload,
      "type": "drag",
      "multiple": "",
      "action": "/zm/cos/upload"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.imgUpload.length < 5),
      expression: "imgUpload.length < 5"
    }],
    staticStyle: {
      "width": "200px",
      "height": "300px",
      "line-height": "300px"
    }
  }, [(_vm.imgProgress) ? _c('Spin', {
    attrs: {
      "fix": ""
    }
  }, [_c('div', [_vm._v("上传中")])]) : _vm._e(), _vm._v(" "), _c('Icon', {
    staticStyle: {
      "padding-top": "30px"
    },
    attrs: {
      "type": "ios-camera",
      "size": "40"
    }
  })], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "预览"
    },
    model: {
      value: (_vm.imgVisible),
      callback: function($$v) {
        _vm.imgVisible = $$v
      },
      expression: "imgVisible"
    }
  }, [(_vm.imgVisible) ? _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.imgShow
    }
  }) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("请上传最少3张截图，支持JPG\\JPEG或PNG格式，建议分辨率：450*800（9：16）,单张图片最大为2M")])], 2)], 1)], 1), _vm._v(" "), _c('formItem', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.isNew) ? _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitTotal
    }
  }, [_vm._v("添加产品")]) : _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveChange
    }
  }, [_vm._v("提交修改")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ "rRdF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "son6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//

var prefixCls = 'ivu-icon';

exports.default = {
    name: 'Icon',
    props: {
        type: String,
        size: [Number, String],
        color: String
    },
    computed: {
        classes: function classes() {
            return prefixCls + ' ' + prefixCls + '-' + this.type;
        },
        styles: function styles() {
            var style = {};

            if (this.size) {
                style['font-size'] = this.size + 'px';
            }

            if (this.color) {
                style.color = this.color;
            }

            return style;
        }
    },
    methods: {
        handleClick: function handleClick(event) {
            this.$emit('click', event);
        }
    }
};

/***/ }),

/***/ "t2zW":
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("7ZpJ"),
  /* template */
  __webpack_require__("dg/3"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "t5eG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "home",
  data: function data() {
    return {
      value: 0
    };
  },

  methods: {
    toLogin: function toLogin() {
      this.$router.push({
        name: "login"
      });
    }
  },
  created: function created() {
    this.toLogin();
  }
};

/***/ }),

/***/ "tILD":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "min-width": "900px"
    }
  }, [_c('p', {
    staticClass: "headPM",
    staticStyle: {
      "font-size": "26px",
      "display": "inline-block",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.flag = false;
        _vm.flag2 = false
      }
    }
  }, [_vm._v("模板消息推送")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag || _vm.flag2),
      expression: "flag||flag2"
    }],
    staticStyle: {
      "font-size": "20px",
      "display": "inline-block"
    }
  }, [_vm._v(" "), _c('Icon', {
    attrs: {
      "type": "ios-arrow-forward"
    }
  }), _vm._v(" 模板消息使用")], 1), _vm._v(" "), _c('Tabs', {
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "value": "qiming"
    },
    on: {
      "on-click": function($event) {
        _vm.flag = false;
        _vm.flag2 = false
      }
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "启明瞳服务号模板",
      "name": "qiming"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.flag),
      expression: "!flag"
    }]
  }, [_c('Table', {
    attrs: {
      "stripe": "",
      "columns": _vm.columns,
      "data": _vm.template_list
    },
    on: {
      "on-expand": _vm.expanding
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag),
      expression: "flag"
    }]
  }, [_c('Card', {
    staticStyle: {
      "margin": "2% 0",
      "font-size": "16px",
      "border-radius": "20px",
      "width": "95%"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #CCCCCC",
      "border-radius": "10px"
    }
  }, [_c('ul', {
    staticStyle: {
      "padding": "3% 5%"
    }
  }, _vm._l((_vm.example), function(value, key) {
    return _c('li', {
      key: key,
      staticStyle: {
        "padding-top": "2%"
      }
    }, [_vm._v(_vm._s(value))])
  }), 0), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "1px solid #CCCCCC"
    }
  }), _vm._v(" "), _c('Row', {
    staticStyle: {
      "padding": "2% 5%",
      "font-size": "18px",
      "color": "#CCCCCC"
    }
  }, [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_vm._v("详情")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2",
      "offset": "18"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-forward"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Row', [_c('p', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("模板消息数据配置")])]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin": "1% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('p', [_vm._v("模板ID:")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.sendData.templateMsgBody.template_id))])])], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin": "1% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('p', [_vm._v("标题:")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "150"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.title))])])], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin": "1% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('p', [_vm._v("行业:")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_vm._v(_vm._s(_vm.industry))])], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin": "1% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('p', {
    attrs: {
      "id": "inputSee"
    }
  }, [_vm._v("小程序appid:")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "150px"
    },
    on: {
      "on-change": _vm.setAppid
    },
    model: {
      value: (_vm.appid1),
      callback: function($$v) {
        _vm.appid1 = $$v
      },
      expression: "appid1"
    }
  }, [_c('Option', {
    attrs: {
      "value": "wxce8e592adfc78ceb"
    }
  }, [_vm._v("启明瞳小程序")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "wxe8861b848e9ce4ca"
    }
  }, [_vm._v("我能帮帮忙小程序")])], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "20px",
      "margin-top": "1%"
    }
  }, [_vm._v("详细内容:")])])], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin": "1% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_vm._v("跳转URL:")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入..."
    },
    model: {
      value: (_vm.skipUrl),
      callback: function($$v) {
        _vm.skipUrl = $$v
      },
      expression: "skipUrl"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin": "1% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_vm._v("小程序页面路径:")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    ref: "inputVal",
    attrs: {
      "placeholder": "请输入..."
    },
    model: {
      value: (_vm.pagepath),
      callback: function($$v) {
        _vm.pagepath = $$v
      },
      expression: "pagepath"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin": "1% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_vm._v("主题:")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入..."
    },
    model: {
      value: (_vm.keywords[0]),
      callback: function($$v) {
        _vm.$set(_vm.keywords, 0, $$v)
      },
      expression: "keywords[0]"
    }
  })], 1)], 1), _vm._v(" "), _c('ul', _vm._l((_vm.content), function(value, key) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (key !== 0 && key !== _vm.content.length - 1),
        expression: "key!==0&&key!==content.length-1"
      }]
    }, [_c('Row', {
      staticStyle: {
        "margin": "2% 5%"
      }
    }, [_c('Col', {
      attrs: {
        "span": "6"
      }
    }, [_vm._v(_vm._s(value))]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "15"
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": "请输入..."
      },
      model: {
        value: (_vm.keywords[key]),
        callback: function($$v) {
          _vm.$set(_vm.keywords, key, $$v)
        },
        expression: "keywords[key]"
      }
    })], 1)], 1)], 1)
  }), 0), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin": "1% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_vm._v("标记:")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入..."
    },
    model: {
      value: (_vm.keywords[_vm.content.length - 1]),
      callback: function($$v) {
        _vm.$set(_vm.keywords, _vm.content.length - 1, $$v)
      },
      expression: "keywords[content.length-1]"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('p', {
    staticStyle: {
      "font-size": "20px",
      "margin": "2% 2%"
    }
  }, [_vm._v("群发模板消息：")])]), _vm._v(" "), _c('Row', [_c('hr', {
    staticStyle: {
      "border": "1px solid #CCCCCC"
    }
  })]), _vm._v(" "), _c('Row', [_c('Row', {
    staticStyle: {
      "margin": "4% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_vm._v("性别")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "150px"
    },
    on: {
      "on-change": function($event) {
        return _vm.selectPeople(_vm.appids[1])
      }
    },
    model: {
      value: (_vm.selectSex),
      callback: function($$v) {
        _vm.selectSex = $$v
      },
      expression: "selectSex"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("女")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未知")])], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2",
      "offset": "1"
    }
  }, [_vm._v("昵称")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "选填"
    },
    on: {
      "on-change": function($event) {
        return _vm.selectPeople(_vm.appids[1])
      }
    },
    model: {
      value: (_vm.nickname),
      callback: function($$v) {
        _vm.nickname = $$v
      },
      expression: "nickname"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('p', [_vm._v("已选中人数:")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "dodgerblue"
    }
  }, [_vm._v(_vm._s(_vm.number))])])], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin": "4% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_vm._v("省份")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "18"
    }
  }, [_c('Checkbox', {
    staticClass: "provenceS",
    on: {
      "on-change": _vm.totalProvince
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('CheckboxGroup', {
    on: {
      "on-change": function($event) {
        return _vm.selectPeople(_vm.appids[1])
      }
    },
    model: {
      value: (_vm.selectProvince),
      callback: function($$v) {
        _vm.selectProvince = $$v
      },
      expression: "selectProvince"
    }
  }, [_c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "北京"
    }
  }, [_vm._v("北京")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "上海"
    }
  }, [_vm._v("上海")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "重庆"
    }
  }, [_vm._v("重庆")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "深圳"
    }
  }, [_vm._v("深圳")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "天津"
    }
  }, [_vm._v("天津")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "南京"
    }
  }, [_vm._v("南京")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "湖北"
    }
  }, [_vm._v("湖北")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "湖南"
    }
  }, [_vm._v("湖南")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "河北"
    }
  }, [_vm._v("河北")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "河南"
    }
  }, [_vm._v("河南")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "江苏"
    }
  }, [_vm._v("江苏")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "浙江"
    }
  }, [_vm._v("浙江")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "山西"
    }
  }, [_vm._v("山西")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "辽宁"
    }
  }, [_vm._v("辽宁")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "吉林"
    }
  }, [_vm._v("吉林")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "福建"
    }
  }, [_vm._v("福建")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "广东"
    }
  }, [_vm._v("广东")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "山东"
    }
  }, [_vm._v("山东")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "江西"
    }
  }, [_vm._v("江西")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "四川"
    }
  }, [_vm._v("四川")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "陕西"
    }
  }, [_vm._v("陕西")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "云南"
    }
  }, [_vm._v("云南")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "广西"
    }
  }, [_vm._v("广西")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "安徽"
    }
  }, [_vm._v("安徽")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "宁夏"
    }
  }, [_vm._v("宁夏")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "青海"
    }
  }, [_vm._v("青海")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "西藏"
    }
  }, [_vm._v("西藏")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "甘肃"
    }
  }, [_vm._v("甘肃")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "新疆"
    }
  }, [_vm._v("新疆")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "黑龙江"
    }
  }, [_vm._v("黑龙江")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "内蒙古"
    }
  }, [_vm._v("内蒙古")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "香港"
    }
  }, [_vm._v("香港")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "澳门"
    }
  }, [_vm._v("澳门")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "台湾"
    }
  }, [_vm._v("台湾")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "海外"
    }
  }, [_vm._v("海外")])], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "text-align": "center",
      "margin": "6% 2% 5% 2%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Button', {
    attrs: {
      "type": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.immedeSend(_vm.content)
      }
    }
  }, [_vm._v("立即发送")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_vm._v("\n              定时：\n              "), _c('Input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "text"
    },
    on: {
      "on-change": _vm.getSetTime
    },
    model: {
      value: (_vm.timeSetting),
      callback: function($$v) {
        _vm.timeSetting = $$v
      },
      expression: "timeSetting"
    }
  }), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "on-change": _vm.getSetTime
    },
    model: {
      value: (_vm.timeDanwei),
      callback: function($$v) {
        _vm.timeDanwei = $$v
      },
      expression: "timeDanwei"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("秒")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "60"
    }
  }, [_vm._v("分钟")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3600"
    }
  }, [_vm._v("小时")])], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Button', {
    attrs: {
      "type": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.timedSend(_vm.content)
      }
    }
  }, [_vm._v("定时发送")])], 1)], 1)], 1)], 1)], 1)]), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "我能帮帮忙服务号模板",
      "name": "help"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.flag2),
      expression: "!flag2"
    }]
  }, [_c('Table', {
    attrs: {
      "stripe": "",
      "columns": _vm.columns2,
      "data": _vm.template_list2
    },
    on: {
      "on-expand": _vm.expanding
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.flag2),
      expression: "flag2"
    }]
  }, [_c('Card', {
    staticStyle: {
      "margin": "2% 0",
      "font-size": "16px",
      "border-radius": "20px",
      "width": "95%"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    attrs: {
      "span": "8"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #CCCCCC",
      "border-radius": "10px"
    }
  }, [_c('ul', {
    staticStyle: {
      "padding": "3% 5%"
    }
  }, _vm._l((_vm.example2), function(value, key) {
    return _c('li', {
      key: key,
      staticStyle: {
        "padding-top": "2%"
      }
    }, [_vm._v(_vm._s(value))])
  }), 0), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "1px solid #CCCCCC"
    }
  }), _vm._v(" "), _c('Row', {
    staticStyle: {
      "padding": "2% 5%",
      "font-size": "18px",
      "color": "#CCCCCC"
    }
  }, [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_vm._v("详情")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2",
      "offset": "18"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-forward"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "16"
    }
  }, [_c('Row', [_c('p', {
    staticStyle: {
      "font-size": "20px"
    }
  }, [_vm._v("模板消息数据配置")])]), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin": "1% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_vm._v("模板ID:")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.sendData.templateMsgBody.template_id))])])], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin": "1% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_vm._v("标题:")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "150"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.title))])])], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin": "1% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_vm._v("行业:")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_vm._v(_vm._s(_vm.industry))])], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin": "1% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', {
    attrs: {
      "id": "inputSee2"
    }
  }, [_vm._v("小程序appid:")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "150px"
    },
    on: {
      "on-change": _vm.setAppid
    },
    model: {
      value: (_vm.appid1),
      callback: function($$v) {
        _vm.appid1 = $$v
      },
      expression: "appid1"
    }
  }, [_c('Option', {
    attrs: {
      "value": "wxce8e592adfc78ceb"
    }
  }, [_vm._v("启明瞳小程序")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "wxe8861b848e9ce4ca"
    }
  }, [_vm._v("我能帮帮忙小程序")])], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "20px",
      "margin-top": "1%"
    }
  }, [_vm._v("详细内容:")])])], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin": "1% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_vm._v("跳转URL:")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入..."
    },
    model: {
      value: (_vm.skipUrl),
      callback: function($$v) {
        _vm.skipUrl = $$v
      },
      expression: "skipUrl"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin": "1% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_vm._v("小程序页面路径:")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    ref: "inputVal",
    attrs: {
      "placeholder": "请输入..."
    },
    model: {
      value: (_vm.pagepath),
      callback: function($$v) {
        _vm.pagepath = $$v
      },
      expression: "pagepath"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin": "1% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_vm._v("主题:")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入..."
    },
    model: {
      value: (_vm.keywords[0]),
      callback: function($$v) {
        _vm.$set(_vm.keywords, 0, $$v)
      },
      expression: "keywords[0]"
    }
  })], 1)], 1), _vm._v(" "), _c('ul', _vm._l((_vm.content2), function(value, key) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (key !== 0 && key !== _vm.content2.length - 1),
        expression: "key!==0&&key!==content2.length-1"
      }]
    }, [_c('Row', {
      staticStyle: {
        "margin": "2% 5%"
      }
    }, [_c('Col', {
      attrs: {
        "span": "6"
      }
    }, [_vm._v(_vm._s(value))]), _vm._v(" "), _c('Col', {
      attrs: {
        "span": "15"
      }
    }, [_c('Input', {
      attrs: {
        "placeholder": "请输入..."
      },
      model: {
        value: (_vm.keywords[key]),
        callback: function($$v) {
          _vm.$set(_vm.keywords, key, $$v)
        },
        expression: "keywords[key]"
      }
    })], 1)], 1)], 1)
  }), 0), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin": "1% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_vm._v("标记:")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入..."
    },
    model: {
      value: (_vm.keywords[_vm.content2.length - 1]),
      callback: function($$v) {
        _vm.$set(_vm.keywords, _vm.content2.length - 1, $$v)
      },
      expression: "keywords[content2.length-1]"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('p', {
    staticStyle: {
      "font-size": "20px",
      "margin": "2% 2%"
    }
  }, [_vm._v("群发模板消息：")])]), _vm._v(" "), _c('Row', [_c('hr', {
    staticStyle: {
      "border": "1px solid #CCCCCC"
    }
  })]), _vm._v(" "), _c('Row', [_c('Row', {
    staticStyle: {
      "margin": "4% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_vm._v("性别")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "150px"
    },
    on: {
      "on-change": function($event) {
        return _vm.selectPeople(_vm.appids[2])
      }
    },
    model: {
      value: (_vm.selectSex),
      callback: function($$v) {
        _vm.selectSex = $$v
      },
      expression: "selectSex"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("女")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未知")])], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "2",
      "offset": "1"
    }
  }, [_vm._v("昵称")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "选填"
    },
    on: {
      "on-change": function($event) {
        return _vm.selectPeople(_vm.appids[2])
      }
    },
    model: {
      value: (_vm.nickname),
      callback: function($$v) {
        _vm.nickname = $$v
      },
      expression: "nickname"
    }
  })], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('p', [_vm._v("已选中人数:")])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "3"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "dodgerblue"
    }
  }, [_vm._v(_vm._s(_vm.number))])])], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin": "4% 5%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "2"
    }
  }, [_vm._v("省份")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "18"
    }
  }, [_c('Checkbox', {
    staticClass: "provenceS",
    on: {
      "on-change": _vm.totalProvince
    }
  }, [_vm._v("全选")]), _vm._v(" "), _c('CheckboxGroup', {
    on: {
      "on-change": function($event) {
        return _vm.selectPeople(_vm.appids[2])
      }
    },
    model: {
      value: (_vm.selectProvince),
      callback: function($$v) {
        _vm.selectProvince = $$v
      },
      expression: "selectProvince"
    }
  }, [_c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "北京"
    }
  }, [_vm._v("北京")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "上海"
    }
  }, [_vm._v("上海")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "重庆"
    }
  }, [_vm._v("重庆")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "深圳"
    }
  }, [_vm._v("深圳")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "天津"
    }
  }, [_vm._v("天津")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "南京"
    }
  }, [_vm._v("南京")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "湖北"
    }
  }, [_vm._v("湖北")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "湖南"
    }
  }, [_vm._v("湖南")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "河北"
    }
  }, [_vm._v("河北")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "河南"
    }
  }, [_vm._v("河南")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "江苏"
    }
  }, [_vm._v("江苏")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "浙江"
    }
  }, [_vm._v("浙江")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "山西"
    }
  }, [_vm._v("山西")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "辽宁"
    }
  }, [_vm._v("辽宁")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "吉林"
    }
  }, [_vm._v("吉林")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "福建"
    }
  }, [_vm._v("福建")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "广东"
    }
  }, [_vm._v("广东")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "山东"
    }
  }, [_vm._v("山东")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "江西"
    }
  }, [_vm._v("江西")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "四川"
    }
  }, [_vm._v("四川")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "陕西"
    }
  }, [_vm._v("陕西")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "云南"
    }
  }, [_vm._v("云南")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "广西"
    }
  }, [_vm._v("广西")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "安徽"
    }
  }, [_vm._v("安徽")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "宁夏"
    }
  }, [_vm._v("宁夏")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "青海"
    }
  }, [_vm._v("青海")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "西藏"
    }
  }, [_vm._v("西藏")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "甘肃"
    }
  }, [_vm._v("甘肃")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "新疆"
    }
  }, [_vm._v("新疆")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "黑龙江"
    }
  }, [_vm._v("黑龙江")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "内蒙古"
    }
  }, [_vm._v("内蒙古")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "香港"
    }
  }, [_vm._v("香港")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "澳门"
    }
  }, [_vm._v("澳门")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "台湾"
    }
  }, [_vm._v("台湾")]), _vm._v(" "), _c('Checkbox', {
    staticClass: "provenceS",
    attrs: {
      "label": "海外"
    }
  }, [_vm._v("海外")])], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "text-align": "center",
      "margin": "6% 2% 5% 2%"
    }
  }, [_c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Button', {
    attrs: {
      "type": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.immedeSend2(_vm.content2)
      }
    }
  }, [_vm._v("立即发送")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "12"
    }
  }, [_c('Button', {
    attrs: {
      "type": "success"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.timeSend2(_vm.content2)
      }
    }
  }, [_vm._v("定时发送")])], 1)], 1)], 1)], 1)], 1)])], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "注意！"
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('h3', [_vm._v("在选择了小程序appid的情况下，小程序页面路径不可为空！")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.makeSure.apply(null, arguments)
      }
    }
  }, [_vm._v("确认")])], 1)])], 1)
},staticRenderFns: []}

/***/ }),

/***/ "tmQQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-container"
  }, [_c('Menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.shrink),
      expression: "!shrink"
    }],
    staticStyle: {
      "overflow": "auto"
    },
    attrs: {
      "theme": "dark",
      "width": "auto",
      "active-name": _vm.$route.name,
      "accordion": "",
      "open-names": _vm.openedSubmenuArr
    },
    on: {
      "on-select": _vm.changeMenu,
      "on-open-change": _vm.changeSubmenu
    }
  }, [_c('div', {
    staticClass: "layout-logo-left"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__("iQH9")
    }
  }), _vm._v(" "), _c('span', [_vm._v("运营管理后台")])]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "notice"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-volume-down"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "layout-text"
  }, [_vm._v("通知")])], 1), _vm._v(" "), _c('Submenu', {
    attrs: {
      "name": "materialManage"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "images"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "layout-text"
  }, [_vm._v("素材管理")])], 1), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "weChatMaterial"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("微信文章")])]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "productManager"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("官网产品")])]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "newsManager"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("官网新闻")])]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "otherMaterial"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("其他")])])], 2), _vm._v(" "), _c('Submenu', {
    attrs: {
      "name": "appManage"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "android-apps"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "layout-text"
  }, [_vm._v("APP管理")])], 1), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "webAPP"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("官网展示")])])], 2), _vm._v(" "), _c('Submenu', {
    attrs: {
      "name": "messageManage"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "android-volume-down"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "layout-text"
  }, [_vm._v("消息管理")])], 1), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "templateMessage"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("模板消息推送")])]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "helpMessage"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("盲人求助消息")])]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "usersMessage"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("用户反馈消息")])]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "weChatMessage"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("微信公共账号消息")])])], 2), _vm._v(" "), _c('Submenu', {
    attrs: {
      "name": "usersManage"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-contact"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "layout-text"
  }, [_vm._v("用户管理")])], 1), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "blindUsers"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("盲人用户")])]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "volunteerUsers"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("志愿者用户")])])], 2), _vm._v(" "), _c('Submenu', {
    attrs: {
      "name": "count"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-pie"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "layout-text"
  }, [_vm._v("统计")])], 1), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "totalCount"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("总体数据")])]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "appCount"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("APP数据")])]), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "volunteerCount"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("志愿者数据")])])], 2), _vm._v(" "), _c('Submenu', {
    attrs: {
      "name": "setup"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('Icon', {
    attrs: {
      "type": "gear-b"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "layout-text"
  }, [_vm._v("设置")])], 1), _vm._v(" "), _c('MenuItem', {
    attrs: {
      "name": "publicSetting"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("公众号设置")])])], 2)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shrink),
      expression: "shrink"
    }],
    staticClass: "dropdown-container",
    attrs: {
      "active-name": ""
    }
  }, [_vm._m(0), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "placement": "right-start",
      "name": "notice"
    }
  }, [_c('Button', {
    staticClass: "dropdown-btn",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.changeMenu('notice')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-volume-down",
      "size": "20"
    }
  })], 1)], 1), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "placement": "right-start",
      "name": "materialManage",
      "transfer": ""
    },
    on: {
      "on-click": _vm.changeMenu
    }
  }, [_c('Button', {
    staticClass: "dropdown-btn",
    attrs: {
      "type": "text"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "images",
      "size": "20"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "weChatMaterial"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("微信文章")])]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "productManager"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("官网产品")])]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "newsManager"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("官网新闻")])]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "otherMaterial"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("其他")])])], 1)], 1), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "placement": "right-start",
      "name": "appManage",
      "transfer": ""
    },
    on: {
      "on-click": _vm.changeMenu
    }
  }, [_c('Button', {
    staticClass: "dropdown-btn",
    attrs: {
      "type": "text"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-apps",
      "size": "20"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "webAPP"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("官网展示")])])], 1)], 1), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "placement": "right-start",
      "name": "messageManage",
      "transfer": ""
    },
    on: {
      "on-click": _vm.changeMenu
    }
  }, [_c('Button', {
    staticClass: "dropdown-btn",
    attrs: {
      "type": "text"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "android-volume-down",
      "size": "20"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "templateMessage"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("模板消息推送")])]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "helpMessage"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("盲人求助消息")])]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "usersMessage"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("用户反馈消息")])]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "weChatMessage"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("微信公共账号消息")])])], 1)], 1), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "placement": "right-start",
      "name": "usersManage",
      "transfer": ""
    },
    on: {
      "on-click": _vm.changeMenu
    }
  }, [_c('Button', {
    staticClass: "dropdown-btn",
    attrs: {
      "type": "text"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-contact",
      "size": "20"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "blindUsers"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("盲人用户")])]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "volunteerUsers"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("志愿者用户")])])], 1)], 1), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "placement": "right-start",
      "name": "count",
      "transfer": ""
    },
    on: {
      "on-click": _vm.changeMenu
    }
  }, [_c('Button', {
    staticClass: "dropdown-btn",
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        return _vm.changeMenu('AdminHome')
      }
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-pie",
      "size": "20"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "totalCount"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("总体数据")])]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "appCount"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("APP数据")])]), _vm._v(" "), _c('DropdownItem', {
    attrs: {
      "name": "volunteerCount"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("志愿者数据")])])], 1)], 1), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "placement": "right-start",
      "name": "setup",
      "transfer": ""
    },
    on: {
      "on-click": _vm.changeMenu
    }
  }, [_c('Button', {
    staticClass: "dropdown-btn",
    attrs: {
      "type": "text"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "gear-b",
      "size": "20"
    }
  })], 1), _vm._v(" "), _c('DropdownMenu', {
    staticClass: "dropdown-menu",
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('DropdownItem', {
    attrs: {
      "name": "publicSetting"
    }
  }, [_c('span', {
    staticClass: "layout-text"
  }, [_vm._v("公众号设置")])])], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layout-logo-left",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "float": "none"
    },
    attrs: {
      "src": __webpack_require__("iQH9")
    }
  })])
}]}

/***/ }),

/***/ "to50":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//

exports.default = {
    name: "appCount"
};

/***/ }),

/***/ "tvui":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uJYQ":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "min-width": "900px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "26px",
      "display": "inline-block",
      "cursor": "pointer"
    }
  }, [_vm._v("官网新闻")]), _vm._v(" "), _c('div', {
    staticClass: "formStyle"
  }, [_c('p', {
    staticClass: "formTitle"
  }, [_vm._v("新闻信息填写")]), _vm._v(" "), _c('Form', {
    staticStyle: {
      "padding": "20px"
    },
    attrs: {
      "model": _vm.formItem,
      "label-width": 100
    }
  }, [_c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("图片上传")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Upload', {
    attrs: {
      "multiple": "",
      "type": "drag",
      "action": "/zm/cos/upload",
      "on-success": _vm.uploadSuccess
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px 20px"
    }
  }, [_c('Icon', {
    staticStyle: {
      "color": "#3399ff"
    },
    attrs: {
      "type": "ios-cloud-upload",
      "size": "52"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click or drag images here to upload")])], 1)])], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("上传地址")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('ul', _vm._l((_vm.imgPath), function(value, index) {
    return _c('li', {
      staticStyle: {
        "font-size": "1rem"
      }
    }, [_c('span', {
      staticStyle: {
        "color": "dodgerblue"
      }
    }, [_vm._v(_vm._s(value.name))]), _vm._v(" " + _vm._s(value.path) + "\n              "), _c('Button', {
      attrs: {
        "type": "primary",
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.copyTo(value.path)
        }
      }
    }, [_vm._v("将该地址复制到图片地址中")])], 1)
  }), 0)])], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("封面图预览")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "150px",
      "height": "150px"
    },
    attrs: {
      "src": _vm.formItem.titleImgUrl
    }
  })])], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("封面图地址")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.formItem.titleImgUrl),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "titleImgUrl", $$v)
      },
      expression: "formItem.titleImgUrl"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("主标题")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入主标题..."
    },
    model: {
      value: (_vm.formItem.mainTitle),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "mainTitle", $$v)
      },
      expression: "formItem.mainTitle"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("来源")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入来源..."
    },
    model: {
      value: (_vm.formItem.source),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "source", $$v)
      },
      expression: "formItem.source"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("新闻类别")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formItem.newsCategory),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "newsCategory", $$v)
      },
      expression: "formItem.newsCategory"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("公司新闻")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_vm._v("行业动态")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_vm._v("媒体报导")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("发布时间")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('DatePicker', {
    attrs: {
      "type": "datetime",
      "placeholder": "Select date",
      "format": "yyyy-MM-dd HH:mm"
    },
    model: {
      value: (_vm.formItem.time),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "time", $$v)
      },
      expression: "formItem.time"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("简介")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入简介..."
    },
    model: {
      value: (_vm.formItem.summary),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "summary", $$v)
      },
      expression: "formItem.summary"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("详细内容")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 4,
        maxRows: 8
      },
      "placeholder": "请输入详细内容..."
    },
    model: {
      value: (_vm.formItem.content),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "content", $$v)
      },
      expression: "formItem.content"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.isNew) ? _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitTotal
    }
  }, [_vm._v("添加新闻")]) : _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveChange
    }
  }, [_vm._v("提交修改")])], 1)], 1)], 1)])
},staticRenderFns: []}

/***/ }),

/***/ "ueoP":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: _vm.classes,
    attrs: {
      "type": _vm.htmlType,
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.loading) ? _c('Icon', {
    staticClass: "ivu-load-loop",
    attrs: {
      "type": "load-c"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon && !_vm.loading) ? _c('Icon', {
    attrs: {
      "type": _vm.icon
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSlot) ? _c('span', {
    ref: "slot"
  }, [_vm._t("default")], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ "v1aQ":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("SNSX")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("DpJM"),
  /* template */
  __webpack_require__("YuJl"),
  /* scopeId */
  "data-v-3a4c27ed",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "vsZy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuex = __webpack_require__("NYxO");

//mapState 辅助函数

exports.default = {
  //生成计算属性
  computed: (0, _vuex.mapState)({
    isLogin: "isLogin",
    currentPath: "currentPath",
    openedTags: "openedTags",
    currentTag: "currentTag",
    openedSubmenuArr: "openedSubmenuArr"
  })

};

/***/ }),

/***/ "w4OT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//

exports.default = {
    name: "usersMessage"
};

/***/ }),

/***/ "wkzM":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("jlNB")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("GXsV"),
  /* template */
  __webpack_require__("IE5C"),
  /* scopeId */
  "data-v-e73e17ec",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "wmPH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//

exports.default = {
    name: "weChatMessage"
};

/***/ }),

/***/ "xRgN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
//
//
//
//
//
//

exports.default = {
    name: "volunteerCount"
};

/***/ }),

/***/ "yRx6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: "error404",
  methods: {
    backPage: function backPage() {
      this.$router.go(-1);
    },
    goHome: function goHome() {
      this.$router.push({
        name: "home"
      });
    }
  }
};

/***/ }),

/***/ "ygWc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zCSa":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("LZ1c")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("wmPH"),
  /* template */
  __webpack_require__("6xkd"),
  /* scopeId */
  "data-v-093a12d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "zG6b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zoD6":
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__("hnz0")

var Component = __webpack_require__("VU/8")(
  /* script */
  __webpack_require__("O4Nb"),
  /* template */
  __webpack_require__("caS/"),
  /* scopeId */
  "data-v-4e738511",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ "ztek":
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-container"
  }, [_c('Row', [_c('p', {
    staticStyle: {
      "font-size": "20px",
      "margin-left": "4%",
      "margin-top": "3%",
      "float": "left"
    }
  }, [_vm._v("账号整体情况")])]), _vm._v(" "), _c('ul', [_c('li', [_c('div', {
    staticStyle: {
      "margin-top": "44px"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_c('Icon', {
    staticClass: "pIcon",
    attrs: {
      "type": "chatbox-working"
    }
  }), _vm._v("\n          提问数量\n        ")], 1), _vm._v(" "), _c('p', {
    staticClass: "showData",
    staticStyle: {
      "font-size": "36px",
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.countInfo.questionTotal) + "\n          "), _c('Icon', {
    staticClass: "pIconRight",
    attrs: {
      "type": "android-remove"
    }
  })], 1)]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_c('Icon', {
    staticClass: "pIcon",
    attrs: {
      "type": "chatboxes"
    }
  }), _vm._v("\n          回答总数\n        ")], 1), _vm._v(" "), _c('p', {
    staticClass: "showData",
    staticStyle: {
      "font-size": "36px",
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.countInfo.answerTotal) + "\n          "), _c('Icon', {
    staticClass: "pIconRight",
    attrs: {
      "type": "android-remove"
    }
  })], 1)]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_c('Icon', {
    staticClass: "pIcon",
    attrs: {
      "type": "person"
    }
  }), _vm._v("\n          盲人总数\n        ")], 1), _vm._v(" "), _c('p', {
    staticClass: "showData",
    staticStyle: {
      "font-size": "36px",
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.countInfo.userTotal) + "\n          "), _c('Icon', {
    staticClass: "pIconRight",
    attrs: {
      "type": "android-remove"
    }
  })], 1)]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_c('Icon', {
    staticClass: "pIcon",
    attrs: {
      "type": "android-happy"
    }
  }), _vm._v("\n          志愿者总数\n        ")], 1), _vm._v(" "), _c('p', {
    staticClass: "showData",
    staticStyle: {
      "font-size": "36px",
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.countInfo.volunteerTotal) + "\n          "), _c('Icon', {
    staticClass: "pIconRight",
    attrs: {
      "type": "android-remove"
    }
  })], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_c('Icon', {
    staticClass: "pIcon",
    attrs: {
      "type": "chatbox-working"
    }
  }), _vm._v("\n          新增提问\n        ")], 1), _vm._v(" "), _c('p', {
    staticClass: "showData",
    staticStyle: {
      "font-size": "36px",
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.countInfo.todayQuestion) + "\n          "), (_vm.countInfo.todayQuestion > 0) ? _c('span', [_c('Icon', {
    staticClass: "pIconRightDown",
    attrs: {
      "type": "arrow-up-a"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.countInfo.todayQuestion < 0) ? _c('span', [_c('Icon', {
    staticClass: "pIconRightDown",
    attrs: {
      "type": "arrow-down-a"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.countInfo.todayQuestion === 0) ? _c('span', [_c('Icon', {
    staticClass: "pIconRightDown",
    attrs: {
      "type": "android-remove"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_c('Icon', {
    staticClass: "pIcon",
    attrs: {
      "type": "chatboxes"
    }
  }), _vm._v("\n          新增回答\n        ")], 1), _vm._v(" "), _c('p', {
    staticClass: "showData",
    staticStyle: {
      "font-size": "36px",
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.countInfo.todayAnswer) + "\n          "), (_vm.countInfo.todayAnswer > 0) ? _c('span', [_c('Icon', {
    staticClass: "pIconRightDown",
    attrs: {
      "type": "arrow-up-a"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.countInfo.todayAnswer < 0) ? _c('span', [_c('Icon', {
    staticClass: "pIconRightDown",
    attrs: {
      "type": "arrow-down-a"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.countInfo.todayAnswer === 0) ? _c('span', [_c('Icon', {
    staticClass: "pIconRightDown",
    attrs: {
      "type": "android-remove"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_c('Icon', {
    staticClass: "pIcon",
    attrs: {
      "type": "person"
    }
  }), _vm._v("\n          新增盲人\n        ")], 1), _vm._v(" "), _c('p', {
    staticClass: "showData",
    staticStyle: {
      "font-size": "36px",
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.defaultKey) + "\n          "), (_vm.defaultKey > 0) ? _c('span', [_c('Icon', {
    staticClass: "pIconRightDown",
    attrs: {
      "type": "arrow-up-a"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.defaultKey < 0) ? _c('span', [_c('Icon', {
    staticClass: "pIconRightDown",
    attrs: {
      "type": "arrow-down-a"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.defaultKey === 0) ? _c('span', [_c('Icon', {
    staticClass: "pIconRightDown",
    attrs: {
      "type": "android-remove"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('p', [_c('Icon', {
    staticClass: "pIcon",
    attrs: {
      "type": "android-happy"
    }
  }), _vm._v("\n          新增志愿者\n        ")], 1), _vm._v(" "), _c('p', {
    staticClass: "showData",
    staticStyle: {
      "font-size": "36px",
      "margin-top": "20px"
    }
  }, [_vm._v(_vm._s(_vm.countInfo.todayAddVolunteer) + "\n          "), (_vm.countInfo.todayAddVolunteer > 0) ? _c('span', [_c('Icon', {
    staticClass: "pIconRightDown",
    attrs: {
      "type": "arrow-up-a"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.countInfo.todayAddVolunteer < 0) ? _c('span', [_c('Icon', {
    staticClass: "pIconRightDown",
    attrs: {
      "type": "arrow-down-a"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.countInfo.todayAddVolunteer === 0) ? _c('span', [_c('Icon', {
    staticClass: "pIconRightDown",
    attrs: {
      "type": "android-remove"
    }
  })], 1) : _vm._e()])])], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.7f0e7c454b.js